import React, { useState, useEffect, useMemo, useRef } from 'react';
import * as XLSX from 'xlsx';
import { createPortal } from 'react-dom';
import { useParams, useNavigate } from 'react-router-dom';
import { db, functions, auth, storage } from '../../firebase'; // MÓDOSÍTVA
import { doc, getDoc, collection, onSnapshot, updateDoc, writeBatch, increment, serverTimestamp, getDocs, where, query } from 'firebase/firestore';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { httpsCallable } from 'firebase/functions'; // ÚJ
import { getCompetitionOffline, saveCompetitionOffline, saveScoreOffline, getPendingScores, clearPendingScore, addParticipantOffline, updateParticipantOffline, deleteParticipantOffline, saveCompetitionUpdateOffline, getPendingCompetitionUpdates, clearPendingCompetitionUpdate } from '../../utils/offlineDB';
import {
  DndContext,
  closestCenter,
  pointerWithin,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragOverlay,
  defaultDropAnimationSideEffects,
  useDroppable
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  useSortable
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { QRCodeSVG } from 'qrcode.react';
import logo from '../../logo_colored_transp_no_text.png';
import {
  FiArrowLeft, FiUsers, FiGrid, FiCamera, FiBarChart2, FiInfo, FiSettings,
  FiSearch, FiDownload, FiTrash2, FiAlertTriangle, FiPrinter, FiX, FiLink,
  FiPlus, FiMessageSquare, FiCheck, FiAlertCircle, FiArrowUp, FiArrowDown,
  FiGlobe, FiEdit3, FiMap, FiFileText, FiEdit2, FiChevronRight, FiChevronLeft,
  FiChevronUp, FiChevronDown, FiUpload, FiImage
} from 'react-icons/fi';
import CourseMapEditor from './CourseMapEditor';
import { MdQrCode, MdAndroid, MdLinkOff } from 'react-icons/md';
import { AiFillAndroid, AiFillApple } from 'react-icons/ai';
import { FaFacebook } from 'react-icons/fa';
import { Map, AdvancedMarker, useMap } from '@vis.gl/react-google-maps';
import { ARCHERY_CLUBS } from '../../constants/ArcheryClubs';

// --- GLOBÁLIS KONSTANSOK A RENDEZÉSHEZ ---
const AGE_ORDER = {
  'mini': 1, 'gyerek': 2, 'junior': 3, 'kadet': 4, 'ifi': 5,
  'fiatal_felnott': 6, 'felnott': 7, 'szenior': 8, 'veteran': 9
};

// EGYSÉGES KATEGÓRIA KULCS GENERÁLÓ (Rangsorhoz és Lezáráshoz)
const getCategoryKey = (p) => {
  return `${p.bowCategory}|${p.ageCategory}|${p.gender}`;
};

// --- SPECIÁLIS TÉRKÉP NYOMTATÓ ELEMEK (PORTÁLHOZ) ---
function PrintMapElements({ courseData }) {
  const map = useMap();

  useEffect(() => {
    if (!map || !window.google || !courseData) return;

    const bounds = new window.google.maps.LatLngBounds();
    let hasElements = false;

    // Utak rajzolása
    courseData.paths?.forEach(pathData => {
      new window.google.maps.Polyline({
        path: pathData.points,
        geodesic: true,
        strokeColor: pathData.color,
        strokeOpacity: 0.8,
        strokeWeight: 4,
        map: map
      });
      pathData.points.forEach(pt => {
          bounds.extend(pt);
          hasElements = true;
      });
    });

    // Célok és Bounds
    courseData.targets?.forEach(t => {
      if (t.lat && t.lng) {
        bounds.extend({ lat: t.lat, lng: t.lng });
        hasElements = true;
      }
    });

    if (courseData.specialMarkers?.office?.lat) {
        bounds.extend(courseData.specialMarkers.office);
        hasElements = true;
    }
    if (courseData.specialMarkers?.warmup?.lat) {
        bounds.extend(courseData.specialMarkers.warmup);
        hasElements = true;
    }

    if (courseData.mapCenter && courseData.mapZoom) {
      map.setCenter(courseData.mapCenter);
      map.setZoom(courseData.mapZoom);
    } else if (hasElements) {
      map.fitBounds(bounds, { top: 10, right: 10, bottom: 10, left: 10 });
      const listener = window.google.maps.event.addListenerOnce(map, 'idle', () => {
        if (map.getZoom() < 17) {
          map.setZoom(17);
        }
      });
    }
  }, [map, courseData]);

  return (
    <>
       {courseData.targets?.map(t => t.lat && (
         <AdvancedMarker key={t.id} position={{ lat: t.lat, lng: t.lng }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', transform: 'translateY(-50%)' }}>
               <div style={{ backgroundColor: '#fff', padding: '1px 6px', borderRadius: '10px', fontSize: '0.7rem', fontWeight: '900', color: '#b30000', border: '1.5px solid #b30000', marginBottom: '1px' }}>{t.id}</div>
               <div style={{ width: '10px', height: '10px', backgroundColor: '#D32F2F', borderRadius: '50% 50% 50% 0', transform: 'rotate(-45deg)', border: '1.5px solid white' }} />
            </div>
         </AdvancedMarker>
       ))}
       {courseData.specialMarkers?.office?.lat && (
         <AdvancedMarker position={courseData.specialMarkers.office}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', transform: 'translateY(-50%)' }}>
               <div style={{ backgroundColor: '#fff', padding: '1px 6px', borderRadius: '10px', fontSize: '0.7rem', fontWeight: '900', color: '#007bff', border: '1.5px solid #007bff', marginBottom: '1px' }}>IRODA</div>
               <div style={{ width: '10px', height: '10px', backgroundColor: '#007bff', borderRadius: '50% 50% 50% 0', transform: 'rotate(-45deg)', border: '1.5px solid white' }} />
            </div>
         </AdvancedMarker>
       )}
       {courseData.specialMarkers?.warmup?.lat && (
         <AdvancedMarker position={courseData.specialMarkers.warmup}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', transform: 'translateY(-50%)' }}>
               <div style={{ backgroundColor: '#fff', padding: '1px 6px', borderRadius: '10px', fontSize: '0.7rem', fontWeight: '900', color: '#333', border: '1.5px solid #333', marginBottom: '1px' }}>BELÖVŐ</div>
               <div style={{ width: '10px', height: '10px', backgroundColor: '#333', borderRadius: '50% 50% 50% 0', transform: 'rotate(-45deg)', border: '1.5px solid white' }} />
            </div>
         </AdvancedMarker>
       )}
    </>
  );
}

function PrintMapPortal({ isOpen, onClose, competition, distance, courseData, isSnapshotMode = false, onScreenshotReady }) {
  const [isCapturing, setIsCapturing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      if (isSnapshotMode) {
        // Screenshot mód: várunk a betöltésre
        const timer = setTimeout(async () => {
          try {
            setIsCapturing(true);
            await new Promise(r => setTimeout(r, 200));

            const canvas = await window.html2canvas(document.querySelector("#archery-nexus-map-print-portal"), {
              useCORS: true,
              allowTaint: true,
              scale: 2
            });
            const base64Image = canvas.toDataURL('image/jpeg', 0.85);

            setIsCapturing(false);
            if (onScreenshotReady) onScreenshotReady(base64Image);
          } catch (e) {
            console.error("Screenshot hiba:", e);
            setIsCapturing(false);
            onClose();
          }
        }, 4000);
        return () => clearTimeout(timer);
      } else {
        // Normál nyomtatás
        const timer = setTimeout(() => {
          window.print();
          onClose();
        }, 2500);
        return () => clearTimeout(timer);
      }
    }
  }, [isOpen, onClose, isSnapshotMode, onScreenshotReady]);

  if (!isOpen || !courseData) return null;

  return createPortal(
    <div id="archery-nexus-map-print-portal">
       {/* ÚJ: TÖLTŐ OVERLAY - KÜLÖN ÁLLAPOTTAL VEZÉRELVE */}
       {isSnapshotMode && !isCapturing && (
         <div style={{
           position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
           backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 20000,
           display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
           color: 'white', textAlign: 'center', borderRadius: '5px', backdropFilter: 'blur(4px)'
         }}>
            <div className="nexus-spinner" style={{
              width: '60px', height: '60px', border: '6px solid rgba(255,255,255,0.2)',
              borderTopColor: '#b30000', borderRadius: '50%',
              animation: 'spin 1s linear infinite', marginBottom: '25px'
            }} />
            <h2 style={{ margin: '0 0 10px 0', color: 'white', fontSize: '1.8rem', fontWeight: '900' }}>Pályatérkép publikálása...</h2>
            <p style={{ margin: 0, fontSize: '1.1rem', opacity: 0.9 }}>Várj egy pillanatot, dolgozom a feltöltésen!</p>
            <p style={{ marginTop: '15px', fontSize: '0.85rem', color: '#ffaaaa', fontWeight: 'bold' }}>Kérjük, ne zárd be ezt az ablakot.</p>
         </div>
       )}

       <div className="print-portal-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <img src={logo} alt="Logo" style={{ height: '60px' }} />
            <div style={{ textAlign: 'left' }}>
              <h1 style={{ margin: 0, color: '#b30000', fontSize: '2.2rem', fontWeight: '900' }}>ArcheryNexus Pályatérkép</h1>
              <h2 style={{ margin: 0, fontSize: '1.2rem', color: '#333' }}>{competition?.competitionName}</h2>
            </div>
          </div>
          {!isSnapshotMode && !isCapturing && (
            <button className="no-print close-portal-btn" onClick={onClose}><FiX size={24} /></button>
          )}
       </div>

       <div className="print-portal-map-area">
          <Map
            defaultCenter={{ lat: parseFloat(competition?.gpsLatitude) || 47, lng: parseFloat(competition?.gpsLongitude) || 19 }}
            defaultZoom={17}
            mapId="PRINT_MAP_INSTANCE"
            mapTypeId="satellite"
            style={{ width: '100%', height: '100%' }}
            gestureHandling={'none'}
            disableDefaultUI={true}
          >
             <PrintMapElements courseData={courseData} />
          </Map>
       </div>

       <div className="print-portal-footer">
          <div className="info-box">
             <div className="info-item">
                <span className="label">ÖSSZESÍTETT TÁVOLSÁG:</span>
                <span className="value">{distance} méter</span>
             </div>
             <div className="info-item">
                <span className="label">CÉLOK SZÁMA:</span>
                <span className="value">{courseData.targets?.filter(t => t.lat).length || 0} db</span>
             </div>
          </div>
          <div className="footer-copyright">
             Nyomtatva: {new Date().toLocaleDateString('hu-HU')} | www.archerynexus.com
          </div>
       </div>

       <style>{`
          #archery-nexus-map-print-portal {
            position: fixed; top: 0; left: 0; right: 0; bottom: 0;
            background: white; z-index: 10006; display: flex; flex-direction: column;
            padding: 3mm; box-sizing: border-box;
          }
          .print-portal-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 3mm; border-bottom: 3px solid #b30000; padding-bottom: 2mm; }
          .print-portal-map-area { flex: 1; border: 2px solid #000; border-radius: 5px; overflow: hidden; position: relative; width: 100%; }
          .print-portal-footer { margin-top: 3mm; }
          .info-box { display: flex; justify-content: space-around; background: #f8f9fa; padding: 3mm; border-radius: 10px; border: 1px solid #eee; }
          .info-item { display: flex; flex-direction: column; align-items: center; }
          .info-item .label { font-size: 0.7rem; color: #666; font-weight: bold; }
          .info-item .value { font-size: 1.3rem; color: #b30000; font-weight: 900; }
          .footer-copyright { text-align: center; margin-top: 2mm; font-size: 0.6rem; color: #999; }
          .close-portal-btn { background: none; border: none; cursor: pointer; color: #666; }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          @media print {
            @page { size: A4 landscape; margin: 0; }
            body > *:not(#archery-nexus-map-print-portal) { display: none !important; }
            #root { display: none !important; }
            #archery-nexus-map-print-portal {
                position: absolute !important;
                top: 0 !important; left: 0 !important;
                width: 297mm !important;
                height: 210mm !important;
                padding: 3mm !important;
                margin: 0 !important;
            }
            .no-print { display: none !important; }
            .print-portal-map-area {
                height: 175mm !important;
                width: 100% !important;
                border: 1px solid #000 !important;
            }
            * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
          }
       `}</style>
    </div>,
    document.body
  );
}

function PrintCustomMapPortal({ isOpen, onClose, competition, customMapImageUrl }) {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        window.print();
        onClose();
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  if (!isOpen || !customMapImageUrl) return null;

  return createPortal(
    <div id="archery-nexus-custom-map-print-portal">
       <div className="print-portal-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <img src={logo} alt="Logo" style={{ height: '60px' }} />
            <div style={{ textAlign: 'left' }}>
              <h1 style={{ margin: 0, color: '#b30000', fontSize: '2.2rem', fontWeight: '900' }}>ArcheryNexus Pályatérkép</h1>
              <h2 style={{ margin: 0, fontSize: '1.2rem', color: '#333' }}>{competition?.competitionName}</h2>
            </div>
          </div>
          <button className="no-print close-portal-btn" onClick={onClose}><FiX size={24} /></button>
       </div>

       <div className="print-portal-map-area" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff' }}>
          <img
            src={customMapImageUrl}
            alt="Saját Pályatérkép"
            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
          />
       </div>

       <div className="print-portal-footer">
          <div className="footer-copyright">
             Nyomtatva: {new Date().toLocaleDateString('hu-HU')} | www.archerynexus.com
          </div>
       </div>

       <style>{`
          #archery-nexus-custom-map-print-portal {
            position: fixed; top: 0; left: 0; right: 0; bottom: 0;
            background: white; z-index: 10006; display: flex; flex-direction: column;
            padding: 3mm; box-sizing: border-box;
          }
          .print-portal-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 3mm; border-bottom: 3px solid #b30000; padding-bottom: 2mm; }
          .print-portal-map-area { flex: 1; border: 2px solid #000; border-radius: 5px; overflow: hidden; position: relative; width: 100%; display: flex; align-items: center; justify-content: center; }
          .print-portal-footer { margin-top: 3mm; }
          .footer-copyright { text-align: center; margin-top: 2mm; font-size: 0.7rem; color: #666; font-weight: bold; }
          .close-portal-btn { background: none; border: none; cursor: pointer; color: #666; }

          @media print {
            @page { size: A4 landscape; margin: 0; }
            body > *:not(#archery-nexus-custom-map-print-portal) { display: none !important; }
            #root { display: none !important; }
            #archery-nexus-custom-map-print-portal {
                position: absolute !important;
                top: 0 !important; left: 0 !important;
                width: 297mm !important;
                height: 210mm !important;
                padding: 3mm !important;
                margin: 0 !important;
            }
            .no-print { display: none !important; }
            .print-portal-map-area {
                height: 180mm !important;
                width: 100% !important;
                border: 1px solid #000 !important;
            }
            * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
          }
       `}</style>
    </div>,
    document.body
  );
}

// Fordítási táblázat a kódokhoz
const translationMap = {
  // Korosztályok
  'mini': 'Mini',
  'gyerek': 'Gyerek',
  'junior': 'Junior',
  'kadet': 'Kadét',
  'ifi': 'Ifi',
  'fiatal_felnott': 'Fiatal felnőtt',
  'felnott': 'Felnőtt',
  'szenior': 'Szenior',
  'veteran': 'Veterán',

  // 3D kategóriák
  '3d_hdh_bb': 'BB (Barebow)',
  '3d_hdh_bg': 'BG (Fúvócső)',
  '3d_hdh_cb': 'CB (Csigás Barebow)',
  '3d_hdh_crb': 'CRB (Számszeríj)',
  '3d_hdh_cu': 'CU (Scope-os Csigás)',
  '3d_hdh_hu': 'HU (Vadász Csigás)',
  '3d_hdh_ol': 'OL (Olimpiai)',
  '3d_hdh_pbhb': 'PBHB (Pusztai íj (Tradi))',
  '3d_hdh_trlb': 'TRLB (Longbow)',
  '3d_hdh_trrb': 'TRRB (Vadászreflex)',
  '3d_ifaa_bbc': 'BB(C) (Barebow-Csigás)',
  '3d_ifaa_bbr': 'BB(R) (Barebow-Reflex)',
  '3d_ifaa_bhc': 'BH(C) (Vadászijász-Csigás)',
  '3d_ifaa_bhr': 'BH(R) (Vadászijász-Reflex)',
  '3d_ifaa_bl': 'BL (Korlátozott Vadászijász)',
  '3d_ifaa_bu': 'BU (Bowhunter Unlimited)',
  '3d_ifaa_fsc': 'FS(C) (Korl. nyílt o.-Csigás)',
  '3d_ifaa_fsr': 'FS(R) (Korl. nyílt o.-Reflex)',
  '3d_ifaa_fu': 'FU (Korlátlan nyílt osztály)',
  '3d_ifaa_hb': 'HB (Történelmi íj)',
  '3d_ifaa_hbm': 'HB(M) (Történelmi íj modern)',
  '3d_ifaa_lb': 'LB (Longbow)',
  '3d_ifaa_tr': 'TR (Tradicionális reflex)',

  // Terep kategóriák
  'terep_olimpiai': 'OL (Olimpiai)',
  'terep_csigas': 'CU (Scope-os Csigás)',
  'terep_barebow': 'BB (Barebow)',
  'terep_cb': 'CB (Csigás Barebow)',
  'terep_hu': 'HU (Vadász Csigás)',
  'terep_pbhb': 'PBHB (Pusztai íj (Tradi))',
  'terep_trlb': 'TRLB (Longbow)',
  'terep_trrb': 'TRRB (Vadászreflex)',

  // Pálya kategóriák
  'palya_wa_ol': 'R (Olimpiai reflexíj)',
  'palya_wa_cu': 'CU (Scope-os Csigás)',
  'palya_wa_hu': 'HU (Vadász Csigás)',
  'palya_wa_bb': 'B (Barebow)',
  'palya_wa_trrb': 'TRRB (Vadászreflex)',
  'palya_wa_trlb': 'TRLB (Longbow)',
  'palya_wa_pbhb': 'PBHB (Pusztai íj (Tradi))',
  'palya_wa_crb': 'CRB (Számszeríj)',
  'palya_ifaa_fu': 'FU (Freestyle Unlimited)',
  'palya_ifaa_fsr': 'FSR (FSR (Freestyle Ltd Recurve))',
  'palya_ifaa_fsc': 'FSC (FSC (Freestyle Ltd Compound))',
  'palya_ifaa_bbr': 'BBR (Barebow-Reflex)',
  'palya_ifaa_bbc': 'BBC (Barebow-Csigás)',
  'palya_ifaa_bu': 'BU (Bowhunter Unlimited)',
  'palya_ifaa_bl': 'BL (Bowhunter Limited)',
  'palya_ifaa_bhc': 'BHC (Vadászijász-Csigás)',
  'palya_ifaa_bhr': 'BHR (Vadászijász-Reflex)',
  'palya_ifaa_lb': 'LB (Longbow)',
  'palya_ifaa_hb': 'HB (Historical Bow)',
  'palya_ifaa_tr': 'TR (Traditional Bow)',

  // Történelmi kategóriák
  'tortenelmi_pusztai_modern': 'Modern pusztai íj',
  'tortenelmi_pusztai_termeszetes': 'Természetes pusztai íj',
  'tortenelmi_botij': 'Történelmi hosszúíj / Botíj',
  'tortenelmi_vadaszij': 'Vadászreflex (karbon és fa együtt)',
  'tortenelmi_vadaszij_fa': 'Vadászíj fa vesszővel',
  'tortenelmi_vadaszij_karbon': 'Vadászíj karbonvesszővel',
  'tortenelmi_ij': 'Történelmi íj',
  'tortenelmi_szamszerij': 'Történelmi számszeríj',
  'tortenelmi_bb': 'BB (Barebow)',

  // Örömijász kategóriák
  'orom_wa_ol': 'OL (Olimpiai reflexíj)',
  'orom_wa_cu': 'CU (Scope-os Csigás)',
  'orom_wa_hu': 'HU (Vadász Csigás)',
  'orom_wa_cb': 'CB (Csigás Barebow)',
  'orom_wa_bb': 'BB (Barebow)',
  'orom_wa_trrb': 'TRRB (Vadászreflex)',
  'orom_wa_trlb': 'TRLB (Longbow)',
  'orom_wa_pbhb': 'PBHB (Pusztai íj)',
  'orom_vadaszij': 'Vadászreflex (karbon és fa együtt)',
  'orom_vadaszij_fa': 'Vadászíj fa vesszővel',
  'orom_vadaszij_karbon': 'Vadászíj karbonvesszővel',
  'orom_tortenelmi_ij': 'Történelmi íj',
  'orom_wa_crb': 'CRB (Számszeríj)',
  'orom_wa_bg': 'BG (Fúvócső)',

  // Egyéb
  'egyeb_wa_ol': 'OL (Olimpiai reflexíj)',
  'egyeb_wa_cu': 'CU (Scope-os Csigás)',
  'egyeb_wa_hu': 'HU (Vadász Csigás)',
  'egyeb_wa_cb': 'CB (Csigás Barebow)',
  'egyeb_wa_bb': 'BB (Barebow)',
  'egyeb_wa_trrb': 'TRRB (Vadászreflex)',
  'egyeb_wa_trlb': 'TRLB (Longbow)',
  'egyeb_wa_pbhb': 'PBHB (Pusztai íj)',
  'egyeb_wa_crb': 'CRB (Számszeríj)',
  'egyeb_wa_bg': 'BG (Fúvócső)',
  'egyeb_altalanos': 'Egyéb Általános'
};

const getShortBowCategoryLabel = (rawCategory) => {
  if (!rawCategory) return "-";

  const customShortMap = {
    'tortenelmi_ij': 'Tört.íj',
    'orom_tortenelmi_ij': 'Tört.íj',
    'tortenelmi_vadaszij_fa': 'Vadászíj (fa)',
    'orom_vadaszij_fa': 'Vadászíj (fa)',
    'tortenelmi_vadaszij_karbon': 'Vadászíj (karb)',
    'orom_vadaszij_karbon': 'Vadászíj (karb)',
    'tortenelmi_vadaszij': 'Vadászreflex',
    'orom_vadaszij': 'Vadászreflex',
    'tortenelmi_botij': 'Tört. hosszúíj',
    'tortenelmi_pusztai_modern': 'Pusztai (M)',
    'tortenelmi_pusztai_termeszetes': 'Pusztai (T)'
  };

  if (customShortMap[rawCategory]) {
    return customShortMap[rawCategory];
  }

  const fullLabel = translationMap[rawCategory] || rawCategory;
  if (fullLabel.includes('(')) {
    return fullLabel.split('(')[0].trim();
  }

  return fullLabel;
};

const isSightedCategory = (bowCat) => {
  if (!bowCat) return false;
  const lower = bowCat.toLowerCase();
  if (
    lower.includes('olimpiai') ||
    lower.includes('_ol') ||
    lower.includes('cu') ||
    lower.includes('hu') ||
    lower.includes('crb') ||
    lower.includes('fu') ||
    lower.includes('fs') ||
    lower.includes('bhc') ||
    lower.includes('bu') ||
    lower.includes('bl') ||
    lower.includes('csigas')
  ) {
    if (lower.includes('cb') || lower.includes('barebow')) {
      return false;
    }
    return true;
  }
  return false;
};

const getColorForZoneValue = (val) => {
  const v = val?.toString().toUpperCase();
  if (v === '11' || v === 'X') return '#4CAF50'; // Zöld
  if (v === '10' || v === '9') return '#FFD700'; // Arany
  if (v === '8' || v === '7') return '#F44336';  // Piros
  if (v === '6' || v === '5') return '#1976D2';  // Kék
  return '#9E9E9E'; // Szürke (0 vagy M)
};

const ageCategories = [
  { id: 'mini', label: 'Mini' },
  { id: 'gyerek', label: 'Gyerek' },
  { id: 'junior', label: 'Junior' },
  { id: 'kadet', label: 'Kadét' },
  { id: 'ifi', label: 'Ifi' },
  { id: 'fiatal_felnott', label: 'Fiatal felnőtt' },
  { id: 'felnott', label: 'Felnőtt' },
  { id: 'szenior', label: 'Szenior' },
  { id: 'veteran', label: 'Veterán' }
];

const bowCategoriesByType = {
  '3d_hdh': [
    { id: '3d_hdh_bb', label: 'BB (Barebow)' },
    { id: '3d_hdh_bg', label: 'BG (Fúvócső)' },
    { id: '3d_hdh_cb', label: 'CB (Csigás Barebow)' },
    { id: '3d_hdh_crb', label: 'CRB (Számszeríj)' },
    { id: '3d_hdh_cu', label: 'CU (Scope-os Csigás)' },
    { id: '3d_hdh_hu', label: 'HU (Vadász Csigás)' },
    { id: '3d_hdh_ol', label: 'OL (Olimpiai)' },
    { id: '3d_hdh_pbhb', label: 'PBHB (Tradi)' },
    { id: '3d_hdh_trlb', label: 'TRLB (Longbow)' },
    { id: '3d_hdh_trrb', label: 'TRRB (Vadászreflex)' }
  ],
  '3d_ifaa': [
    { id: '3d_ifaa_bbc', label: 'BB(C) (Barebow-Csigás)' },
    { id: '3d_ifaa_bbr', label: 'BB(R) (Barebow-Reflex)' },
    { id: '3d_ifaa_bhc', label: 'BH(C) (Vadászijász-Csigás)' },
    { id: '3d_ifaa_bhr', label: 'BH(R) (Vadászijász-Reflex)' },
    { id: '3d_ifaa_bl', label: 'BL (Korlátozott Vadászijász)' },
    { id: '3d_ifaa_bu', label: 'BU (Bowhunter Unlimited)' },
    { id: '3d_ifaa_fsc', label: 'FS(C) (Korl. nyílt o.-Csigás)' },
    { id: '3d_ifaa_fsr', label: 'FS(R) (Korl. nyílt o.-Reflex)' },
    { id: '3d_ifaa_fu', label: 'FU (Korlátlan nyílt osztály)' },
    { id: '3d_ifaa_hb', label: 'HB (Történelmi íj)' },
    { id: '3d_ifaa_hbm', label: 'HB(M) (Történelmi íj modern)' },
    { id: '3d_ifaa_lb', label: 'LB (Longbow)' },
    { id: '3d_ifaa_tr', label: 'TR (Tradicionális reflex)' }
  ],
  'terep': [
    { id: 'terep_olimpiai', label: 'OL (Olimpiai)' },
    { id: 'terep_csigas', label: 'CU (Scope-os Csigás)' },
    { id: 'terep_barebow', label: 'BB (Barebow)' },
    { id: 'terep_cb', label: 'CB (Csigás Barebow)' },
    { id: 'terep_hu', label: 'HU (Vadász Csigás)' },
    { id: 'terep_pbhb', label: 'PBHB (Tradi - Pusztai íj)' },
    { id: 'terep_trlb', label: 'TRLB (Longbow)' },
    { id: 'terep_trrb', label: 'TRRB (Vadászreflex)' }
  ],
  'palya_wa': [
    { id: 'palya_wa_ol', label: 'R (Olimpiai reflexíj)' },
    { id: 'palya_wa_cu', label: 'CU (Scope-os Csigás)' },
    { id: 'palya_wa_hu', label: 'HU (Vadász Csigás)' },
    { id: 'palya_wa_bb', label: 'B (Barebow)' },
    { id: 'palya_wa_trrb', label: 'TRRB (Vadászreflex)' },
    { id: 'palya_wa_trlb', label: 'TRLB (Longbow)' },
    { id: 'palya_wa_pbhb', label: 'PBHB (Tradi - Pusztai íj)' },
    { id: 'palya_wa_crb', label: 'CRB (Számszeríj)' }
  ],
  'palya_ifaa': [
    { id: 'palya_ifaa_fu', label: 'FU (Freestyle Unlimited)' },
    { id: 'palya_ifaa_fsr', label: 'FSR (Freestyle Ltd Recurve)' },
    { id: 'palya_ifaa_fsc', label: 'FSC (Freestyle Ltd Compound)' },
    { id: 'palya_ifaa_bbr', label: 'BBR (Barebow Recurve)' },
    { id: 'palya_ifaa_bbc', label: 'BBC (Barebow Compound)' },
    { id: 'palya_ifaa_bu', label: 'BU (Bowhunter Unlimited)' },
    { id: 'palya_ifaa_bl', label: 'BL (Bowhunter Limited)' },
    { id: 'palya_ifaa_bhc', label: 'BHC (Bowhunter Compound)' },
    { id: 'palya_ifaa_bhr', label: 'BHR (Bowhunter Recurve)' },
    { id: 'palya_ifaa_lb', label: 'LB (Longbow)' },
    { id: 'palya_ifaa_hb', label: 'HB (Historical Bow)' },
    { id: 'palya_ifaa_tr', label: 'TR (Traditional Bow)' }
  ],
  'tortenelmi': [
    { id: 'tortenelmi_pusztai_modern', label: 'Modern pusztai íj' },
    { id: 'tortenelmi_pusztai_termeszetes', label: 'Természetes pusztai íj' },
    { id: 'tortenelmi_botij', label: 'Történelmi hosszúíj / Botíj' },
    { id: 'tortenelmi_vadaszij', label: 'Hagyományos vadászíj' },
    { id: 'tortenelmi_vadaszij_fa', label: 'Vadászíj fa vesszővel' },
    { id: 'tortenelmi_vadaszij_karbon', label: 'Vadászíj karbonvesszővel' },
    { id: 'tortenelmi_ij', label: 'Történelmi íj' },
    { id: 'tortenelmi_szamszerij', label: 'Történelmi számszeríj' },
    { id: 'tortenelmi_bb',label: 'BB (Barebow)' }
  ],
  'oromijasz': [
    { id: 'orom_wa_ol', label: 'OL (Olimpiai reflexíj)' },
    { id: 'orom_wa_cu', label: 'CU (Scope-os Csigás)' },
    { id: 'orom_wa_hu', label: 'HU (Vadász Csigás)' },
    { id: 'orom_wa_cb', label: 'CB (Csigás Barebow)' },
    { id: 'orom_wa_bb', label: 'BB (Barebow)' },
    { id: 'orom_wa_trrb', label: 'TRRB (Vadászreflex)' },
    { id: 'orom_wa_trlb', label: 'TRLB (Longbow)' },
    { id: 'orom_wa_pbhb', label: 'PBHB (Pusztai íj)' },
    { id: 'orom_vadaszij_fa', label: 'Vadászíj fa vesszővel' },
    { id: 'orom_vadaszij_karbon', label: 'Vadászíj karbonvesszővel' },
    { id: 'orom_tortenelmi_ij', label: 'Történelmi íj' },
    { id: 'orom_wa_crb', label: 'CRB (Számszeríj)' },
    { id: 'orom_wa_bg',label: 'BG (Fúvócső)' }
  ],
  'egyeb': [
    { id: 'egyeb_wa_ol', label: 'OL (Olimpiai reflexíj)' },
    { id: 'egyeb_wa_cu', label: 'CU (Scope-os Csigás)' },
    { id: 'egyeb_wa_hu', label: 'HU (Vadász Csigás)' },
    { id: 'egyeb_wa_cb', label: 'CB (Csigás Barebow)' },
    { id: 'egyeb_wa_bb', label: 'BB (Barebow)' },
    { id: 'egyeb_wa_trrb', label: 'TRRB (Vadászreflex)' },
    { id: 'egyeb_wa_trlb', label: 'TRLB (Longbow)' },
    { id: 'egyeb_wa_pbhb', label: 'PBHB (Pusztai íj)' },
    { id: 'egyeb_wa_crb', label: 'CRB (Számszeríj)' },
    { id: 'egyeb_wa_bg',label: 'BG (Fúvócső)' },
    { id: 'egyeb_altalanos',label: 'Egyéb Általános' }
  ]
};

// --- SEGÉDFÜGGVÉNY: Fix szín generálása linkId alapján (Nagy kontrasztú paletta) ---
const getLinkColor = (linkId) => {
  if (!linkId) return 'transparent';
  const contrastColors = [
    '#E6194B', '#3CB44B', '#4363D8', '#F58231', '#911EB4',
    '#42D4F4', '#F032E6', '#228B22', '#B30000', '#008080',
    '#9A6324', '#800000', '#000075', '#333333', '#F0A000'
  ];
  let hash = 0;
  for (let i = 0; i < linkId.length; i++) {
    hash = linkId.charCodeAt(i) + ((hash << 5) - hash);
  }
  return contrastColors[Math.abs(hash) % contrastColors.length];
};

// --- SEGÉDFÜGGVÉNY: Csoportosítás linkId alapján a vizuális kerethez ---
const groupParticipantsByLink = (list) => {
  const groups = [];
  const processedLinkIds = new Set();

  list.forEach(p => {
    if (p.linkId) {
      if (!processedLinkIds.has(p.linkId)) {
        // Megkeressük az összes tagot, aki ehhez a lánchoz tartozik a listában
        const members = list.filter(m => m.linkId === p.linkId);
        groups.push({ type: 'linked', linkId: p.linkId, members: members });
        processedLinkIds.add(p.linkId);
      }
    } else {
      groups.push({ type: 'single', participant: p });
    }
  });
  return groups;
};

const LinkedGroupWrapper = ({ linkId, children, onUnlinkClick, isCollapsed, onToggleCollapse }) => {
  const color = getLinkColor(linkId);
  return (
    <div style={{
      border: `3px solid ${color}`,
      borderRadius: '12px',
      padding: '5px',
      marginBottom: '10px',
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
      boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
      position: 'relative'
    }}>
      {/* Collapse / Expand button (Red) */}
      {onToggleCollapse && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggleCollapse(linkId);
          }}
          style={{
            position: 'absolute',
            top: '8px',
            right: onUnlinkClick ? '40px' : '8px',
            backgroundColor: '#b30000',
            color: '#ffffff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '4px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
            zIndex: 20
          }}
          title={isCollapsed ? "Csoport kibontása" : "Csoport összecsukása"}
        >
          {isCollapsed ? <FiChevronDown size={18} /> : <FiChevronUp size={18} />}
        </button>
      )}

      {/* Unlink button (Black) */}
      {onUnlinkClick && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onUnlinkClick(linkId);
          }}
          style={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            backgroundColor: '#333333',
            color: '#ffffff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '4px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
            zIndex: 20
          }}
          title="Láncolás felbontása"
        >
          <MdLinkOff size={18} />
        </button>
      )}

      {isCollapsed ? (
        <div>
          {React.Children.toArray(children)[0]}
        </div>
      ) : (
        children
      )}
    </div>
  );
};

// --- KOROSZTÁLY SZÍNEK ---
const getAgeCategoryStyle = (ageCategory) => {
  const colors = {
    'mini': { backgroundColor: '#B2EBF2', color: '#006064', borderColor: '#00838F' },
    'gyerek': { backgroundColor: '#C8E6C9', color: '#1B5E20', borderColor: '#2E7D32' },
    'junior': { backgroundColor: '#FFF59D', color: '#F57F17', borderColor: '#FBC02D' },
    'kadet': { backgroundColor: '#FFE082', color: '#E65100', borderColor: '#F57C00' },
    'ifi': { backgroundColor: '#F8BBD0', color: '#880E4F', borderColor: '#C2185B' },
    'fiatal_felnott': { backgroundColor: '#D1C4E9', color: '#4A148C', borderColor: '#7E57C2' },
    'felnott': { backgroundColor: '#BBDEFB', color: '#0D47A1', borderColor: '#1976D2' },
    'szenior': { backgroundColor: '#FFAB91', color: '#BF360C', borderColor: '#D84315' },
    'veteran': { backgroundColor: '#B0BEC5', color: '#263238', borderColor: '#546E7A' }
  };
  return colors[ageCategory] || { backgroundColor: '#e2e8f0', color: '#334155', borderColor: '#cbd5e1' };
};

const baseBadgeStyle = {
  padding: '2px 8px',
  borderRadius: '6px',
  fontSize: '0.7rem',
  fontWeight: 'bold',
  borderWidth: '1px',
  borderStyle: 'solid'
};

const neutralBadgeStyle = {
  ...baseBadgeStyle,
  backgroundColor: '#e9ecef',
  color: '#495057',
  borderColor: '#ced4da'
};

// --- SORTABLE ITEM KOMPONENS ---
const SortableParticipant = ({ id, participant, isOverlay = false, isLinkBase = false, onLinkClick, isInGroup = false }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: id });

  // Megállapítjuk az effektív színt (vagy a meglévőt, vagy amit a host kapna)
  const effectiveLinkId = participant.linkId || (isLinkBase ? `group_${participant.id}` : null);
  const linkColor = getLinkColor(effectiveLinkId);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    padding: '10px',
    backgroundColor: isLinkBase ? 'transparent' : '#f0f2f5', // Picivel sötétebb szürke
    border: participant.linkId
      ? (isInGroup ? '1px solid #ddd' : `3px solid ${linkColor}`)
      : '1px solid #e0e0e0',
    borderRadius: '8px',
    marginBottom: isInGroup ? '4px' : '8px',
    cursor: 'grab',
    boxShadow: isOverlay ? '0 5px 15px rgba(0,0,0,0.15)' : 'none',
    zIndex: isOverlay ? 1000 : 1,
    fontSize: '0.85rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    position: 'relative',
    '--pulse-color': linkColor,
    animation: isLinkBase ? 'brutal-pulse 0.6s infinite linear' : 'none'
  };

  const catShort = (() => {
    const cat = participant.bowCategory || '';
    if (cat === 'tortenelmi_vadaszij' || cat === 'orom_vadaszij') return 'Vad.Reflex';
    if (cat === 'tortenelmi_vadaszij_fa' || cat === 'orom_vadaszij_fa') return 'Vadászíj (FA)';
    if (cat === 'tortenelmi_vadaszij_karbon' || cat === 'orom_vadaszij_karbon') return 'Vadászíj (KARB)';
    if (cat === 'tortenelmi_ij' || cat === 'orom_tortenelmi_ij') return 'Tört. íj';
    return cat.split('_').pop()?.toUpperCase() || '??';
  })();

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
        {/* LÁNC IKON BALRA */}
        {onLinkClick && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onLinkClick(participant.id);
            }}
            style={{
              background: 'none',
              border: 'none',
              color: '#b30000', // Mindig piros, ahogy eddig volt
              cursor: 'pointer',
              display: 'flex',
              padding: '2px',
              flexShrink: 0,
              marginTop: '1px'
            }}
            title="Összekötés másokkal"
          >
            <FiLink size={18} />
          </button>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
          {/* 1. SOR: NÉV */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px', overflow: 'hidden' }}>
            {participant.registeredVia === 'android' && (
              <AiFillAndroid size={14} color="#3DDC84" style={{ flexShrink: 0 }} title="Android App felhasználó" />
            )}
            {participant.registeredVia === 'ios' && (
              <AiFillApple size={14} color="#999999" style={{ flexShrink: 0 }} title="iOS Webes nevező" />
            )}
            {participant.registeredVia === 'web' && (
              <FiGlobe size={14} color="#007bff" style={{ flexShrink: 0 }} title="Webes nevező" />
            )}
            <span style={{ fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.9rem' }}>
              {participant.fullName}
            </span>
          </div>

          {/* 2. SOR: EGYESÜLET */}
          <div style={{ fontSize: '0.75rem', color: '#888', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', marginTop: '1px' }}>
            {participant.club || 'Egyéni induló'}
          </div>

          {/* 3. SOR: KATEGÓRIA, KOROSZTÁLY, NEM (Badge stílusban) */}
          <div style={{ display: 'flex', gap: '6px', alignItems: 'center', flexWrap: 'nowrap', marginTop: '6px', overflow: 'hidden' }}>
            <span style={neutralBadgeStyle}>{catShort}</span>
            <span style={{ ...baseBadgeStyle, ...getAgeCategoryStyle(participant.ageCategory) }}>
              {translationMap[participant.ageCategory] || participant.ageCategory}
            </span>
            <span style={neutralBadgeStyle}>
              {participant.gender === 'Férfi' ? 'Férfi' : 'Nő'}
            </span>
          </div>
        </div>
      </div>

      {/* 4. SOR: MEGJEGYZÉS (Legalul) */}
      {participant.comment && (
        <div style={{ ...teamCardCommentStyle, marginTop: '8px' }} title={participant.comment}>
          "{participant.comment}"
        </div>
      )}
      <style>{`
        @keyframes brutal-pulse {
          0% { background-color: #f0f2f5; color: #333; transform: scale(1); box-shadow: 0 0 0px transparent; }
          50% { background-color: var(--pulse-color); color: #fff; transform: scale(1.05); box-shadow: 0 0 20px var(--pulse-color); }
          100% { background-color: #f0f2f5; color: #333; transform: scale(1); box-shadow: 0 0 0px transparent; }
        }
        @keyframes team-pulse-selected {
          0% { background-color: var(--status-color); color: var(--text-color); border-color: #000; }
          100% { background-color: #b30000; color: #fff; border-color: #b30000; }
        }
      `}</style>
    </div>
  );
};

// --- TEAM BOX KOMPONENS ---
const TeamBox = ({ teamNumber, totalTeams, participants, linkBaseId, onLinkClick, isArchived, onScoreTeam, onUnlinkClick, onSwapTeams }) => {
  const { setNodeRef } = useDroppable({
    id: `team-${teamNumber}`,
  });

  return (
    <div ref={setNodeRef} style={teamBoxStyle}>
      <div style={teamHeaderStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span>{teamNumber}. csapat</span>
          {participants.length > 0 && (
            <button
              onClick={() => onScoreTeam({ number: teamNumber, members: participants })}
              style={{
                backgroundColor: '#b30000',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '2px 5px',
                fontSize: '0.65rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                textAlign: 'center',
                lineHeight: '1.1'
              }}
            >
              Eredmény<br/>beirása
            </button>
          )}

          {!isArchived && onSwapTeams && (
            <select
              value=""
              onChange={(e) => {
                const targetTeam = parseInt(e.target.value);
                if (targetTeam) {
                  onSwapTeams(teamNumber, targetTeam);
                }
              }}
              style={{
                padding: '2px 4px',
                borderRadius: '4px',
                border: '1px solid #ccc',
                fontSize: '0.65rem',
                fontWeight: 'bold',
                backgroundColor: '#fff',
                color: '#333',
                cursor: 'pointer'
              }}
            >
              <option value="" disabled>Csere</option>
              {Array.from({ length: totalTeams || 20 }, (_, i) => i + 1)
                .filter(num => num !== teamNumber)
                .map(num => (
                  <option key={num} value={num}>
                    {num}. csapat
                  </option>
                ))}
            </select>
          )}
        </div>
        <span style={teamCountStyle}>{participants.length} fő</span>
      </div>
      <SortableContext
        id={`team-${teamNumber}`}
        items={participants.map(p => p.id)}
        strategy={verticalListSortingStrategy}
      >
        <div style={teamBodyStyle}>
          {groupParticipantsByLink(participants).map((group, idx) => {
            if (group.type === 'linked') {
              return (
                <LinkedGroupWrapper key={`group-${group.linkId}-${idx}`} linkId={group.linkId} onUnlinkClick={isArchived ? null : onUnlinkClick}>
                  {group.members.map(p => (
                    <SortableParticipant
                      key={p.id}
                      id={p.id}
                      participant={p}
                      isLinkBase={linkBaseId === p.id}
                      onLinkClick={isArchived ? null : onLinkClick}
                      isInGroup={true}
                    />
                  ))}
                </LinkedGroupWrapper>
              );
            }
            return (
              <SortableParticipant
                key={group.participant.id}
                id={group.participant.id}
                participant={group.participant}
                isLinkBase={linkBaseId === group.participant.id}
                onLinkClick={isArchived ? null : onLinkClick}
              />
            );
          })}
          {participants.length === 0 && (
            <div style={emptyTeamTextStyle}>Húzz ide valakit...</div>
          )}
        </div>
      </SortableContext>
    </div>
  );
};

// --- POOL BOX KOMPONENS ---
const PoolBox = ({ participants, onLinkClick, isArchived, linkBaseId, onUnlinkClick, collapsedWaitlistLinks, onToggleWaitlistLinkCollapse }) => {
  const { setNodeRef } = useDroppable({
    id: 'pool',
  });

  return (
    <div id="pool" ref={setNodeRef} style={{
      flex: 1,
      backgroundColor: '#fdfdfd',
      borderRadius: '8px',
      border: '2px dashed #eee',
      padding: '10px',
      minHeight: '200px',
      overflowY: 'auto'
    }}>
      <SortableContext
        id="pool"
        items={participants.map(p => p.id)}
        strategy={verticalListSortingStrategy}
      >
        {groupParticipantsByLink(participants).map((group, idx) => {
          if (group.type === 'linked') {
            const isCollapsed = collapsedWaitlistLinks?.has(group.linkId);
            return (
              <LinkedGroupWrapper
                key={`group-pool-${group.linkId}-${idx}`}
                linkId={group.linkId}
                onUnlinkClick={isArchived ? null : onUnlinkClick}
                isCollapsed={isCollapsed}
                onToggleCollapse={onToggleWaitlistLinkCollapse}
              >
                {group.members.map(p => (
                  <SortableParticipant
                    key={p.id}
                    id={p.id}
                    participant={p}
                    isLinkBase={linkBaseId === p.id}
                    onLinkClick={isArchived ? null : onLinkClick}
                    isInGroup={true}
                  />
                ))}
              </LinkedGroupWrapper>
            );
          }
          return (
            <SortableParticipant
              key={group.participant.id}
              id={group.participant.id}
              participant={group.participant}
              isLinkBase={linkBaseId === group.participant.id}
              onLinkClick={isArchived ? null : onLinkClick}
            />
          );
        })}
        {participants.length === 0 && (
          <div style={{ color: '#ccc', textAlign: 'center', marginTop: '30px', fontStyle: 'italic', fontSize: '0.8rem' }}>
            Mindenki csapatban van.
          </div>
        )}
      </SortableContext>
    </div>
  );
};

// --- QR-KÓD BEOLVASÓ KOMPONENS (JAVÍTOTT, DUPLA KAMERA MENTES, KORLÁTOZÓ ZÁRRAL) ---
const QrCodeScannerTab = ({ onScanSuccess, onSaveScores, qrProgressInfo, onCancelProgress }) => {
  const [scannedResults, setScannedResults] = useState(null);
  const [rawQrText, setRawQrText] = useState('');
  const scannedResultsRef = useRef(null);

  useEffect(() => {
    scannedResultsRef.current = scannedResults;
  }, [scannedResults]);

  const playBeep = () => {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(880, ctx.currentTime);
      gainNode.gain.setValueAtTime(0.2, ctx.currentTime);
      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + 0.25);
    } catch (e) {}
  };

  useEffect(() => {
    let scannerInstance = null;
    let isMounted = true;

    const startScanner = async () => {
      try {
        const { Html5QrcodeScanner } = await import('html5-qrcode');
        if (!isMounted) return;

        const container = document.getElementById("qr-reader-container");
        if (!container) return;

        // Csak akkor hozunk létre újat, ha a konténer üres
        if (container.innerHTML === "") {
          scannerInstance = new Html5QrcodeScanner(
            "qr-reader-container",
            {
              fps: 20,
              qrbox: { width: 260, height: 260 },
              aspectRatio: 1.0,
              experimentalFeatures: {
                useBarCodeDetectorIfSupported: true
              }
            },
            false
          );

          scannerInstance.render(
            (decodedText) => {
              if (!isMounted) return;
              // HA MÁR BE VAN OLVASVA EGY CSAPAT ÉS OTT VAN A KÉPERNYŐN, NEM DOLGOZUNK FEL ÚJABB KÓDOKAT!
              if (scannedResultsRef.current !== null) return;

              setRawQrText(decodedText);
              if (onScanSuccess) {
                const resultsList = onScanSuccess(decodedText);
                if (resultsList && resultsList.length > 0) {
                  playBeep();
                  setScannedResults(resultsList);
                  scannedResultsRef.current = resultsList;
                }
              }
            },
            () => {} // Olvasási hibák csendes ignorálása
          );
        }
      } catch (err) {
        console.error("Hiba a szkenner indításakor:", err);
      }
    };

    startScanner();

    return () => {
      isMounted = false;
      if (scannerInstance) {
        try {
          // Megpróbáljuk leállítani, de ha a DOM elem már nincs ott, elkapjuk a hibát
          scannerInstance.clear().catch(err => {
            console.warn("Scanner clear failure (safe to ignore):", err);
          });
        } catch (e) {
          // Másodlagos védelem a szinkron hibák ellen
        }
      }
    };
  }, []);

  // --- GOMBNYOMÁS KEZELÉSE: MENTÉS ÉS ELŐNÉZET ÜRÍTÉSE ---
  const handleConfirmAndSend = () => {
    if (onSaveScores && scannedResults) {
      onSaveScores(scannedResults);
      setScannedResults(null); // Kártyák törlése, készen áll a következő csapatra
      scannedResultsRef.current = null;
      setRawQrText('');
    }
  };

  const handleCancelScannedResults = () => {
    setScannedResults(null);
    scannedResultsRef.current = null;
    setRawQrText('');
  };

  const isDarkScanning = true;

  return (
    <div style={{
      ...mainCardStyle,
      maxWidth: '1000px',
      margin: '0 auto',
      padding: '0px 15px 0px 15px',
      minHeight: 'auto',
      backgroundColor: isDarkScanning ? '#1e1e1e' : '#ffffff',
      color: isDarkScanning ? '#ffffff' : '#333333',
      transition: 'background-color 0.4s ease, color 0.4s ease'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '20px',
        alignItems: 'flex-start',
        flexWrap: 'wrap'
      }}>

        {/* BAL OLDAL: Kamera Kép + Kamera Képen Lévő Úszó Címsor */}
        <div style={{ flex: '1 1 350px', minWidth: '300px', position: 'relative' }}>
          {/* ÚSZÓ CÍMSOR ÉS PIROS VONAL A KAMERÁN */}
          <div style={{
            position: 'absolute',
            top: '12px',
            left: '15px',
            zIndex: 12,
            pointerEvents: 'none'
          }}>
            <h3 style={{
              margin: 0,
              fontSize: '0.95rem',
              fontWeight: '900',
              color: 'white',
              textShadow: '0 2px 6px rgba(0,0,0,0.9), 0 0 2px rgba(0,0,0,0.9)',
              paddingBottom: '3px',
              borderBottom: '2.5px solid #b30000',
              display: 'inline-block',
              letterSpacing: '0.5px'
            }}>
              Helyszíni QR-kód beolvasás
            </h3>
          </div>

          {/* ÚSZÓ TÖLTŐCSÍK SÁV A KAMERA ALSÓ SZÉLÉN */}
          {qrProgressInfo && (
            <div style={{
              position: 'absolute',
              bottom: '38px',
              left: '12px',
              right: '12px',
              backgroundColor: 'rgba(230, 255, 250, 0.95)',
              border: '2px solid #38b2ac',
              borderRadius: '10px',
              padding: '8px 12px',
              zIndex: 15,
              boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
              backdropFilter: 'blur(4px)'
            }}>
              {/* PIROS KÖRÖS X BEZÁRÓ GOMB */}
              <button
                onClick={onCancelProgress}
                style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-8px',
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  backgroundColor: '#b30000',
                  color: 'white',
                  border: '2px solid white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                  zIndex: 20
                }}
                title="Félkész beolvasás megszakítása"
              >
                <FiX size={14} strokeWidth={3} />
              </button>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px', paddingRight: '8px' }}>
                <span style={{ fontWeight: 'bold', color: '#2c7a7b', fontSize: '0.85rem' }}>
                  🔄 Beolvasás: {qrProgressInfo.receivedCount} / {qrProgressInfo.totalParts} megvan
                </span>
                <span style={{ fontWeight: '900', color: '#2c7a7b', fontSize: '0.85rem' }}>
                  {Math.round((qrProgressInfo.receivedCount / qrProgressInfo.totalParts) * 100)}%
                </span>
              </div>

              <div style={{
                width: '100%',
                height: '8px',
                backgroundColor: '#cbd5e0',
                borderRadius: '4px',
                overflow: 'hidden'
              }}>
                <div style={{
                  width: `${Math.min(100, Math.round((qrProgressInfo.receivedCount / qrProgressInfo.totalParts) * 100))}%`,
                  height: '100%',
                  backgroundColor: '#28a745',
                  transition: 'width 0.4s ease',
                  borderRadius: '4px'
                }} />
              </div>
            </div>
          )}

          <div
            id="qr-reader-container"
            style={{
              width: '100%',
              borderRadius: '12px',
              overflow: 'hidden',
              border: 'none',
              backgroundColor: '#fafafa',
              position: 'relative'
            }}
          ></div>

          <style>{`
            #qr-reader-container {
              position: relative !important;
              border: none !important;
            }
            #qr-reader-container video {
              transform: scaleX(-1) !important;
              -webkit-transform: scaleX(-1) !important;
              display: block !important;
              border-radius: 12px !important;
            }
            #qr-reader-container__dashboard {
              background: transparent !important;
              border: none !important;
              padding: 0 !important;
              margin: 0 !important;
            }
            #qr-reader-container__status_span,
            #qr-reader-container__header_message {
              display: none !important;
            }
            #qr-reader-container__dashboard_section_csr {
              position: absolute !important;
              top: 12px !important;
              right: 12px !important;
              left: auto !important;
              transform: none !important;
              z-index: 15 !important;
              margin: 0 !important;
              padding: 0 !important;
              width: auto !important;
              background: transparent !important;
            }
            #qr-reader-container__dashboard_section_csr button {
              background-color: rgba(108, 117, 125, 0.85) !important;
              color: white !important;
              border: 1px solid rgba(255, 255, 255, 0.5) !important;
              padding: 5px 12px !important;
              border-radius: 20px !important;
              cursor: pointer !important;
              font-weight: bold !important;
              box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3) !important;
              backdrop-filter: blur(4px) !important;
              font-size: 0.8rem !important;
              white-space: nowrap !important;
            }
            #qr-reader-container__dashboard_section_csr button:hover {
              background-color: rgba(179, 0, 0, 0.9) !important;
            }
          `}</style>
        </div>

        {/* JOBB OLDAL: Versenyzőnkénti részletes kártyák + MENTÉS GOMB */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '12px' }}>

          {scannedResults && scannedResults.length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', flex: 1, minHeight: '350px', justifyContent: 'space-between' }}>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2px' }}>
                <span style={{ fontWeight: 'bold', color: '#28a745', fontSize: '1rem' }}>
                  🔍 Ellenőrizd a beolvasott csapatot ({scannedResults.length} fő)
                </span>
              </div>

              {/* VERSENYZŐK LISTÁJA MAXIMÁLIS SIKERES BELSŐ GÖRGETÉSSEL */}
              <div style={{
                maxHeight: 'calc(100vh - 220px)',
                flex: 1,
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                paddingRight: '6px'
              }}>
                {scannedResults.map((comp, idx) => (
                  <div key={idx} style={{
                    padding: '12px 15px',
                    backgroundColor: '#f8fdf9',
                    border: '1px solid #c3e6cb',
                    borderRadius: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '6px'
                  }}>
                    {/* Név, Kategória és Összpontszám */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <div style={{ fontWeight: 'bold', fontSize: '1rem', color: '#155724' }}>
                          {comp.fullName}
                        </div>
                        <div style={{ fontSize: '0.75rem', color: '#555' }}>
                          {comp.bowCategory} | {comp.ageCategory}
                        </div>
                      </div>
                      <div style={{
                        backgroundColor: '#28a745',
                        color: 'white',
                        padding: '4px 10px',
                        borderRadius: '8px',
                        fontWeight: 'bold',
                        fontSize: '1.1rem'
                      }}>
                        {comp.totalScore} pont
                      </div>
                    </div>

                    {/* TALÁLATI ZÓNÁK STATISZTIKÁJA */}
                    <div style={{
                      display: 'flex',
                      gap: '6px',
                      flexWrap: 'wrap',
                      marginTop: '4px',
                      paddingTop: '6px',
                      borderTop: '1px dashed #d4edda'
                    }}>
                      {Object.entries(comp.hitZoneCounts)
                        .sort(([a], [b]) => {
                          const valA = a === 'X' ? 11.5 : (parseInt(a) || 0);
                          const valB = b === 'X' ? 11.5 : (parseInt(b) || 0);
                          return valB - valA;
                        })
                        .map(([zone, count]) => (
                          <span key={zone} style={{
                            backgroundColor: '#e2f0e5',
                            padding: '2px 7px',
                            borderRadius: '4px',
                            fontSize: '0.75rem',
                            color: '#155724',
                            fontWeight: 'bold'
                          }}>
                            {zone === 'X' ? 'X' : `${zone}p`}: <strong>{count}db</strong>
                          </span>
                        ))}
                    </div>
                  </div>
                ))}
              </div>

              {/* GOMBOK: MENTÉS ÉS MÉGSE */}
              <div style={{ display: 'flex', gap: '10px', marginTop: '6px' }}>
                <button
                  onClick={handleCancelScannedResults}
                  style={{
                    flex: 1,
                    padding: '7px 12px',
                    backgroundColor: '#6c757d',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: 'bold',
                    fontSize: '0.85rem',
                    cursor: 'pointer'
                  }}
                >
                  Mégse
                </button>
                <button
                  onClick={handleConfirmAndSend}
                  style={{
                    flex: 2,
                    padding: '7px 15px',
                    backgroundColor: '#28a745',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    cursor: 'pointer',
                    boxShadow: '0 2px 4px rgba(40, 167, 69, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                >
                  <span>🚀 Beküldés az eredményekhez</span>
                </button>
              </div>



            </div>
          ) : (
            <div style={{
              padding: '50px 20px',
              marginTop: '15px',
              backgroundColor: isDarkScanning ? '#282828' : '#fff',
              border: isDarkScanning ? '2px dashed #444' : '2px dashed #e0e0e0',
              color: isDarkScanning ? '#888' : '#aaa',
              borderRadius: '10px',
              textAlign: 'center',
              fontStyle: 'italic',
              fontSize: '0.9rem',
              transition: 'all 0.4s ease'
            }}>
              Várakozás a csapat QR-kódjára...
            </div>
          )}

        </div>

      </div>
    </div>
  );
};

// --- ÚJ: html2canvas DINAMIKUS BETÖLTÉSE ---
const loadHtml2Canvas = () => {
  return new Promise((resolve, reject) => {
    if (window.html2canvas) return resolve(window.html2canvas);
    const script = document.createElement('script');
    script.src = "https://html2canvas.hertzen.com/dist/html2canvas.min.js";
    script.onload = () => resolve(window.html2canvas);
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

const CompetitionOffice = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [competition, setCompetition] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('overview');
  const [participantSearchTerm, setParticipantSearchTerm] = useState('');
  const [resultsSearchTerm, setResultsSearchTerm] = useState('');
  const [resultsViewMode, setResultsViewMode] = useState('individual'); // 'individual' | 'team'
  const [collapsedWaitlistLinks, setCollapsedWaitlistLinks] = useState(() => {
    try {
      const saved = localStorage.getItem(`archerynexus_collapsed_links_${id}`);
      if (saved) {
        return new Set(JSON.parse(saved));
      }
    } catch (e) {
      console.error("Hiba a láncolt csoportok állapotának betöltésekor:", e);
    }
    return new Set();
  });

  useEffect(() => {
    try {
      localStorage.setItem(`archerynexus_collapsed_links_${id}`, JSON.stringify(Array.from(collapsedWaitlistLinks)));
    } catch (e) {
      console.error("Hiba a láncolt csoportok állapotának mentésekor:", e);
    }
  }, [collapsedWaitlistLinks, id]);

  const toggleWaitlistLinkCollapse = (linkId) => {
    setCollapsedWaitlistLinks(prev => {
      const next = new Set(prev);
      if (next.has(linkId)) next.delete(linkId);
      else next.add(linkId);
      return next;
    });
  };
  const [activeId, setActiveId] = useState(null);
  const [isSnapshotMode, setIsSnapshotMode] = useState(false); // ÚJ

  // --- DOKUMENTUMOK ÉS BEÍRÓLAP STATE-EK ---
  const [isDocsMenuOpen, setIsDocsMenuOpen] = useState(false);
  const [scoreSheetQrOption, setScoreSheetQrOption] = useState('blank'); // 'blank' | 'printed'
  const [scoreSheetPageOrientation, setScoreSheetPageOrientation] = useState('portrait'); // 'portrait' | 'landscape'
  const [scoreSheetTargetCount, setScoreSheetTargetCount] = useState(20);
  const [scoreSheetSelectedCompetitorId, setScoreSheetSelectedCompetitorId] = useState('all');

  // --- GOLYÓÁLLÓ DND AUTO-SCROLL REFEK ---
  const autoScrollAnimationRef = useRef(null);
  const dragPointerYRef = useRef(null);

  // --- ÚJ: MAX PONTSZÁM SZÁMÍTÓ SEGÉDFÜGGVÉNY ---
  const calculateMaxPossibleScore = (participant) => {
    if (!competition) return 9999;
    const maxZone = Math.max(...(competition.scoringValues || ['11', '10', '8', '5', '0']).map(v => v === 'X' ? 11 : parseInt(v) || 0));
    const numTargets = Number(competition.numberOfTargets) || 0;

    const bowCatShort = participant?.bowCategory?.split('_').pop()?.toUpperCase() || '';
    let shotsPerTarget = Number(competition.shotsPerTarget) || 0;

    if (competition.crossbowSingleShot && (bowCatShort === 'CRB' || bowCatShort === 'SZAMSZERIJ')) {
      shotsPerTarget = 1;
    }

    return numTargets * shotsPerTarget * maxZone;
  };

  // --- ÚJ: CÉLOK ÉS TÁVOK ÁLLAPOTA ---
  const [localTargetDetails, setLocalTargetDetails] = useState({});
  const [isSavingTargets, setIsSavingTargets] = useState(false);
  const [isPublishingTargets, setIsPublishingTargets] = useState(false); // ÚJ
  const [showTargetsPrintModal, setShowTargetsPrintModal] = useState(false);

  // --- ÚJ: CSAPAT ÁLLAPOT HOVER ---
  const [hoveredTeam, setHoveredTeam] = useState(null);
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });

  // --- ÚJ: REGISZTRÁCIÓS ÁLLAPOTOK (OFFLINE-BARÁT) ---
  const [localRegisteredIds, setLocalRegisteredIds] = useState(() => {
    // SZINKRON BETÖLTÉS: Azonnal beolvassuk a mentett állapotot indításkor
    const saved = localStorage.getItem(`reg_${id}`);
    if (saved) {
      try {
        return new Set(JSON.parse(saved));
      } catch (e) {
        console.error("Hiba a helyi adatok betöltésekor:", e);
      }
    }
    return new Set();
  });

  const [regSearchTerm, setRegSearchTerm] = useState('');
  const [teamFilter, setTeamFilter] = useState(null);
  const [showOnSiteOnly, setShowOnSiteOnly] = useState(false);

  const isParticipantCreatedToday = (p, targetDateStr) => {
    if (!p) return false;

    // 1. KIZÁRÓLAG A MANUÁLISAN FELVETT VENDÉGEKET ENGEDJÜK TOVÁBB
    const isManualOrGuest = p.isGuest === true || (p.userId && typeof p.userId === 'string' && p.userId.startsWith('G'));
    if (!isManualOrGuest) return false;

    // 2. KIZÁRÓLAG A VERSENY NAPJÁN FELVETTEKET ENGEDJÜK TOVÁBB (SZIGORÚ DÁTUM ELLENŐRZÉS)
    let dateStr = "";
    if (typeof p.createdAt === 'string') {
      dateStr = p.createdAt.slice(0, 10);
    } else if (p.createdAt && typeof p.createdAt.toDate === 'function') {
      try { dateStr = p.createdAt.toDate().toISOString().slice(0, 10); } catch (e) {}
    } else if (p.createdAt && p.createdAt.seconds) {
      try { dateStr = new Date(p.createdAt.seconds * 1000).toISOString().slice(0, 10); } catch (e) {}
    } else if (p.createdAt instanceof Date) {
      try { dateStr = p.createdAt.toISOString().slice(0, 10); } catch (e) {}
    }

    return dateStr === targetDateStr;
  };

  const onSiteCount = useMemo(() => {
    const targetDateStr = competition?.competitionDate || new Date().toISOString().slice(0, 10);
    return participants.filter(p => isParticipantCreatedToday(p, targetDateStr)).length;
  }, [participants, competition?.competitionDate]);

  // --- ÚJ: REGISZTRÁCIÓ LEZÁRÁSA ÁLLAPOT ---
  const [isRegistrationClosed, setIsRegistrationClosed] = useState(() => {
    return localStorage.getItem(`reg_closed_${id}`) === 'true';
  });

  // --- ÚJ: RÉSZLETES PONTOK ÁLLAPOTA ---
  const [allShotsByCompetitor, setAllShotsByCompetitor] = useState(() => {
    const saved = localStorage.getItem(`all_shots_${id}`);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error("Hiba a részletes pontok betöltésekor:", e);
      }
    }
    return {};
  });

  useEffect(() => {
    localStorage.setItem(`all_shots_${id}`, JSON.stringify(allShotsByCompetitor));
  }, [allShotsByCompetitor, id]);

  // --- ÚJ: VÁRÓLISTA KERESŐ ---
  const [poolSearchTerm, setPoolSearchTerm] = useState('');
  const [poolCategoryFilter, setPoolCategoryFilter] = useState('');
  const [poolAgeFilter, setPoolAgeFilter] = useState('');

  // --- ÚJ: LÁNCBONTÁS MEGERŐSÍTŐ MODAL ÁLLAPOTOK ---
  const [unlinkLinkIdToConfirm, setUnlinkLinkIdToConfirm] = useState(null);

  // Automatikus mentés LocalStorage-ba minden változáskor
  useEffect(() => {
    localStorage.setItem(`reg_${id}`, JSON.stringify(Array.from(localRegisteredIds)));
  }, [localRegisteredIds, id]);

  // --- ÚJ: LocalStorage szinkronizáció fül-váltáskor és külső módosításkor ---
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === `reg_${id}`) {
        try {
          const remoteReg = JSON.parse(e.newValue || '[]');
          setLocalRegisteredIds(prev => {
            // Összefésüljük a meglévőt a külsővel (soha ne veszítsünk pipát!)
            const merged = new Set([...prev, ...remoteReg]);
            return merged;
          });
        } catch (err) { console.error(err); }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [id]);

  useEffect(() => {
    localStorage.setItem(`reg_closed_${id}`, isRegistrationClosed.toString());
  }, [isRegistrationClosed, id]);

  // --- ÚJ: MODAL ÁLLAPOTOK A PONTOZÁSHOZ ---
  const [showTeamScoreModal, setShowTeamScoreModal] = useState(false);
  const [teamScoringData, setTeamScoringData] = useState({ number: null, members: [], scores: {}, memberZones: {} });

  // --- ÚJ: GYORS-KASSZA (CSOPORTOS FIZETÉS) ÁLLAPOTOK ---
  const [paymentGroup, setPaymentGroup] = useState([]);
  const [showPaymentUI, setShowPaymentUI] = useState(false);
  const paymentTimer = useRef(null);
  const lastRegistrationClickTime = useRef(0);

  const [showEditScoreModal, setShowEditScoreModal] = useState(false);
  const [scoreEditData, setScoreEditData] = useState({ id: '', name: '', score: '' });

  const handleOpenEditScoreModal = (p) => {
    setScoreEditData({
      id: p.id,
      name: p.fullName,
      score: p.totalScore !== undefined ? p.totalScore.toString() : ''
    });
    setShowEditScoreModal(true);
  };

  const handleSaveManualScoreEdit = async () => {
    if (isArchived || competition?.status === 'Lezárt' || competition?.status === 'Ready to Upload') {
      alert("A verseny le van zárva, az eredmények már nem módosíthatók.");
      return;
    }

    try {
      const score = parseInt(scoreEditData.score) || 0;

      // LocalStorage frissítés
      const savedScores = JSON.parse(localStorage.getItem(`scores_${id}`) || '{}');
      savedScores[scoreEditData.id] = score;
      localStorage.setItem(`scores_${id}`, JSON.stringify(savedScores));

      // --- OFFLINE MENTÉS ÁG ---
      if (!navigator.onLine) {
        await saveScoreOffline(id, scoreEditData.id, {
          totalScore: score,
          isManuallyEdited: true,
          status: "Eredmény felülbírálva (Offline)"
        });

        setParticipants(prev => prev.map(p =>
          p.id === scoreEditData.id ? { ...p, totalScore: score, isManuallyEdited: true, status: "Eredmény felülbírálva (Offline)" } : p
        ));

        setLocalRegisteredIds(prev => new Set(prev).add(scoreEditData.id));

        setShowEditScoreModal(false);
        setScannedSaveSource('edit_manual');
        setScannedSaveSuccessData([{
          fullName: scoreEditData.name,
          totalScore: score
        }]);
        alert("Pontszám felülbírálva offline módba! 🏹💾");
        return;
      }

      // --- ONLINE MENTÉS ÁG ---
      const pRef = doc(db, "events", id, "participants", scoreEditData.id);
      await updateDoc(pRef, {
        totalScore: score,
        isManuallyEdited: true,
        status: "Eredmény felülbírálva"
      });

      // Memória frissítés
      setParticipants(prev => prev.map(p =>
        p.id === scoreEditData.id ? { ...p, totalScore: score, isManuallyEdited: true, status: "Eredmény felülbírálva" } : p
      ));

      setLocalRegisteredIds(prev => new Set(prev).add(scoreEditData.id));

      setShowEditScoreModal(false);
      setScannedSaveSuccessData([{
        fullName: scoreEditData.name,
        totalScore: score
      }]);
    } catch (e) {
      console.error("Hiba a mentéskor:", e);
      try {
        await saveScoreOffline(id, scoreEditData.id, {
          totalScore: parseInt(scoreEditData.score) || 0,
          isManuallyEdited: true,
          status: "Eredmény felülbírálva (Offline)"
        });
      } catch (offErr) {}
      alert("Pontszám elmentve offline módba! 🏹💾");
      setShowEditScoreModal(false);
    }
  };

  const handleOpenTeamScoreModal = (team) => {
    const initialScores = {};
    const initialZones = {};
    const scoringValues = competition?.scoringValues || ['11', '10', '8', '5', '0'];

    team.members.forEach(m => {
      initialScores[m.id] = m.totalScore !== undefined ? m.totalScore.toString() : '';

      // Zónák inicializálása
      initialZones[m.id] = {};
      scoringValues.forEach(z => {
        // Ha vannak már mentett lövései, megpróbáljuk kinyerni belőle a zónákat
        const shots = m.shots || allShotsByCompetitor[m.id] || [];
        const count = shots.filter(s => s.value === z).length;
        initialZones[m.id][z] = count > 0 ? count : '';
      });
    });

    setTeamScoringData({
      number: team.number,
      members: team.members,
      scores: initialScores,
      memberZones: initialZones
    });
    setShowTeamScoreModal(true);
  };

  const handleTeamScoreChange = (participantId, value) => {
    if (value === '' || /^[0-9\b]+$/.test(value)) {
      const numVal = parseInt(value) || 0;
      const p = participants.find(p => p.id === participantId);
      const maxScore = calculateMaxPossibleScore(p);
      const finalVal = Math.min(numVal, maxScore).toString();

      setTeamScoringData(prev => ({
        ...prev,
        scores: { ...prev.scores, [participantId]: value === '' ? '' : finalVal }
      }));
    }
  };

  const handleTeamZoneChange = (participantId, zone, value) => {
    if (value === '' || /^[0-9\b]+$/.test(value)) {
      setTeamScoringData(prev => {
        const newZones = {
          ...prev.memberZones[participantId],
          [zone]: value === '' ? '' : parseInt(value)
        };

        // ÚJ: Automatikus összpontszám újraszámolás a zónák alapján
        const newTotal = Object.entries(newZones).reduce((acc, [z, count]) => {
          const v = z === 'X' ? 11 : parseInt(z) || 0;
          return acc + (v * (parseInt(count) || 0));
        }, 0);

        return {
          ...prev,
          memberZones: {
            ...prev.memberZones,
            [participantId]: newZones
          },
          scores: {
            ...prev.scores,
            [participantId]: newTotal > 0 ? newTotal.toString() : ''
          }
        };
      });
    }
  };

  const handleSaveTeamScores = async () => {
    if (isArchived || competition?.status === 'Lezárt') {
      alert("A verseny le van zárva, az eredmények már nem módosíthatók.");
      return;
    }

    try {
      const savedScores = JSON.parse(localStorage.getItem(`scores_${id}`) || '{}');
      const newAllShots = { ...allShotsByCompetitor };
      const participantUpdates = [];

      teamScoringData.members.forEach(m => {
        const scoreStr = teamScoringData.scores[m.id];
        if (scoreStr !== '') {
          const enteredTotal = parseInt(scoreStr);
          const zones = teamScoringData.memberZones[m.id] || {};

          // --- VALIDÁCIÓS SZÁMÍTÁSOK ---
          let calculatedTotal = 0;
          let totalShotsCount = 0;
          const virtualShots = [];

          Object.entries(zones)
            .sort((a, b) => {
              const valA = a[0] === 'X' ? 11.5 : parseInt(a[0]) || 0;
              const valB = b[0] === 'X' ? 11.5 : parseInt(b[0]) || 0;
              return valB - valA;
            })
            .forEach(([zone, count]) => {
            const numCount = parseInt(count) || 0;
            const zoneValue = zone === 'X' ? 11 : parseInt(zone) || 0;
            calculatedTotal += zoneValue * numCount;
            totalShotsCount += numCount;

            for (let i = 0; i < numCount; i++) {
              virtualShots.push({ value: zone, sum: zoneValue });
            }
          });

          // Elvárt lövésszám meghatározása
          const bowCatShort = m.bowCategory?.split('_').pop()?.toUpperCase() || '';
          let expectedShotsPerTarget = Number(competition?.shotsPerTarget) || 0;
          if (competition?.crossbowSingleShot && (bowCatShort === 'CRB' || bowCatShort === 'SZAMSZERIJ')) {
            expectedShotsPerTarget = 1;
          }
          const maxExpectedShots = (Number(competition?.numberOfTargets) || 0) * expectedShotsPerTarget;

          // DÖNTÉS: Hivatalos vagy Felülbírált?
          const isOfficial = (calculatedTotal === enteredTotal) && (totalShotsCount === maxExpectedShots);

          // --- LÖVÉSEK SZÉTOSTÁSA CÉLOKRA ---
          const finalVirtualShots = [];
          if (isOfficial) {
            const numTargets = Number(competition?.numberOfTargets) || 24;
            const shotsPerT = (totalShotsCount / numTargets) || 1;
            virtualShots.forEach((shot, index) => {
              finalVirtualShots.push({
                ...shot,
                target: Math.floor(index / shotsPerT) + 1,
                position: (index % shotsPerT) + 1
              });
            });
          }

          participantUpdates.push({
            id: m.id,
            fullName: m.fullName,
            totalScore: enteredTotal,
            shots: finalVirtualShots,
            isOfficial
          });

          savedScores[m.id] = enteredTotal;
          if (isOfficial) {
            newAllShots[m.id] = finalVirtualShots;
          }
        }
      });

      // --- MENTÉS: OFFLINE ÁG ---
      if (!navigator.onLine) {
        for (const update of participantUpdates) {
          await saveScoreOffline(id, update.id, {
            totalScore: update.totalScore,
            shots: update.shots,
            status: "Csapat leadva (Offline)",
            isManuallyEdited: true
          });
        }
        alert(`${participantUpdates.length} fő eredménye elmentve offline módba! 🏹💾`);
      } else {
        // --- MENTÉS: ONLINE ÁG ---
        const batch = writeBatch(db);
        participantUpdates.forEach(update => {
          const pRef = doc(db, "events", id, "participants", update.id);
          batch.update(pRef, {
            totalScore: update.totalScore,
            shots: update.shots,
            isManuallyEdited: true,
            status: "Eredmény leadva"
          });
        });
        await batch.commit();
      }

      // Közös UI frissítés
      localStorage.setItem(`scores_${id}`, JSON.stringify(savedScores));
      setAllShotsByCompetitor(newAllShots);

      setParticipants(prev => prev.map(p => {
        const update = participantUpdates.find(u => u.id === p.id);
        return update ? { ...p, totalScore: update.totalScore, shots: update.shots, isManuallyEdited: true, status: navigator.onLine ? "Eredmény leadva" : "Csapat leadva (Offline)" } : p;
      }));

      // --- ÚJ: REGISZTRÁCIÓ FRISSÍTÉSE (Hogy ne tűnjenek el a listából) ---
      setLocalRegisteredIds(prev => {
        const newSet = new Set(prev);
        participantUpdates.forEach(u => newSet.add(u.id));
        return newSet;
      });

      setShowTeamScoreModal(false);
      setScannedSaveSource('team_score');
      setScannedSaveSuccessData(participantUpdates);
    } catch (e) {
      console.error("Hiba a mentéskor:", e);
      setShowTeamScoreModal(false);
      alert("Hiba történt a mentés során.");
    }
  };

  // --- ÚJ: KIJELÖLÉSI ÁLLAPOT ---
  const [selectedIds, setSelectedIds] = useState(new Set());

  // --- ÚJ: MEGJEGYZÉS POPUP ÁLLAPOT ---
  const [activeComment, setActiveComment] = useState(null);

  // --- ÚJ: ÖSSZEKÖTÉSI (LINK) ÁLLAPOTOK ---
  const [linkBaseId, setLinkBaseId] = useState(null);
  const [mapTotalDistance, setMapTotalDistance] = useState(0); // ÚJ: Térkép össztávolság
  const [showMapPrintModal, setShowMapPrintModal] = useState(false); // ÚJ: Térkép nyomtatási portál
  const [editorKey, setEditorKey] = useState(0); // ÚJ: Térképszerkesztő frissítő kulcs (F5 remount)

  // Összekötés váltása
  const handleToggleLink = async (participantId) => {
    if (isArchived) return; // ARCHIVÁLT VÉDELEM

    // 1. Ha ő a bázis, akkor kikapcsoljuk a módot
    if (linkBaseId === participantId) {
      setLinkBaseId(null);
      return;
    }

    // 2. Ha nincs bázis, ő lesz az
    if (!linkBaseId) {
      setLinkBaseId(participantId);
      return;
    }

    // 3. Ha van már bázis, akkor összekötjük a két embert / csoportot
    const baseParticipant = participants.find(p => p.id === linkBaseId);
    const targetParticipant = participants.find(p => p.id === participantId);

    if (!baseParticipant || !targetParticipant) return;

    const baseMembers = baseParticipant.linkId
      ? participants.filter(p => p.linkId === baseParticipant.linkId)
      : [baseParticipant];

    const targetMembers = targetParticipant.linkId
      ? participants.filter(p => p.linkId === targetParticipant.linkId)
      : [targetParticipant];

    // Ha szétbontani akarjuk (ugyanazon láncon belül kattintottak)
    const isUnlinking = baseParticipant.linkId && baseParticipant.linkId === targetParticipant.linkId;

    if (isUnlinking) {
      const targetTeam = targetParticipant.team !== undefined ? targetParticipant.team : null;

      setParticipants(prev => prev.map(p => p.id === participantId ? { ...p, linkId: null, team: targetTeam } : p));

      try {
        await updateParticipantOffline(participantId, { linkId: null, team: targetTeam });
        if (navigator.onLine && !participantId.toString().startsWith('temp_')) {
          await updateDoc(doc(db, "events", id, "participants", participantId), { linkId: null, team: targetTeam });
        }
      } catch (e) {
        console.error("Hiba a láncbontáskor:", e);
      }
      return;
    }

    // ÖSSZEKÖTÉS: Összevesszük mindkét oldal összes tagját
    const newLinkId = baseParticipant.linkId || targetParticipant.linkId || `group_${linkBaseId}`;
    const targetTeam = (baseParticipant.team !== undefined && baseParticipant.team !== null)
      ? baseParticipant.team
      : (targetParticipant.team !== undefined && targetParticipant.team !== null ? targetParticipant.team : null);

    const allMembersToLink = Array.from(new Set([...baseMembers, ...targetMembers]));
    const memberIdsToLink = new Set(allMembersToLink.map(m => m.id));

    // Optimista UI frissítés
    setParticipants(prev => prev.map(p => {
      if (memberIdsToLink.has(p.id)) {
        return { ...p, linkId: newLinkId, team: targetTeam };
      }
      return p;
    }));

    try {
      // Offline IndexedDB mentés (átadva a teljes modellt a biztonság kedvéért)
      for (const m of allMembersToLink) {
        await updateParticipantOffline(m.id, { linkId: newLinkId, team: targetTeam }, m);
      }

      // Online Firestore mentés
      if (navigator.onLine) {
        const batch = writeBatch(db);
        allMembersToLink.forEach(m => {
          if (!m.id.toString().startsWith('temp_')) {
            const pRef = doc(db, "events", id, "participants", m.id);
            batch.update(pRef, { linkId: newLinkId, team: targetTeam });
          }
        });
        await batch.commit();
      }
    } catch (e) {
      console.error("Hiba az összekötésnél:", e);
      alert("Hiba történt az összekötés során.");
    }
  };

  // --- MODAL ÁLLAPOTOK A TÖRLÉSHEZ ÉS PUBLIKÁLÁSHOZ ---
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showPublishTargetsConfirm, setShowPublishTargetsConfirm] = useState(false); // ÚJ
  const [showPublishTeamsConfirm, setShowPublishTeamsConfirm] = useState(false); // ÚJ
  const [isPublishingTeams, setIsPublishingTeams] = useState(false); // ÚJ
  const [participantToDelete, setParticipantToDelete] = useState(null);
  const [showPublishMapConfirm, setShowPublishMapConfirm] = useState(false); // ÚJ
  const [isPublishingMap, setIsPublishingMap] = useState(false); // ÚJ

  // --- ÚJ: CSAPATOK PUBLIKÁLÁSA FUNKCIÓ ---
  const handleTogglePublishTeams = async () => {
    const newState = !competition?.teamsPublished;

    if (newState && !showPublishTeamsConfirm) {
      setShowPublishTeamsConfirm(true);
      return;
    }

    setIsPublishingTeams(true);
    try {
      const collectionName = isArchived ? "events_closed" : "events";
      const docRef = doc(db, collectionName, id);
      await updateDoc(docRef, {
        teamsPublished: newState
      });
      setCompetition(prev => ({ ...prev, teamsPublished: newState }));
      setShowPublishTeamsConfirm(false);
      alert(newState ? "A csapatbeosztás (rajtlista) publikálva lett az íjászoknak! 🏹🚀" : "A csapatbeosztás mostantól rejtve van.");
    } catch (error) {
      console.error("Hiba a csapatok publikálásakor:", error);
      alert("Hiba történt a művelet során.");
    } finally {
      setIsPublishingTeams(false);
    }
  };

// --- ARCHERY NEXUS STÍLUSÚ MODAL ÁLLAPOT A MENTÉSHEZ ---
  const [scannedSaveSuccessData, setScannedSaveSuccessData] = useState(null);
  const [scannedSaveSource, setScannedSaveSource] = useState('qr_scan');

  // --- ÚJ: MODAL ÁLLAPOTOK AZ ÚJ NEVEZŐHÖZ ---
  const [showAddModal, setShowAddModal] = useState(false);
  const [isSavingParticipant, setIsSavingParticipant] = useState(false); // ÚJ: Duplázódás elleni védelem
  const [showEditModal, setShowEditModal] = useState(false); // ÚJ
  const [editData, setEditData] = useState(null); // ÚJ
  const [newParticipant, setNewParticipant] = useState({
    fullName: '',
    club: '',
    bowCategory: '',
    ageCategory: 'felnott',
    gender: 'Férfi',
    lunchCount: 0,
    lunchSelections: { A: 0, B: 0, C: 0 },
    comment: '',
    license: '',
    team: null
  });

  // --- ÚJ: MODAL ÁLLAPOT A QR NYOMTATÁSHOZ ---
  const [showQrModal, setShowQrModal] = useState(false);
  const [qrSortOrder, setQrSortOrder] = useState('name'); // 'name' vagy 'team'
  const [qrPrintFormat, setQrPrintFormat] = useState('a4'); // 'a4' vagy 'label'
  const [qrSkipCount, setQrSkipCount] = useState(0); // ÚJ: Hány matricát hagyjon ki az elején

  // --- ÚJ: MODAL ÁLLAPOT A CSAPAT NYOMTATÁSHOZ ---
  const [showTeamsPrintModal, setShowTeamsPrintModal] = useState(false);

  // --- ÚJ: PÉNZÜGYI LÁTHATÓSÁG ---
  const [showFinancials, setShowFinancials] = useState(false);

  // --- ÚJ: MANUÁLIS EREDMÉNY RÖGZÍTÉS ÁLLAPOTOK ---
  const [showManualScoreModal, setShowManualScoreModal] = useState(false);
  const [showResultsExportModal, setShowResultsExportModal] = useState(false);
  const [resultsExportType, setResultsExportType] = useState('full');
  const [manualSearchTerm, setManualSearchTerm] = useState('');

  // --- ÚJ: SZÉTLÖVÉS ÁLLAPOTOK ---
  const [showShootOffModal, setShowShootOffModal] = useState(false);
  const [shootOffGroup, setShootOffGroup] = useState([]); // Versenyzők listája a szétlövésben
  const [shootOffRanks, setShootOffRanks] = useState({}); // Kinek mi a szétlövéses helyezése (1, 2, 3...)
  const [shootOffSaving, setShootOffSaving] = useState(false);
  const [manualScoreEntry, setManualScoreEntry] = useState({
    participant: null,
    zones: {},
    totalScore: ''
  });
  const [manualScoreError, setManualScoreError] = useState(null);
  const [showCloseCompetitionError, setShowCloseCompetitionError] = useState(false);
  const [showFinalCloseConfirmModal, setShowFinalCloseConfirmModal] = useState(false);
  const [isArchived, setIsArchived] = useState(false);
  const [showSoftCloseInfoModal, setShowSoftCloseInfoModal] = useState(false); // ÚJ: Soft close info
  const [showUnsavedMapWarning, setShowUnsavedMapWarning] = useState(false); // ÚJ: Térkép védelem
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // ÚJ: Behúzható oldalsáv állapota
  const [pendingOfflineCount, setPendingOfflineCount] = useState(0); // ÚJ: Szinkronizálásra váró adatok száma
  const [isSyncing, setIsSyncing] = useState(false); // ÚJ: Szinkronizálás folyamatban jelző
  const [broadcastMessage, setBroadcastMessage] = useState('');
  const [isSendingBroadcast, setIsSendingBroadcast] = useState(false);

  // --- ÚJ: MULTI-CHUNK QR LOKÁLIS RAM ÁLLAPOTOK ---
  const qrSessionsRef = useRef({});
  const [qrProgressInfo, setQrProgressInfo] = useState(null);
  const [showScrollTop, setShowScrollTop] = useState(false); // ÚJ: Vissza a tetejére gombhoz
  const contentRef = useRef(null); // ÚJ: A görgethető tartalom eléréséhez

  // --- ÚJ: EGYESÜLET AUTOCOMPLETE ÁLLAPOTOK ---
  const [clubSuggestions, setClubSuggestions] = useState([]);
  const [showAddClubSuggestions, setShowAddClubSuggestions] = useState(false);
  const [showEditClubSuggestions, setShowEditClubSuggestions] = useState(false);

  // --- ÚJ: KLUB NÉV FORMÁZÓ SEGÉDFÜGGVÉNY ---
  const formatClubName = (name) => {
    if (!name || name === "Egyéb") return name;
    const specialCases = {
        "3d": "3D", "kft.": "Kft.", "se": "SE", "sk": "SK", "dse": "DSE",
        "kse": "KSE", "mavir": "MAVIR", "ifaa": "IFAA", "hdh-iaa": "HDH-IAA"
    };

    return name.split(' ').map(word => {
      const cleanWord = word.replace(/[^a-zA-ZáéíóöőúüűÁÉÍÓÖŐÚÜŰ0-9]/g, '').toLowerCase();
      if (specialCases[cleanWord]) return specialCases[cleanWord];
      if (word.startsWith('"')) {
          return '"' + word.charAt(1).toUpperCase() + word.slice(2).toLowerCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
  };

  const handleClubChange = (value, isEdit = false) => {
    const filtered = ARCHERY_CLUBS.filter(club =>
      club.toLowerCase().includes(value.toLowerCase())
    ).slice(0, 10);

    // Formázott javaslatok a listába
    const formatted = filtered.map(c => formatClubName(c));
    setClubSuggestions(formatted);

    if (isEdit) {
      setEditData({ ...editData, club: value });
      setShowEditClubSuggestions(value.length > 1 && formatted.length > 0);
    } else {
      setNewParticipant({ ...newParticipant, club: value });
      setShowAddClubSuggestions(value.length > 1 && formatted.length > 0);
    }
  };

  // --- ÚJ: ID LÁTHATÓSÁG ---
  const [revealedIds, setRevealedIds] = useState(new Set());

  // --- ÚJ: NÉV LÁTHATÓSÁG ---
  const [revealedNames, setRevealedNames] = useState(new Set());
  const mapEditorRef = useRef(null); // ÚJ: Ref a pályaszerkesztőhöz
  const customMapInputRef = useRef(null); // ÚJ: Ref a saját térkép fájl feltöltőhöz
  const [isUploadingCustomMap, setIsUploadingCustomMap] = useState(false);
  const [showPrintDropdown, setShowPrintDropdown] = useState(false);
  const [showCustomMapPrintModal, setShowCustomMapPrintModal] = useState(false);
  const printDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutsidePrint = (event) => {
      if (printDropdownRef.current && !printDropdownRef.current.contains(event.target)) {
        setShowPrintDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutsidePrint);
    return () => document.removeEventListener('mousedown', handleClickOutsidePrint);
  }, []);

  const handleCustomMapUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      alert("Kérjük, képfájlt (PNG, JPG, WEBP) válassz ki!");
      return;
    }

    setIsUploadingCustomMap(true);
    try {
      const reader = new FileReader();
      reader.onload = async (event) => {
        try {
          const base64Image = event.target.result;
          const wasPublished = competition?.courseMapPublished || false;

          const publishFunc = httpsCallable(functions, 'publishMapImage');
          const result = await publishFunc({
            eventId: id,
            base64Image: base64Image
          });

          const downloadUrl = result.data.imageUrl;

          // VÁZLATKÉNT MENTJÜK: isCustomMap: true, de a courseMapPublished megőrzi az eredeti állapotát!
          const collectionName = isArchived ? "events_closed" : "events";
          await updateDoc(doc(db, collectionName, id), {
            customMapImageUrl: downloadUrl,
            isCustomMap: true,
            courseMapPublished: wasPublished,
            courseMapImageUrl: wasPublished ? downloadUrl : ""
          });

          setCompetition(prev => ({
            ...prev,
            customMapImageUrl: downloadUrl,
            isCustomMap: true,
            courseMapPublished: wasPublished,
            courseMapImageUrl: wasPublished ? downloadUrl : ""
          }));

          alert(wasPublished
            ? "Új saját térkép feltöltve és frissítve! 🏹🗺️"
            : "Saját térkép vázlatként feltöltve! A közzétételhez kattints a 'Térkép publikálása' gombra. 🏹🗺️"
          );
        } catch (error) {
          console.error("Hiba a saját térkép feltöltésekor (Cloud Function):", error);
          alert("Hiba történt a kép feltöltése során: " + (error.message || error));
        } finally {
          setIsUploadingCustomMap(false);
          if (e.target) e.target.value = '';
        }
      };
      reader.onerror = () => {
        alert("Hiba a fájl beolvasásakor.");
        setIsUploadingCustomMap(false);
        if (e.target) e.target.value = '';
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error("Hiba a saját térkép feldolgozásakor:", error);
      alert("Hiba történt a kép feldolgozása során.");
      setIsUploadingCustomMap(false);
      if (e.target) e.target.value = '';
    }
  };

  const handleSwitchToGoogleMaps = async () => {
    try {
      const collectionName = isArchived ? "events_closed" : "events";
      await updateDoc(doc(db, collectionName, id), {
        isCustomMap: false
      });
      setCompetition(prev => ({
        ...prev,
        isCustomMap: false
      }));
    } catch (error) {
      console.error("Hiba a Google Maps-re való váltáskor:", error);
    }
  };

  const handleSwitchToCustomMap = async () => {
    try {
      const collectionName = isArchived ? "events_closed" : "events";
      await updateDoc(doc(db, collectionName, id), {
        isCustomMap: true
      });
      setCompetition(prev => ({
        ...prev,
        isCustomMap: true
      }));
    } catch (error) {
      console.error("Hiba a saját térképre való váltáskor:", error);
    }
  };

  const handleRemoveCustomMap = async () => {
    if (!window.confirm("Biztosan törölni szeretnéd a feltöltött saját térképet, és visszatérsz az interaktív Google Maps szerkesztőhöz?")) {
      return;
    }

    setIsUploadingCustomMap(true);
    try {
      const collectionName = isArchived ? "events_closed" : "events";
      await updateDoc(doc(db, collectionName, id), {
        customMapImageUrl: "",
        isCustomMap: false,
        courseMapPublished: false,
        courseMapImageUrl: ""
      });

      setCompetition(prev => ({
        ...prev,
        customMapImageUrl: "",
        isCustomMap: false,
        courseMapPublished: false,
        courseMapImageUrl: ""
      }));

      alert("Saját térkép törölve, az interaktív Google Maps újra aktív.");
    } catch (error) {
      console.error("Hiba a saját térkép törlésekor:", error);
      alert("Hiba történt a törlés során.");
    } finally {
      setIsUploadingCustomMap(false);
    }
  };

  // --- ÚJ: RENDEZÉSI ÁLLAPOT ---
  const [sortConfig, setSortConfig] = useState({ key: 'fullName', direction: 'asc' });

  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const toggleIdVisibility = (id) => {
    const newSet = new Set(revealedIds);
    if (newSet.has(id)) {
      newSet.delete(id);
    } else {
      newSet.add(id);
    }
    setRevealedIds(newSet);
  };

  // ÚJ: CÍM MEGVÁLTOZTATÁSA NYOMTATÁSKOR (Eltünteti a localhost feliratot a fejlécből)
  useEffect(() => {
    if (showTeamsPrintModal) {
      const originalTitle = document.title;
      document.title = " "; // Teljesen üres cím, így a Windows nem tudja odaírni az URL-t felülre
      return () => { document.title = originalTitle; };
    }
  }, [showTeamsPrintModal]);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  // 1. Verseny alapadatok betöltése - ÉLŐ FIGYELŐVEL (onSnapshot)
  useEffect(() => {
    if (!id) return;

    let unsubscribe = () => {};

    const startListener = async () => {
      try {
        // --- ÚJ: OFFLINE ELLENŐRZÉS ---
        if (!navigator.onLine) {
          const offlineData = await getCompetitionOffline(id);
          if (offlineData.competition) {
            setCompetition(offlineData.competition);
            setParticipants(offlineData.participants);
            setLoading(false);
            return;
          }
        }

        // Először megpróbáljuk az aktív versenyek közül
        const activeRef = doc(db, "events", id);

        unsubscribe = onSnapshot(activeRef, (docSnap) => {
          if (docSnap.exists()) {
            const compData = { id: docSnap.id, ...docSnap.data() };
            setCompetition(compData);
            setIsArchived(false);
            setLoading(false);

            if (compData.targetDetails) setLocalTargetDetails(compData.targetDetails);
            if (compData.registrationClosed === true) setIsRegistrationClosed(true);
          } else {
            // Ha aktívként nincs meg, nézzük meg a lezártak között (vagy épp most zárták le)
            const closedRef = doc(db, "events_closed", id);
            getDoc(closedRef).then(closedSnap => {
              if (closedSnap.exists()) {
                // Átállunk a lezárt figyelőre
                unsubscribe();
                unsubscribe = onSnapshot(closedRef, (csnap) => {
                   if (csnap.exists()) {
                      const cData = { id: csnap.id, ...csnap.data() };
                      setCompetition(cData);
                      setIsArchived(true);
                      setIsRegistrationClosed(true);
                      setLoading(false);
                      if (cData.targetDetails) setLocalTargetDetails(cData.targetDetails);
                   }
                });
              } else {
                // Ha sehol nincs meg
                alert("A verseny nem található!");
                navigate('/egyesulet-dashboard');
              }
            });
          }
        }, (error) => {
          console.error("Hiba a verseny figyelésekor:", error);
          setLoading(false);
        });

      } catch (error) {
        console.error("Hiba az inicializáláskor:", error);
        setLoading(false);
      }
    };

    startListener();
    return () => unsubscribe();
  }, [id, navigate]);

  // --- AUTOMATIKUS OFFLINE SZINKRONIZÁLÓ MOTOR ---
  const syncPendingOfflineActions = async (competitionId) => {
    if (!navigator.onLine || !competitionId) return;

    try {
      const pendingItems = await getPendingScores(competitionId);
      if (!pendingItems || pendingItems.length === 0) return;

      console.log("Függőben lévő offline műveletek szinkronizálása indult:", pendingItems.length);

      for (const item of pendingItems) {
        try {
          const collectionName = isArchived ? "events_closed" : "events";

          // 1. TÖRLÉSI PARANCSOK (delete_participant)
          if (item.type === 'delete_participant') {
            if (item.id && !item.id.toString().startsWith('temp_')) {
              const batch = writeBatch(db);
              const pRef = doc(db, collectionName, competitionId, "participants", item.id);
              batch.delete(pRef);
              const eventRef = doc(db, collectionName, competitionId);
              batch.update(eventRef, { participantsCount: increment(-1) });
              await batch.commit();
            }
            await clearPendingScore(item.id);
          }
          // 2. ÚJ NEVEZŐ PARANCSOK (new_participant)
          else if (item.type === 'new_participant') {
            const { type, ...pData } = item;
            const batch = writeBatch(db);
            const pRef = doc(db, collectionName, competitionId, "participants", item.id);
            batch.set(pRef, pData);
            const eventRef = doc(db, collectionName, competitionId);
            batch.update(eventRef, { participantsCount: increment(1) });
            await batch.commit();
            await clearPendingScore(item.id);
          }
          // 3. MÓDOSÍTÁSI PARANCSOK (update_participant)
          else if (item.type === 'update_participant') {
            if (item.id && item.updateData && !item.id.toString().startsWith('temp_')) {
              const pRef = doc(db, collectionName, competitionId, "participants", item.id);
              await updateDoc(pRef, item.updateData);
            }
            await clearPendingScore(item.id);
          }
          // 4. EREDMÉNY MÓDOSÍTÁSOK
          else if (item.id && item.totalScore !== undefined) {
            if (!item.id.toString().startsWith('temp_')) {
              const pRef = doc(db, collectionName, competitionId, "participants", item.id);
              await updateDoc(pRef, {
                totalScore: item.totalScore,
                ...(item.shots ? { shots: item.shots } : {})
              });
            }
            await clearPendingScore(item.id);
          }
        } catch (itemErr) {
          console.error("Hiba az offline elem szinkronizálásakor:", item, itemErr);
        }
      }
      console.log("Offline szinkronizáció sikeresen befejeződött.");
    } catch (err) {
      console.error("Hiba az offline szinkronizációs motorban:", err);
    }
  };

  // 1b. Hálózati kapcsolat helyreállásának és induláskori szinkronizációjának figyelése
  useEffect(() => {
    if (!id) return;

    if (navigator.onLine) {
      syncPendingOfflineActions(id);
    }

    const handleOnline = () => {
      console.log("Internetkapcsolat helyreállt, offline szinkronizáció indítása...");
      syncPendingOfflineActions(id);
    };

    window.addEventListener('online', handleOnline);
    return () => window.removeEventListener('online', handleOnline);
  }, [id, isArchived]);

  // 2. Nevezők valós idejű betöltése ÉS ROBOT LOGIKA
  useEffect(() => {
    if (!id) return;

    // A gyűjtemény kiválasztása attól függően, hogy archivált-e
    const collectionName = isArchived ? "events_closed" : "events";
    const participantsRef = collection(db, collectionName, id, "participants");

    const unsubscribe = onSnapshot(participantsRef, async (snapshot) => {
      let participantsList = [];

      snapshot.forEach((doc) => {
        const data = { id: doc.id, ...doc.data() };
        participantsList.push(data);
      });

      // --- ÚJ: ÖNTISZTÍTÓ NEVEZŐSZÁM SZINKRONIZÁCIÓ (SELF-HEALING) ---
      const serverParticipantCount = snapshot.size;
      if (competition && Number(competition.participantsCount) !== serverParticipantCount && !isArchived && navigator.onLine) {
        try {
          const eventRef = doc(db, "events", id);
          updateDoc(eventRef, { participantsCount: serverParticipantCount });
        } catch (e) {
          console.error("Hiba a participantsCount önjavításakor:", e);
        }
      }

      // --- OFFLINE-FIRST: Mindig összefésüljük a helyi adatokat a szerveressel ---
      const offlineData = await getCompetitionOffline(id);
      if (offlineData.participants) {
        const firestoreIds = new Set(participantsList.map(p => p.id));
        // Megkeressük azokat, akik csak a laptopon léteznek még
        const onlyOffline = offlineData.participants.filter(p => !firestoreIds.has(p.id));
        participantsList = [...participantsList, ...onlyOffline];
      }

      // --- ÚJ: Mentett pontok és lövések összefésülése a LocalStorage-ból (GOLYÓÁLLÓ OFFLINE-FIRST) ---
      const savedScores = JSON.parse(localStorage.getItem(`scores_${id}`) || '{}');
      participantsList.forEach(p => {
        // 1. Összpontszám visszaállítása
        if (savedScores[p.id] !== undefined) {
          p.totalScore = savedScores[p.id];
        }

        // 2. Részletes lövések visszaállítása (ha a Firestore-ban még üres, de nekünk megvan)
        const localShots = allShotsByCompetitor[p.id];
        if (localShots && (!p.shots || p.shots.length === 0)) {
          p.shots = localShots;
          p.isManuallyEdited = true; // Jelöljük, hogy helyi adatot használunk
          if (!p.status) p.status = "Eredmény leadva (Offline)";
        }
      });

      // --- ÚJ: REGISZTRÁCIÓS PIPÁK SZINKRONIZÁLÁSA AZ INDEXEDDB / FIRESTORE ADATOKBÓL ---
      setLocalRegisteredIds(prev => {
        const updatedSet = new Set(prev);
        participantsList.forEach(p => {
          if (p.arrived === true) {
            updatedSet.add(p.id);
          }
        });
        return updatedSet;
      });

      participantsList.sort((a, b) => (a.fullName || '').localeCompare(b.fullName || '', 'hu'));
      setParticipants(participantsList);
    }, (error) => {
      console.error("Hiba a nevezők betöltésekor:", error);
    });

    return () => unsubscribe();
  }, [id, competition?.numberOfTargets, isArchived, allShotsByCompetitor]); // HOZZÁADVA: allShotsByCompetitor a stabil offline-fésüléshez

  const handleDragPointerMove = (e) => {
    const clientY = e.clientY || (e.touches && e.touches[0] ? e.touches[0].clientY : null);
    if (clientY !== null) {
      dragPointerYRef.current = clientY;
    }
  };

  const startAutoScrollLoop = () => {
    const scrollStep = () => {
      if (dragPointerYRef.current !== null) {
        const y = dragPointerYRef.current;
        const container = contentRef.current;
        const rect = container ? container.getBoundingClientRect() : { top: 0, bottom: window.innerHeight };
        const topEdge = rect.top || 0;
        const bottomEdge = rect.bottom || window.innerHeight;
        const edgeThreshold = 140;

        const performScroll = (deltaY) => {
          if (container && typeof container.scrollBy === 'function') {
            try { container.scrollBy(0, deltaY); } catch (e) {}
          }
          if (document.scrollingElement && typeof document.scrollingElement.scrollBy === 'function') {
            try { document.scrollingElement.scrollBy(0, deltaY); } catch (e) {}
          }
          if (document.documentElement && typeof document.documentElement.scrollBy === 'function') {
            try { document.documentElement.scrollBy(0, deltaY); } catch (e) {}
          }
          if (typeof window.scrollBy === 'function') {
            try { window.scrollBy(0, deltaY); } catch (e) {}
          }
        };

        if (y > bottomEdge - edgeThreshold) {
          const intensity = Math.min(1, (y - (bottomEdge - edgeThreshold)) / edgeThreshold);
          const speed = Math.max(8, Math.min(36, Math.round(intensity * 36)));
          performScroll(speed);
        } else if (y < topEdge + edgeThreshold) {
          const intensity = Math.min(1, ((topEdge + edgeThreshold) - y) / edgeThreshold);
          const speed = Math.max(8, Math.min(36, Math.round(intensity * 36)));
          performScroll(-speed);
        }
      }
      autoScrollAnimationRef.current = requestAnimationFrame(scrollStep);
    };

    if (!autoScrollAnimationRef.current) {
      autoScrollAnimationRef.current = requestAnimationFrame(scrollStep);
    }
  };

  const stopAutoScrollLoop = () => {
    if (autoScrollAnimationRef.current) {
      cancelAnimationFrame(autoScrollAnimationRef.current);
      autoScrollAnimationRef.current = null;
    }
    dragPointerYRef.current = null;
    window.removeEventListener('pointermove', handleDragPointerMove);
    window.removeEventListener('touchmove', handleDragPointerMove);
  };

  // Drag & Drop eseménykezelő (Csoportos mozgatás támogatással)
  const handleDragStart = (event) => {
    setActiveId(event.active.id);
    dragPointerYRef.current = null;
    window.addEventListener('pointermove', handleDragPointerMove);
    window.addEventListener('touchmove', handleDragPointerMove);
    startAutoScrollLoop();
  };

  const handleDragCancel = () => {
    stopAutoScrollLoop();
    setActiveId(null);
  };

  const handleDragOver = (event) => {
    // Húzás közben nem módosítjuk a state-et, hogy elkerüljük a dnd-kit visszaugrálási (snap-back) hibáját.
    // Az áthelyezés kizárólag a handleDragEnd-ben történik.
  };

  const handleDragEnd = async (event) => {
    stopAutoScrollLoop();
    const { active, over } = event;
    const dragId = active.id;
    setActiveId(null);

    if (!over) return;

    const activeParticipant = participants.find(p => p.id === dragId);
    if (!activeParticipant) return;

    let finalTeamId = undefined;
    const overParticipant = participants.find(p => p.id === over.id);

    if (over.id === 'pool') {
      finalTeamId = null; // Visszahúzás a várólistára (üres területre)
    } else if (overParticipant) {
      finalTeamId = overParticipant.team || null; // Ha az itemnek nincs csapata, akkor null (várólista)
    } else if (over.id.toString().startsWith('team-')) {
      finalTeamId = parseInt(over.id.toString().split('-')[1]);
    }

    if (finalTeamId !== undefined) {
      const movingMembers = activeParticipant.linkId
        ? participants.filter(p => p.linkId === activeParticipant.linkId)
        : [activeParticipant];

      // --- OPTIMISTA UI FRISSÍTÉS (Azonnal frissítjük a state-et, megőrizve a linkId-t) ---
      const movingIds = new Set(movingMembers.map(m => m.id));
      setParticipants(prev => prev.map(p => {
        if (movingIds.has(p.id)) {
          return {
            ...p,
            team: finalTeamId
          };
        }
        return p;
      }));

      try {
        // --- OFFLINE MENTÉS (Teljes modell átadásával) ---
        for (const member of movingMembers) {
          await updateParticipantOffline(member.id, { team: finalTeamId ?? null }, member);
        }

        if (navigator.onLine) {
          const batch = writeBatch(db);
          movingMembers.forEach(member => {
            if (!member.id.toString().startsWith('temp_')) {
              const pRef = doc(db, "events", id, "participants", member.id);
              batch.update(pRef, { team: finalTeamId ?? null });
            }
          });
          await batch.commit();
        }
      } catch (e) {
        console.error("Hiba a mentéskor:", e);
      }
    }
  };

  // --- LÁNCBONTÁS MEGERŐSÍTŐ KEZELŐ ---
  const handleConfirmUnlinkGroup = async () => {
    if (!unlinkLinkIdToConfirm) return;
    const targetLinkId = unlinkLinkIdToConfirm;
    const membersToUnlink = participants.filter(p => p.linkId === targetLinkId);
    setUnlinkLinkIdToConfirm(null);

    if (membersToUnlink.length === 0) return;

    try {
      setParticipants(prev => prev.map(p => p.linkId === targetLinkId ? { ...p, linkId: null } : p));

      for (const m of membersToUnlink) {
        await updateParticipantOffline(m.id, { linkId: null });
      }

      if (navigator.onLine) {
        const batch = writeBatch(db);
        membersToUnlink.forEach(m => {
          if (!m.id.toString().startsWith('temp_')) {
            const pRef = doc(db, "events", id, "participants", m.id);
            batch.update(pRef, { linkId: null });
          }
        });
        await batch.commit();
      }
    } catch (e) {
      console.error("Hiba a láncolás bontásakor:", e);
      alert("Hiba történt a láncolás bontása során.");
    }
  };

  // --- NEVEZŐ TÖRLÉSE FUNKCIÓ (MODAL NYITÁSA) ---
  const handleDeleteParticipant = (participant) => {
    if (isRegistrationClosed) return; // Ha lezárva, nem nyitható meg a törlés

    setParticipantToDelete(participant);
    setShowDeleteModal(true);
  };

  const handleLunchChange = (menuKey, delta, isEdit) => {
    if (isEdit) {
      setEditData(prev => {
        const currentSelections = prev.lunchSelections || {
          A: prev.selectedMenu === 'A' ? (prev.lunchCount || 0) : 0,
          B: prev.selectedMenu === 'B' ? (prev.lunchCount || 0) : 0,
          C: prev.selectedMenu === 'C' ? (prev.lunchCount || 0) : 0,
        };
        const newSelections = { ...currentSelections, [menuKey]: Math.max(0, (currentSelections[menuKey] || 0) + delta) };
        const newTotal = Object.values(newSelections).reduce((a, b) => a + b, 0);
        return { ...prev, lunchSelections: newSelections, lunchCount: newTotal };
      });
    } else {
      setNewParticipant(prev => {
        const currentSelections = prev.lunchSelections || { A: 0, B: 0, C: 0 };
        const newSelections = { ...currentSelections, [menuKey]: Math.max(0, (currentSelections[menuKey] || 0) + delta) };
        const newTotal = Object.values(newSelections).reduce((a, b) => a + b, 0);
        return { ...prev, lunchSelections: newSelections, lunchCount: newTotal };
      });
    }
  };

  // --- ÚJ: GYORS CSAPATCSERE LOGIKA ---
  const handleSwapTeams = async (sourceTeam, targetTeam) => {
    if (sourceTeam === targetTeam || isArchived || competition?.status === 'Lezárt') return;

    const sourceMembers = participants.filter(p => Number(p.team) === sourceTeam);
    const targetMembers = participants.filter(p => Number(p.team) === targetTeam);

    if (sourceMembers.length === 0 && targetMembers.length === 0) return;

    try {
      // 1. Optimista UI frissítés
      setParticipants(prev => prev.map(p => {
        if (Number(p.team) === sourceTeam) {
          return { ...p, team: targetTeam };
        }
        if (Number(p.team) === targetTeam) {
          return { ...p, team: sourceTeam };
        }
        return p;
      }));

      // 2. Offline IndexedDB mentés
      for (const m of sourceMembers) {
        await updateParticipantOffline(m.id, { team: targetTeam });
      }
      for (const m of targetMembers) {
        await updateParticipantOffline(m.id, { team: sourceTeam });
      }

      // 3. Online Firestore mentés
      if (navigator.onLine) {
        const batch = writeBatch(db);
        sourceMembers.forEach(m => {
          if (!m.id.toString().startsWith('temp_')) {
            const pRef = doc(db, "events", id, "participants", m.id);
            batch.update(pRef, { team: targetTeam });
          }
        });
        targetMembers.forEach(m => {
          if (!m.id.toString().startsWith('temp_')) {
            const pRef = doc(db, "events", id, "participants", m.id);
            batch.update(pRef, { team: sourceTeam });
          }
        });
        await batch.commit();
      }
    } catch (e) {
      console.error("Hiba a csapatok cseréjekor:", e);
      alert("Hiba történt a csapatok cseréje során.");
    }
  };

  // --- NEVEZŐ SZERKESZTÉSE FUNKCIÓ ---
  const handleSaveTeamAssignments = async () => {
    if (isArchived || competition?.status === 'Lezárt') {
      alert("A verseny le van zárva, a beosztás már nem módosítható.");
      return;
    }

    try {
      if (!navigator.onLine) {
        for (const p of participants) {
          await updateParticipantOffline(p.id, { team: p.team !== undefined ? p.team : null, linkId: p.linkId || null });
        }
        alert("Csapatbeosztás sikeresen elmentve offline módban! 🏹💾");
        return;
      }

      const batch = writeBatch(db);
      participants.forEach(p => {
        if (!p.id.toString().startsWith('temp_')) {
          const pRef = doc(db, "events", id, "participants", p.id);
          batch.update(pRef, {
            team: p.team !== undefined ? p.team : null,
            linkId: p.linkId || null
          });
        }
      });

      await batch.commit();
      alert("A csapatbeosztás sikeresen elmentve! ✅");
    } catch (e) {
      console.error("Hiba a csapatbeosztás mentésekor:", e);
      alert("Hiba történt a mentés során.");
    }
  };

  const handleEditClick = (p) => {
    if (isRegistrationClosed) return;

    // Inicializáljuk a lunchSelections-t a meglévő adatok alapján (visszafelé kompatibilitás)
    const initialSelections = p.lunchSelections || {
      A: p.selectedMenu === 'A' ? (p.lunchCount || 0) : 0,
      B: p.selectedMenu === 'B' ? (p.lunchCount || 0) : 0,
      C: p.selectedMenu === 'C' ? (p.lunchCount || 0) : 0,
    };

    setEditData({
      ...p,
      license: p.licenseNumber || p.license || '',
      lunchSelections: initialSelections
    });
    setShowEditModal(true);
  };

  const handleUpdateParticipant = async () => {
    if (!editData.fullName || !editData.bowCategory) {
      alert("A név és az íjkategória megadása kötelező!");
      return;
    }

    try {
      const newEntryFee = competition?.ageFees?.[editData.ageCategory] || editData.entryFee || '';
      const updateData = {
        fullName: editData.fullName,
        club: editData.club || 'Egyéb',
        bowCategory: editData.bowCategory,
        ageCategory: editData.ageCategory,
        gender: editData.gender,
        lunchCount: parseInt(editData.lunchCount) || 0,
        lunchSelections: editData.lunchSelections || { A: 0, B: 0, C: 0 },
        entryFee: newEntryFee,
        team: editData.team || null,
        license: editData.license || '',
        comment: editData.comment || ''
      };

      // 1. OPTIMISTA UI FRISSÍTÉS (Azonnali felületi reakció)
      setParticipants(prev => prev.map(p => p.id === editData.id ? { ...p, ...updateData } : p));

      // 2. OFFLINE INDEXEDDB MENTÉS (Mindig elmentjük a laptop memóriájába!)
      try {
        await updateParticipantOffline(editData.id, updateData);
      } catch (offErr) {
        console.warn("Helyi mentési hiba:", offErr);
      }

      // 3. ONLINE FIRESTORE MENTÉS (Ha van hálózat)
      if (navigator.onLine && !editData.id.toString().startsWith('temp_')) {
        try {
          const pRef = doc(db, "events", id, "participants", editData.id);
          await updateDoc(pRef, updateData);
        } catch (netErr) {
          console.warn("Firestore frissítés offline módba váltott:", netErr);
        }
      }

      // 4. MODAL BEZÁRÁSA MINDEN ESETBEN GARANTÁLTAN
      setShowEditModal(false);
      setEditData(null);
    } catch (error) {
      console.error("Hiba a frissítés során:", error);
      // Még váratlan hiba esetén is bezárjuk a modalt, hiszen a helyi mentés lefutott!
      setShowEditModal(false);
      setEditData(null);
    }
  };

  // --- MANUÁLIS NEVEZŐ MENTÉSE ---
  const handleSaveNewParticipant = async () => {
    if (isSavingParticipant) return; // VÉDELEM

    if (competition?.status === 'Lezárt' || competition?.status === 'Ready to Upload') {
      alert("A verseny le van zárva, új nevező már nem adható hozzá.");
      return;
    }

    if (!newParticipant.fullName || !newParticipant.fullName.trim() || !newParticipant.bowCategory) {
      alert("A név és az íjkategória megadása kötelező!");
      return;
    }

    setIsSavingParticipant(true);

    try {
      // 1. GENERÁLJUK A GUEST AZONOSÍTÓT (G001, G002...)
      const existingGuestNums = participants
        .filter(p => p.isGuest && p.userId?.startsWith('G'))
        .map(p => parseInt(p.userId.substring(1)) || 0);
      const storedMax = parseInt(localStorage.getItem(`max_guest_${id}`) || '0');
      const maxGuestNum = Math.max(storedMax, 0, ...existingGuestNums);
      const nextNum = maxGuestNum + 1;
      localStorage.setItem(`max_guest_${id}`, nextNum.toString());
      const guestUserId = `G${nextNum.toString().padStart(3, '0')}`;

      // 2. GENERÁLJUK A TELJES FIRESTORE DOKUMENTUM ID-T (ÉÉHHNNGxxx)
      const dateParts = (competition.competitionDate || '').split('-');
      const yy = dateParts[0]?.slice(-2) || '00';
      const mm = dateParts[1] || '00';
      const dd = dateParts[2] || '00';
      const finalDocId = `${yy}${mm}${dd}${guestUserId}`;

      const autoEntryFee = competition?.ageFees?.[newParticipant.ageCategory] || '';
      const finalClub = newParticipant.club.trim() === '' ? 'Egyéb' : newParticipant.club.trim();

      const pData = {
        ...newParticipant,
        id: finalDocId, // Azonosító rögzítése
        userId: guestUserId,
        club: finalClub,
        isGuest: true,
        entryFee: autoEntryFee,
        status: navigator.onLine ? 'Nevezve' : 'Nevezve (Offline)',
        createdAt: new Date().toISOString(),
        registeredVia: navigator.onLine ? 'web' : 'web-offline'
      };

      // --- OFFLINE ÁG ---
      if (!navigator.onLine) {
        await addParticipantOffline(id, pData);
        setParticipants(prev => [...prev, pData].sort((a, b) => a.fullName?.localeCompare(b.fullName)));
        alert(`Nevező (${finalDocId}) elmentve offline módba! 🏹💾`);
      } else {
        // --- ONLINE ÁG ---
        const collectionName = isArchived ? "events_closed" : "events";
        const batch = writeBatch(db);
        const newParticipantRef = doc(db, collectionName, id, "participants", finalDocId);

        batch.set(newParticipantRef, pData);
        batch.update(doc(db, collectionName, id), { participantsCount: increment(1) });
        await batch.commit();
      }

      // SIKERES MENTÉS UTÁN (Közös rész)
      setShowAddModal(false);
      setNewParticipant({
        fullName: '', club: '', bowCategory: '', ageCategory: 'felnott',
        gender: 'Férfi', lunchCount: 0, lunchSelections: { A: 0, B: 0, C: 0 }, comment: '', license: '', team: null
      });

    } catch (error) {
      console.error("Hiba a mentés során:", error);
      setShowAddModal(false);
      alert("Hiba történt a mentés közben!");
    } finally {
      setIsSavingParticipant(false);
      setShowAddModal(false);
    }
  };

  const handleFinalDeleteParticipant = async () => {
    if (!participantToDelete) return;

    try {
      // --- OPTIMISTA UI FRISSÍTÉS (Azonnal eltávolítjuk a listából) ---
      const deletedId = participantToDelete.id;
      setParticipants(prev => prev.filter(p => p.id !== deletedId));

      // --- HIVATALOS HELYI TÖRLÉS ÉS TOMBSTONE (MINDIG LEFUT ONLINE ÉS OFFLINE IS) ---
      await deleteParticipantOffline(deletedId, id);

      // Ha teljesen offline vagyunk, a Firestore részt kihagyjuk
      if (!navigator.onLine) {
        setShowDeleteModal(false);
        setParticipantToDelete(null);
        return;
      }

      // --- ONLINE TÖRLÉS (Ha nem temp ID) ---
      if (!deletedId.toString().startsWith('temp_')) {
        const collectionName = isArchived ? "events_closed" : "events";
        const batch = writeBatch(db);
        const pRef = doc(db, collectionName, id, "participants", deletedId);
        batch.delete(pRef);

        const eventRef = doc(db, collectionName, id);
        batch.update(eventRef, {
          participantsCount: increment(-1)
        });

        await batch.commit();
      }

      // --- SZINKRONIZÁCIÓ: Törlés a helyi regisztrációs listából is ---
      const newRegistered = new Set(localRegisteredIds);
      if (newRegistered.has(deletedId)) {
        newRegistered.delete(deletedId);
        setLocalRegisteredIds(newRegistered);
      }

      setShowDeleteModal(false);
      setParticipantToDelete(null);
    } catch (error) {
      console.error("Hiba a törlés során:", error);
      setShowDeleteModal(false);
      setParticipantToDelete(null);
      alert("Hiba történt a törlés közben!");
    }
  };

  const teamsData = useMemo(() => {
    const num = Number(competition?.numberOfTeams) || 20;
    const t = [];
    for (let i = 1; i <= num; i++) {
      t.push({
        number: i,
        members: participants.filter(p => Number(p.team) === i)
      });
    }
    return t;
  }, [participants, competition?.numberOfTeams]);

  // --- ÚJ: LÁNCOLÁSI LEBEGŐ BUBORÉK ADATOK ÉS RENDERELŐ ---
  const poolContainerRef = useRef(null);
  const [poolRect, setPoolRect] = useState(null);

  useEffect(() => {
    const updateRect = () => {
      if (poolContainerRef.current) {
        setPoolRect(poolContainerRef.current.getBoundingClientRect());
      }
    };

    updateRect();
    window.addEventListener('resize', updateRect);
    window.addEventListener('scroll', updateRect);
    return () => {
      window.removeEventListener('resize', updateRect);
      window.removeEventListener('scroll', updateRect);
    };
  }, [linkBaseId, activeTab]);

  const linkingData = useMemo(() => {
    if (!linkBaseId) return { baseParticipant: null, isBaseInPool: false, linkedMembers: [] };
    const base = participants.find(p => p.id === linkBaseId);
    if (!base) return { baseParticipant: null, isBaseInPool: false, linkedMembers: [] };

    const inPool = !base.team;
    const activeLinkId = base.linkId;
    const linked = activeLinkId
      ? participants.filter(p => p.linkId === activeLinkId && p.id !== base.id)
      : [];

    return {
      baseParticipant: base,
      isBaseInPool: inPool,
      linkedMembers: linked
    };
  }, [linkBaseId, participants]);

  const StaticParticipantCard = ({ participant, isLinkBase = false, onLinkClick, isInGroup = false }) => {
    const effectiveLinkId = participant.linkId || (isLinkBase ? `group_${participant.id}` : null);
    const linkColor = getLinkColor(effectiveLinkId);

    const style = {
      padding: '10px',
      backgroundColor: isLinkBase ? 'transparent' : '#f0f2f5',
      border: participant.linkId
        ? (isInGroup ? '1px solid #ddd' : `3px solid ${linkColor}`)
        : '1px solid #e0e0e0',
      borderRadius: '8px',
      marginBottom: isInGroup ? '4px' : '8px',
      fontSize: '0.85rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      position: 'relative',
      '--pulse-color': linkColor,
      animation: isLinkBase ? 'brutal-pulse 0.6s infinite linear' : 'none'
    };

    const catShort = (() => {
      const cat = participant.bowCategory || '';
      if (cat === 'tortenelmi_vadaszij' || cat === 'orom_vadaszij') return 'Vad.Reflex';
      if (cat === 'tortenelmi_vadaszij_fa' || cat === 'orom_vadaszij_fa') return 'Vadászíj (FA)';
      if (cat === 'tortenelmi_vadaszij_karbon' || cat === 'orom_vadaszij_karbon') return 'Vadászíj (KARB)';
      if (cat === 'tortenelmi_ij' || cat === 'orom_tortenelmi_ij') return 'Tört. íj';
      return cat.split('_').pop()?.toUpperCase() || '??';
    })();

    return (
      <div style={style}>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
          {onLinkClick && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onLinkClick(participant.id);
              }}
              style={{
                background: 'none',
                border: 'none',
                color: '#b30000',
                cursor: 'pointer',
                display: 'flex',
                padding: '2px',
                flexShrink: 0,
                marginTop: '1px'
              }}
              title="Összekötés másokkal"
            >
              <FiLink size={18} />
            </button>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', overflow: 'hidden' }}>
              {participant.registeredVia === 'android' && (
                <AiFillAndroid size={14} color="#3DDC84" style={{ flexShrink: 0 }} title="Android App felhasználó" />
              )}
              {participant.registeredVia === 'ios' && (
                <AiFillApple size={14} color="#999999" style={{ flexShrink: 0 }} title="iOS Webes nevező" />
              )}
              {participant.registeredVia === 'web' && (
                <FiGlobe size={14} color="#007bff" style={{ flexShrink: 0 }} title="Webes nevező" />
              )}
              <span style={{ fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.9rem' }}>
                {participant.fullName}
              </span>
            </div>

            <div style={{ fontSize: '0.75rem', color: '#888', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', marginTop: '1px' }}>
              {participant.club || 'Egyéni induló'}
            </div>

            <div style={{ display: 'flex', gap: '6px', alignItems: 'center', flexWrap: 'wrap', marginTop: '6px' }}>
              <span style={neutralBadgeStyle}>{catShort}</span>
              <span style={{ ...baseBadgeStyle, ...getAgeCategoryStyle(participant.ageCategory) }}>
                {translationMap[participant.ageCategory] || participant.ageCategory}
              </span>
              <span style={neutralBadgeStyle}>
                {participant.gender === 'Férfi' ? 'Férfi' : 'Nő'}
              </span>
            </div>
          </div>
        </div>

        {participant.comment && (
          <div style={{ ...teamCardCommentStyle, marginTop: '8px' }} title={participant.comment}>
            "{participant.comment}"
          </div>
        )}
      </div>
    );
  };

  const renderLinkingBubble = () => {
    if (!linkBaseId || !linkingData.isBaseInPool) return null;

    const activeLinkId = linkingData.baseParticipant?.linkId || `group_${linkBaseId}`;
    const allGroupMembers = participants.filter(p => (p.linkId && p.linkId === activeLinkId) || p.id === linkBaseId);

    return createPortal(
      <div style={{
        position: 'fixed',
        left: poolRect ? `${poolRect.left - 305}px` : 'calc(100vw - 625px)',
        top: poolRect ? `${Math.max(20, poolRect.top)}px` : '80px',
        width: '290px',
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '10px',
        boxShadow: '0 12px 36px rgba(0,0,0,0.3)',
        border: '2px solid #b30000',
        zIndex: 100000,
        animation: 'fadeIn 0.2s ease-in-out',
        pointerEvents: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
      }}>
        {/* HÁROMSZÖG NYÍL A JOBB FELSŐ SAROKBAN A VÁRÓLISTÁRA MUTATVA */}
        <div style={{
          position: 'absolute',
          right: '-12px',
          top: '18px',
          width: 0,
          height: 0,
          borderTop: '8px solid transparent',
          borderBottom: '8px solid transparent',
          borderLeft: '12px solid #b30000'
        }} />

        {/* LÁNCKERET A HIVATALOS KÁRTYÁIVAL */}
        <LinkedGroupWrapper linkId={activeLinkId}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', maxHeight: '240px', overflowY: 'auto' }}>
            {allGroupMembers.map(m => (
              <StaticParticipantCard
                key={m.id}
                participant={m}
                isLinkBase={linkBaseId === m.id}
                onLinkClick={handleToggleLink}
                isInGroup={true}
              />
            ))}
          </div>
        </LinkedGroupWrapper>

        {/* OK GOMB A LEZÁRÁSHOZ */}
        <button
          onClick={() => setLinkBaseId(null)}
          style={{
            backgroundColor: '#b30000',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '8px 12px',
            fontWeight: 'bold',
            fontSize: '0.85rem',
            cursor: 'pointer',
            width: '100%',
            boxShadow: '0 2px 6px rgba(179,0,0,0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px'
          }}
        >
          <FiCheck size={16} /> OK (Láncolás lezárása)
        </button>
      </div>,
      document.body
    );
  };

  // --- ÚJ: VÁRÓLISTA ADATOK ---
  const poolData = useMemo(() => {
    return participants
      .filter(p => !p.team)
      .filter(p => {
        // Ha van aktív linkBaseId a várólistán, a láncolt tagokat elrejtjük a listából, hogy ne duplázódjanak meg a lebegő buborékkal
        if (linkBaseId && linkingData.isBaseInPool) {
          const activeLinkId = linkingData.baseParticipant?.linkId;
          if (p.id === linkBaseId || (activeLinkId && p.linkId === activeLinkId)) {
            return false;
          }
        }

        // 1. Szöveges szűrés (Név vagy Egyesület)
        const term = poolSearchTerm.toLowerCase();
        const nameMatch = !term || p.fullName?.toLowerCase().includes(term);
        const clubMatch = !term || p.club?.toLowerCase().includes(term);

        // 2. Kategória szűrés
        const categoryMatch = !poolCategoryFilter || p.bowCategory === poolCategoryFilter;

        // 3. Korosztály szűrés
        const ageMatch = !poolAgeFilter || p.ageCategory === poolAgeFilter;

        return (nameMatch || clubMatch) && categoryMatch && ageMatch;
      })
      .sort((a, b) => {
        return (a.fullName || '').localeCompare(b.fullName || '', 'hu');
      });
  }, [participants, poolSearchTerm, poolCategoryFilter, poolAgeFilter, linkBaseId, linkingData]);

  // --- ÚJ: KARÓ SZÍN MEGHATÁROZÁSA A VERSENYZŐ KATEGÓRIÁJA ALAPJÁN ---
  const getPegColorForCompetitor = (p) => {
    if (!p) return 'blue';

    const age = (p.ageCategory || '').toLowerCase();
    if (age === 'gyerek' || age === 'mini') {
      return 'white'; // Gyerek & Mini -> Fehér karó
    }

    const cat = (p.bowCategory || '').toLowerCase();
    if (cat.includes('bg') || cat.includes('fuvocso')) {
      return 'white'; // Fúvócső -> Fehér karó
    }

    // Piros karó kategóriák (Csigások & Számszeríj)
    const isRedPegCat = cat.includes('cu') || cat.includes('hu') || cat.includes('crb') ||
                        cat.includes('szamszerij') || cat.includes('csigas') ||
                        cat.includes('fu') || cat.includes('bu') || cat.includes('fsc') ||
                        cat.includes('bl') || cat.includes('bhc');

    if (isRedPegCat) {
      return 'red';
    }

    // Minden egyéb kategória felnőtt/ifi/kadét -> Kék karó
    return 'blue';
  };

  // --- ÚJ: CÉLONKÉNTI ÉS KARÓNKÉNTI ÁTLAGPONTSZÁM (VESSZŐÁTLAG) SZÁMÍTÁSA ---
  const targetAverages = useMemo(() => {
    const averages = {};
    const numTargets = Number(competition?.numberOfTargets) || 20;

    for (let t = 1; t <= numTargets; t++) {
      averages[t] = {
        red: { sum: 0, count: 0, avg: null },
        blue: { sum: 0, count: 0, avg: null },
        white: { sum: 0, count: 0, avg: null }
      };
    }

    participants.forEach(p => {
      const peg = getPegColorForCompetitor(p);
      const shots = p.shots || allShotsByCompetitor[p.id] || [];

      shots.forEach(s => {
        const targetNum = Number(s.target);
        if (targetNum && averages[targetNum]) {
          const valStr = s.value;
          const score = valStr === 'X' ? 11 : (parseInt(valStr, 10) || 0);
          averages[targetNum][peg].sum += score;
          averages[targetNum][peg].count += 1;
        }
      });
    });

    Object.keys(averages).forEach(t => {
      ['red', 'blue', 'white'].forEach(peg => {
        const item = averages[t][peg];
        if (item.count > 0) {
          item.avg = (item.sum / item.count).toFixed(1).replace('.', ',');
        }
      });
    });

    return averages;
  }, [participants, allShotsByCompetitor, competition?.numberOfTargets]);

  const resultsData = useMemo(() => {
    let filtered = participants.filter(p =>
      p.fullName?.toLowerCase().includes(resultsSearchTerm.toLowerCase()) ||
      p.club?.toLowerCase().includes(resultsSearchTerm.toLowerCase())
    );

    if (teamFilter !== null && !resultsSearchTerm.trim()) {
      filtered = filtered.filter(p => Number(p.team) === teamFilter);
    }

    const groups = {};
    filtered.forEach(p => {
      // Csak a hivatalosan visszalépett/törölt versenyzőket zárjuk ki az eredményekből
      if (p.isCancelled) {
        return;
      }

      const key = getCategoryKey(p);
      if (!groups[key]) {
        groups[key] = {
          bowCategory: p.bowCategory,
          ageCategory: p.ageCategory,
          gender: p.gender,
          scoredMembers: [],
          unscoredMembers: []
        };
      }

      if (p.totalScore !== undefined) {
        groups[key].scoredMembers.push(p);
      } else {
        groups[key].unscoredMembers.push(p);
      }
    });

    // --- SEGÉDFÜGGVÉNY A RÉSZLETES ÖSSZEHASONLÍTÁSHOZ ---
    const compareCompetitors = (a, b) => {
      const scoreA = Number(a.totalScore);
      const scoreB = Number(b.totalScore);

      // 1. Alap pontszám ellenőrzése
      if (scoreB !== scoreA) return scoreB - scoreA;

      // 2. Ha a pontszám egyenlő, végigmegyünk a beállított szabályokon sorrendben
      const rules = competition?.tieBreakingRules || [];
      const getZoneCount = (p, zoneKeys) => {
        const shots = p.shots || allShotsByCompetitor[p.id] || [];
        return shots.filter(s => zoneKeys.includes(s.value)).length;
      };

      for (const rule of rules) {
        if (rule === 'more_elevens_xs') {
          const diff = getZoneCount(b, ['11', 'X']) - getZoneCount(a, ['11', 'X']);
          if (diff !== 0) return diff;
        }
        if (rule === 'more_tens') {
          const diff = getZoneCount(b, ['10']) - getZoneCount(a, ['10']);
          if (diff !== 0) return diff;
        }
        if (rule === 'more_eights') {
          const diff = getZoneCount(b, ['8']) - getZoneCount(a, ['8']);
          if (diff !== 0) return diff;
        }
        if (rule === 'more_fives') {
          const diff = getZoneCount(b, ['5']) - getZoneCount(a, ['5']);
          if (diff !== 0) return diff;
        }
        if (rule === 'fewer_zeros') {
          const diff = getZoneCount(a, ['0']) - getZoneCount(b, ['0']); // Itt a kevesebb a jobb!
          if (diff !== 0) return diff;
        }
      }

      // 3. Ha minden szabály után is egyenlőek, megnézzük, van-e rögzített Szétlövés eredmény (shootOffRank)
      // A KISEBB rank a jobb (1. hely jobb, mint a 2.)
      const rankA = a.shootOffRank || 999;
      const rankB = b.shootOffRank || 999;
      if (rankA !== rankB) {
        return rankA - rankB;
      }

      // 4. Ha még a szétlövés eredmény is hiányzik (vagy egyenlő), akkor abszolút döntetlen
      return 0;
    };

    Object.values(groups).forEach(group => {
      // 1. RANGSOROLTAK RENDEZÉSE AZ ÚJ LOGIKÁVAL
      group.scoredMembers.sort(compareCompetitors);

      // 2. VÁRAKOZÓK RENDEZÉSE NÉVSORBAN
      group.unscoredMembers.sort((a, b) => a.fullName?.localeCompare(b.fullName));

      // 3. SZÉTLÖVÉS (PIROS KIEMELÉS) JELÖLÉSE ÉS CSOPORTKÉPZÉS
      // Csak akkor jelöljük, ha a szabályok között ott van a 'shoot_off' (Szétlövés)
      const hasShootOffRule = competition?.tieBreakingRules?.includes('shoot_off');
      let currentShootOffGroupId = 0;

      for (let i = 0; i < group.scoredMembers.length; i++) {
        const current = group.scoredMembers[i];
        const prev = group.scoredMembers[i - 1];
        const next = group.scoredMembers[i + 1];

        // Döntetlen ellenőrzése (Ha a compare 0-t ad, akkor 100% egyenlőek)
        const tiedWithPrev = prev && compareCompetitors(current, prev) === 0;
        const tiedWithNext = next && compareCompetitors(current, next) === 0;

        if (hasShootOffRule && (tiedWithPrev || tiedWithNext)) {
          current.needsShootOff = true;

          // Ha ez egy új csoport kezdete
          if (!tiedWithPrev) {
            currentShootOffGroupId++;
            current.shootOffGroupId = currentShootOffGroupId;
            current.isShootOffStart = true;
          } else {
            // Ha folytatása egy csoportnak
            current.shootOffGroupId = currentShootOffGroupId;
            current.isShootOffStart = false;
          }

          // Ha ez a csoport vége
          if (!tiedWithNext) {
            current.isShootOffEnd = true;
          } else {
            current.isShootOffEnd = false;
          }

        } else {
          current.needsShootOff = false;
          current.shootOffGroupId = null;
        }
      }

      // 4. TAGOK ÖSSZEFŰZÉSE
      group.members = [...group.scoredMembers, ...group.unscoredMembers];
    });

    return Object.values(groups).sort((a, b) => {
      // 1. Íjkategória (ABC - Lefordított név alapján)
      const bowA = translationMap[a.bowCategory] || a.bowCategory;
      const bowB = translationMap[b.bowCategory] || b.bowCategory;
      const bowComp = bowA.localeCompare(bowB, 'hu');
      if (bowComp !== 0) return bowComp;

      // 2. Korosztály (Súlyozott sorrend a globális konstansból)
      // FONTOS: Ez garantálja, hogy a Gyerek (2) megelőzze a Felnőttet (7)
      const ageA = AGE_ORDER[a.ageCategory] || 99;
      const ageB = AGE_ORDER[b.ageCategory] || 99;
      if (ageA !== ageB) return ageA - ageB;

      // 3. Nem (Nők előre)
      const genderA = a.gender === 'Nő' ? 0 : 1;
      const genderB = b.gender === 'Nő' ? 0 : 1;
      return genderA - genderB;
    });
  }, [participants, resultsSearchTerm, allShotsByCompetitor, competition?.tieBreakingRules, isRegistrationClosed, localRegisteredIds]);

  // --- ÚJ: ÉREM SZÁMLÁLÓ LOGIKA ---
  const medalStats = useMemo(() => {
    let gold = 0, silver = 0, bronze = 0;
    resultsData.forEach(group => {
      const count = group.members.length;
      if (count >= 1) gold++;
      if (count >= 2) silver++;
      if (count >= 3) bronze++;
    });
    return { gold, silver, bronze };
  }, [resultsData]);

  const teamLeaderboardData = useMemo(() => {
    return teamsData
      .map(t => {
        const validMembers = t.members.filter(m => m.totalScore !== undefined);
        const totalScore = validMembers.reduce((sum, m) => sum + (Number(m.totalScore) || 0), 0);
        return {
          ...t,
          validMembersCount: validMembers.length,
          totalScore
        };
      })
      .filter(t => t.members.length > 0)
      .sort((a, b) => b.totalScore - a.totalScore);
  }, [teamsData]);

  const topShootersData = useMemo(() => {
    const catMap = {};
    const allScored = [];
    participants.forEach(p => {
      if (p.totalScore !== undefined) {
        allScored.push(p);
        const cat = p.bowCategory || 'egyeb';
        if (!catMap[cat]) catMap[cat] = [];
        catMap[cat].push(p);
      }
    });

    const categories = Object.keys(catMap).map(catKey => {
      const members = catMap[catKey].sort((a, b) => (b.totalScore || 0) - (a.totalScore || 0)).slice(0, 3);
      return {
        bowCategory: catKey,
        label: translationMap[catKey] || catKey,
        isSighted: isSightedCategory(catKey),
        members
      };
    });

    const sightlessCategories = categories.filter(c => !c.isSighted).sort((a, b) => a.label.localeCompare(b.label, 'hu'));
    const sightedCategories = categories.filter(c => c.isSighted).sort((a, b) => a.label.localeCompare(b.label, 'hu'));

    const sightlessScored = allScored.filter(p => !isSightedCategory(p.bowCategory)).sort((a, b) => (b.totalScore || 0) - (a.totalScore || 0));
    const sightedScored = allScored.filter(p => isSightedCategory(p.bowCategory)).sort((a, b) => (b.totalScore || 0) - (a.totalScore || 0));

    return {
      sightless: sightlessCategories,
      sighted: sightedCategories,
      sightlessBest: sightlessScored[0] || null,
      sightedBest: sightedScored[0] || null
    };
  }, [participants]);

  const renderAbsoluteTopCard = (bestShooter, accentColor, title) => {
    if (!bestShooter) return null;
    return (
      <div style={{
        ...mainCardStyle,
        margin: 0,
        padding: '15px 20px',
        minHeight: 'auto',
        backgroundColor: '#fff',
        border: `2px solid ${accentColor}`,
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontSize: '2rem' }}>👑</span>
          <div>
            <div style={{ fontSize: '0.75rem', fontWeight: 'bold', color: accentColor, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              {title}
            </div>
            <div style={{ fontWeight: 'bold', fontSize: '1.05rem', color: '#333', marginTop: '2px' }}>
              {bestShooter.fullName}
            </div>
            <div style={{ fontSize: '0.75rem', color: '#666', marginTop: '1px' }}>
              {translationMap[bestShooter.ageCategory] || bestShooter.ageCategory} • {formatClubName(bestShooter.club) || '-'} ({translationMap[bestShooter.bowCategory] || bestShooter.bowCategory})
            </div>
          </div>
        </div>
        <div style={{ fontSize: '1.3rem', fontWeight: 'bold', color: accentColor, backgroundColor: '#f8f9fa', padding: '8px 14px', borderRadius: '8px', border: '1px solid #eee' }}>
          {bestShooter.totalScore} pont
        </div>
      </div>
    );
  };

  // --- ÚJ: BEREGISZTRÁLTAK (MEGÉRKEZETTEK) SZÁMÍTÁSA (PONTOSÍTVA) ---
  const arrivedCount = useMemo(() => {
    // Akkor számít megérkezettnek, ha be van pipálva VAGY már van pontszáma (másik eszközről rögzítették)
    return participants.filter(p => localRegisteredIds.has(p.id) || p.totalScore !== undefined).length;
  }, [participants, localRegisteredIds]);

  // --- ÚJ: DASHBOARD STATISZTIKÁK ---
  const dashboardStats = useMemo(() => {
    const stats = {
      totalLunches: 0,
      totalEntryFees: 0,
      totalLunchFees: 0,
      expectedEntryFees: 0,
      expectedLunchFees: 0,
      expectedTotal: 0,
      categories: {},
      arrivedLunches: 0,
      menuCounts: { A: 0, B: 0, C: 0 } // ÚJ: Menü szerinti számláló
    };

    participants.forEach(p => {
      const count = Number(p.lunchCount) || 0;
      stats.totalLunches += count;

      // --- EXPECTED (Mindenki) ---
      const effectiveEntryFee = Number(competition?.ageFees?.[p.ageCategory]) || Number(p.entryFee) || 0;
      let expectedLunchFee = 0;
      if (count > 0 && !competition?.lunchPaidElsewhere) {
        if (p.lunchSelections) {
          Object.entries(p.lunchSelections).forEach(([menuKey, amount]) => {
            const price = Number(competition?.lunches?.[menuKey]?.price) ||
                          (menuKey === 'A' ? (Number(competition?.lunchPrice) || 0) : 0);
            expectedLunchFee += amount * price;
          });
        } else {
          const menuKey = p.selectedMenu || 'A';
          const price = Number(competition?.lunches?.[menuKey]?.price) || Number(competition?.lunchPrice) || 0;
          expectedLunchFee = count * price;
        }
      }
      stats.expectedEntryFees += effectiveEntryFee;
      stats.expectedLunchFees += expectedLunchFee;

      // --- ÚJ: DINAMIKUS MENÜ SZÁMLÁLÁS ---
      if (count > 0) {
        if (p.lunchSelections) {
          // Ha már van új típusú elosztás (térkép)
          Object.entries(p.lunchSelections).forEach(([menuKey, amount]) => {
            if (stats.menuCounts[menuKey] !== undefined) {
              stats.menuCounts[menuKey] += amount;
            }
          });
        } else if (p.selectedMenu) {
          // Ha régi típusú egyedi választás van
          stats.menuCounts[p.selectedMenu] += count;
        } else {
          // Alapértelmezett (régi nevezőknek)
          stats.menuCounts.A += count;
        }
      }

      const isArrived = localRegisteredIds.has(p.id) || p.totalScore !== undefined;

      if (isArrived) {
        stats.arrivedLunches += count;

        // Pénzügy - CSAK A MEGÉRKEZETTEKET SZÁMOLJUK!
        stats.totalEntryFees += effectiveEntryFee;
        stats.totalLunchFees += expectedLunchFee;
      }

      // Kategóriák
      const catKey = p.bowCategory || 'Ismeretlen';
      if (!stats.categories[catKey]) {
        stats.categories[catKey] = { label: translationMap[catKey] || catKey, count: 0, arrived: 0 };
      }
      stats.categories[catKey].count++;
      if (isArrived) {
        stats.categories[catKey].arrived++;
      }
    });

    stats.expectedTotal = stats.expectedEntryFees + stats.expectedLunchFees;
    return stats;
  }, [participants, localRegisteredIds, competition?.lunchPrice, competition?.lunches, competition?.ageFees]);

  // --- ÚJ: REGISZTRÁCIÓ KEZELÉSE (ADATBÁZIS SZINKRONNAL) ---
  const handleToggleRegistrationLock = async () => {
    const newState = !isRegistrationClosed;
    setIsRegistrationClosed(newState);

    // --- ÚJ: OFFLINE TÁMOGATÁS ---
    if (!navigator.onLine) {
      try {
        await saveCompetitionUpdateOffline(id, { registrationClosed: newState });
        alert(`Offline: Regisztráció ${newState ? 'lezárva' : 'megnyitva'} a gépen! 💾`);
        return;
      } catch (e) {
        console.error("Offline hiba:", e);
      }
    }

    try {
      await updateDoc(doc(db, "events", id), { registrationClosed: newState });
    } catch (e) {
      console.error("Hiba a regisztráció állapot mentésekor:", e);
      // Fallback: mentsük el offline ha a hálózat menet közben szakadt meg
      await saveCompetitionUpdateOffline(id, { registrationClosed: newState });
    }
  };

  const handlePaidPayment = () => {
    setPaymentGroup([]);
    setShowPaymentUI(false);
    if (paymentTimer.current) clearTimeout(paymentTimer.current);
  };

  const handleCancelPayment = () => {
    // Visszavonjuk a regisztrációt azoknál, akik a fizetési listában vannak
    const newRegistered = new Set(localRegisteredIds);
    paymentGroup.forEach(p => {
      newRegistered.delete(p.id);
    });
    setLocalRegisteredIds(newRegistered);

    // Panel bezárása
    setPaymentGroup([]);
    setShowPaymentUI(false);
    if (paymentTimer.current) clearTimeout(paymentTimer.current);
  };

  const handleToggleRegistration = async (participantId) => {
    if (isRegistrationClosed || isArchived) return;

    const newRegistered = new Set(localRegisteredIds);
    const isAdding = !newRegistered.has(participantId);

    if (isAdding) {
      newRegistered.add(participantId);

      const participant = participants.find(p => p.id === participantId);
      if (participant) {
        setPaymentGroup(prev => [...prev, participant]);
        setShowPaymentUI(true);
      }
    } else {
      newRegistered.delete(participantId);
      // Ha kivesszük a pipát, vegyük le a fizetési listáról is
      setPaymentGroup(prev => {
        const newList = prev.filter(p => p.id !== participantId);
        if (newList.length === 0) setShowPaymentUI(false);
        return newList;
      });
    }

    setLocalRegisteredIds(newRegistered);

    // Frissítjük a participants memóriabeli állapotát
    setParticipants(prev => prev.map(p =>
      p.id === participantId ? { ...p, arrived: isAdding } : p
    ));

    // IndexedDB offline mentés
    try {
      await updateParticipantOffline(participantId, { arrived: isAdding });
    } catch (e) {
      console.warn("IndexedDB pipa mentési hiba:", e);
    }

    // --- ÚJ: OFFLINE TÁMOGATÁS A REGISZTRÁCIÓHOZ (PIPA) ---
    if (!navigator.onLine) {
        saveScoreOffline(id, participantId, {
            arrived: isAdding,
            status: isAdding ? "Eredmény leadva (Offline)" : "Nevezve (Offline)",
        });
    } else {
        // ONLINE: Frissítjük a Firestore-t is azonnal
        if (!participantId.toString().startsWith('temp_')) {
          const pRef = doc(db, "events", id, "participants", participantId);
          updateDoc(pRef, { arrived: isAdding, status: isAdding ? "Eredmény leadva" : "Nevezve" })
              .catch(err => console.error("Firestore pipa hiba:", err));
        }
    }
  };

  // --- ÚJ: MANUÁLIS FÁJLMENTÉS (CSV) ---
  const handleDownloadBackup = () => {
    const registeredList = participants
      .filter(p => localRegisteredIds.has(p.id))
      .map(p => `${p.fullName},${translationMap[p.bowCategory] || p.bowCategory},${translationMap[p.ageCategory] || p.ageCategory},${p.club || '-'}`)
      .join('\n');

    const header = "Név,Kategória,Korosztály,Egyesület\n";
    const blob = new Blob([header + registeredList], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `regisztraltak_${competition?.competitionName || 'lista'}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // --- ÚJ: NATIVE EXCEL EXPORTÁLÁS (.xlsx) ---
  const handleExportToExcel = () => {
    if (!participants || participants.length === 0) {
      alert("Nincs exportálható adat!");
      return;
    }

    // 1. Adatok előkészítése JSON formátumban magyar oszlopnevekkel (MINDIG A TELJES LISTA)
    const exportData = participants.map(p => {
      const displayId = generateParticipantId(p);
      const entryFee = competition?.ageFees?.[p.ageCategory] || p.entryFee || 0;
      // --- DINAMIKUS EBÉDÁR SZÁMÍTÁS EXCELHEZ ---
      let lunchFee = 0;
      if (Number(p.lunchCount) > 0) {
        if (p.lunchSelections) {
          Object.entries(p.lunchSelections).forEach(([menuKey, amount]) => {
            const price = Number(competition?.lunches?.[menuKey]?.price) ||
                          (menuKey === 'A' ? (Number(competition?.lunchPrice) || 0) : 0);
            lunchFee += amount * price;
          });
        } else {
          const menuKey = p.selectedMenu || 'A';
          const price = Number(competition?.lunches?.[menuKey]?.price) || Number(competition?.lunchPrice) || 0;
          lunchFee = Number(p.lunchCount) * price;
        }
      }
      const isArrived = localRegisteredIds.has(p.id) ? "Igen" : "Nem";

      return {
        "ID.": displayId,
        "Név": p.fullName || "",
        "Egyesület": p.club || "-",
        "Csapat": p.team || "-",
        "Engedély": p.licenseNumber || p.license || "-",
        "Kategória": translationMap[p.bowCategory] || p.bowCategory || "",
        "Korosztály": translationMap[p.ageCategory] || p.ageCategory || "",
        "Nem": p.gender || "",
        "Nevezési díj (Ft)": Number(entryFee) || 0,
        "Ebéd adag": Number(p.lunchCount) || 0,
        "Ebéd díja (Ft)": Number(lunchFee) || 0,
        "Megjegyzés": p.comment || "",
        "Megérkezett": isArrived
      };
    });

    // 2. Munkafüzet létrehozása
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Nevezők");

    // 3. Oszlopszélességek beállítása
    const wscols = [
      {wch: 12}, {wch: 25}, {wch: 25}, {wch: 8}, {wch: 12}, {wch: 20},
      {wch: 15}, {wch: 8}, {wch: 15}, {wch: 12}, {wch: 15}, {wch: 30}, {wch: 12}
    ];
    worksheet['!cols'] = wscols;

    // 4. Fájl letöltése
    const fileName = `nevezok_${competition?.competitionName?.replace(/\s+/g, '_') || 'lista'}_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  // --- ÚJ: EREDMÉNYEK EXPORTÁLÁSA EXCELBE ---
  const handleExportResultsToExcel = () => {
    if (!resultsData || resultsData.length === 0) {
      alert("Nincs exportálható eredmény!");
      return;
    }

    const exportData = [];
    const merges = []; // Cellaösszevonások a kategória fejlécekhez
    const isPodiumOnly = resultsExportType === 'podium';

    // Egységes 4 letisztult oszlop mindkét export típusnál
    const headers = ["Hely.", "Név", "Egyesület", "Összpontszám"];
    const maxColIndex = 3;

    resultsData.forEach(group => {
      const groupName = `${translationMap[group.bowCategory] || group.bowCategory} - ${translationMap[group.ageCategory] || group.ageCategory} - ${group.gender}`;

      const membersToExport = isPodiumOnly
        ? group.scoredMembers.slice(0, 3)
        : group.members.filter(p => p.totalScore !== undefined);

      if (membersToExport.length === 0) return;

      // 1. Kategória megnevezése sor + cellaösszevonás mind a 4 oszlopra (c: 0 .. c: 3)
      const groupHeaderRowIndex = exportData.length;
      merges.push({ s: { r: groupHeaderRowIndex, c: 0 }, e: { r: groupHeaderRowIndex, c: maxColIndex } });

      const groupHeaderRow = {};
      headers.forEach(h => groupHeaderRow[h] = h === "Hely." ? groupName : "");
      exportData.push(groupHeaderRow);

      // 2. Belső fejléc sor
      const subHeaderRow = {};
      headers.forEach(h => subHeaderRow[h] = h);
      exportData.push(subHeaderRow);

      // 3. Versenyzők adatai
      membersToExport.forEach((p) => {
        const rank = group.scoredMembers.indexOf(p) + 1;
        const row = {};

        row["Hely."] = `${rank}.`;
        row["Név"] = p.fullName || "";
        row["Egyesület"] = p.club || "Egyéni induló";
        row["Összpontszám"] = p.totalScore || 0;
        exportData.push(row);
      });

      // 4. Üres sor
      const emptyRow = {};
      headers.forEach(h => emptyRow[h] = "");
      exportData.push(emptyRow);
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData, { header: headers, skipHeader: true });
    worksheet['!merges'] = merges; // Cellaösszevonások hozzáadása

    // A4 Álló Lapra Igazított Nyomtatási Paraméterek (fitToWidth: 1)
    worksheet['!pageSetup'] = {
      fitToWidth: 1,
      fitToHeight: 0,
      orientation: 'portrait',
      paperSize: 9
    };

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Eredmények");

    const wscols = [{wch: 8}, {wch: 22}, {wch: 22}, {wch: 12}];
    worksheet['!cols'] = wscols;

    const typeLabel = isPodiumOnly ? 'dobogosok' : 'teljes';
    const fileName = `eredmenyek_${typeLabel}_${competition?.competitionName?.replace(/\s+/g, '_') || 'lista'}_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(workbook, fileName);
    setShowResultsExportModal(false);
  };

// --- CSAPAT QR-KÓD DEKÓDOLÁSA (ELŐNÉZET PREPARÁLÁS + DARABOLÁS TÁMOGATÁS) ---
  const handleQrScanResult = (qrString) => {
    if (!qrString || qrString.length < 15) {
      return null;
    }

    try {
      const version = qrString.substring(0, 2);
      let sessionHash = null;
      let totalParts = 1;
      let partIndex = 1;
      let headerOffset = 2;

      if (version === "03") {
        sessionHash = qrString.substring(2, 6);
        totalParts = parseInt(qrString.substring(6, 8), 10) || 1;
        partIndex = parseInt(qrString.substring(8, 10), 10) || 1;
        headerOffset = 10;
      }

      // 1. Fejléc adatok kiolvasása
      const targetCount = parseInt(qrString.substring(headerOffset + 1, headerOffset + 4), 10);
      const positiveScoresCount = parseInt(qrString.substring(headerOffset + 4, headerOffset + 5), 16);

      const totalScoreValuesCount = positiveScoresCount + 1;
      const scoreValues = [];
      let cursor = headerOffset + 5;

      for (let i = 0; i < totalScoreValuesCount; i++) {
        const valStr = qrString.substring(cursor, cursor + 2);
        scoreValues.push(parseInt(valStr, 10));
        cursor += 2;
      }

      const startingTarget = parseInt(qrString.substring(cursor, cursor + 3), 10);
      cursor += 3;

      const scannedCompetitorsDetails = [];

      // INTELLIGENS ZÓNA CÍMKE ÉS PONTSZÁM LEKÉPEZÉS A VERSENY SAJÁT SZABÁLYAI ALAPJÁN
      const competitionScoringValues = competition?.scoringValues || [];
      const hasXInScoring = competitionScoringValues.includes('X');
      const has11InScoring = competitionScoringValues.includes('11');

      const numericZones = competitionScoringValues
        .map(v => parseInt(v))
        .filter(n => !isNaN(n));
      const maxCompetitionZoneScore = numericZones.length > 0 ? Math.max(...numericZones) : 10;

      // Címkék előállítása: ha a versenyben 'X' van és nincs 11-es (pl. IFAA/WA), az '11' kódú zónát 'X'-nek címkézzük
      const scoreLabels = scoreValues.map(v => {
        if (v === 11 && hasXInScoring && !has11InScoring) {
          return 'X';
        }
        return v.toString();
      });

      // Tényleges pontértékek leképezése: ha '11' kód érkezett egy IFAA/WA versenyen ('X' van, '11' nincs),
      // akkor a pontértéke a verseny maximális zónája (IFAA-nál 5, WA-nál 10)!
      const adjustedScoreValues = scoreValues.map(v => {
        if (v === 11 && hasXInScoring && !has11InScoring) {
          return maxCompetitionZoneScore;
        }
        return v;
      });

      // 2. Versenyzők feldolgozása a 10 KARAKTERES azonosító alapján
      while (cursor < qrString.length) {
        const rawId = qrString.substring(cursor, cursor + 10).trim();
        const shotsPerTarget = parseInt(qrString.substring(cursor + 10, cursor + 12), 10);
        cursor += 12;

        const totalShotsForCompetitor = targetCount * shotsPerTarget;
        let competitorTotalScore = 0;
        const competitorShots = [];

        const hitZoneCounts = {};
        scoreLabels.forEach(label => { hitZoneCounts[label] = 0; });

        for (let s = 0; s < totalShotsForCompetitor; s++) {
          if (cursor >= qrString.length) break;
          const hexIndex = parseInt(qrString.substring(cursor, cursor + 1), 16);
          cursor += 1;

          const scoreVal = adjustedScoreValues[hexIndex] !== undefined ? adjustedScoreValues[hexIndex] : 0;
          const label = scoreLabels[hexIndex] || '0';
          competitorTotalScore += scoreVal;

          if (hitZoneCounts[label] !== undefined) {
            hitZoneCounts[label] = (hitZoneCounts[label] || 0) + 1;
          } else if (label.length <= 2) {
             hitZoneCounts[label] = 1;
          }

          competitorShots.push({
            value: label.length > 2 ? scoreVal.toString() : label,
            sum: scoreVal,
            target: Math.floor(s / shotsPerTarget) + 1,
            position: (s % shotsPerTarget) + 1
          });
        }

        // PONTOS MATCH A TELJES AZONOSÍTÓ ALAPJÁN
        const participant = participants.find(p => {
          const fullId = generateParticipantId(p);
          return fullId === rawId || p.userId === rawId || p.id === rawId;
        });

        if (participant) {
          scannedCompetitorsDetails.push({
            id: participant.id,
            fullName: participant.fullName,
            bowCategory: translationMap[participant.bowCategory] || participant.bowCategory,
            ageCategory: translationMap[participant.ageCategory] || participant.ageCategory,
            gender: participant.gender || '-',
            totalScore: competitorTotalScore,
            hitZoneCounts: hitZoneCounts,
            shots: competitorShots
          });
        } else {
          scannedCompetitorsDetails.push({
            id: rawId,
            fullName: `Ismeretlen nevező (ID: ${rawId})`,
            bowCategory: '-',
            ageCategory: '-',
            gender: '-',
            totalScore: competitorTotalScore,
            hitZoneCounts: hitZoneCounts,
            shots: competitorShots
          });
        }
      }

      // --- Sima "02" vagy 1 darabos kód esetén azonnal visszatérünk ---
      if (version === "02" || totalParts <= 1) {
        setQrProgressInfo(null);
        return scannedCompetitorsDetails;
      }

      // --- "03" Darabolt QR esetén az akkumulációs logika (LOKÁLIS BÖNGÉSZŐ RAM MEGFOGÁS) ---
      if (!qrSessionsRef.current[sessionHash]) {
        qrSessionsRef.current[sessionHash] = { totalParts, parts: {} };
      }

      const activeSession = qrSessionsRef.current[sessionHash];

      if (!activeSession.parts[partIndex]) {
        activeSession.parts[partIndex] = scannedCompetitorsDetails;
      }

      const receivedIndices = Object.keys(activeSession.parts).map(Number).sort((a, b) => a - b);
      const receivedCount = receivedIndices.length;

      setQrProgressInfo({
        receivedCount,
        totalParts,
        receivedPartIndices: receivedIndices
      });

      if (receivedCount >= totalParts) {
        let combinedCompetitors = [];
        for (let pIdx = 1; pIdx <= totalParts; pIdx++) {
          if (activeSession.parts[pIdx]) {
            combinedCompetitors = [...combinedCompetitors, ...activeSession.parts[pIdx]];
          }
        }

        delete qrSessionsRef.current[sessionHash];

        setTimeout(() => setQrProgressInfo(null), 1500);
        return combinedCompetitors;
      } else {
        return null;
      }

    } catch (error) {
      console.error("Hiba a QR kód dekódolásakor:", error);
      return null;
    }
  };

  const handleCancelPartialScan = () => {
    setQrProgressInfo(null);
    qrSessionsRef.current = {};
  };

  // --- MENTÉS AZ EREDMÉNYEKHEZ (ARCHERY NEXUS MODAL VISSZAJELZÉSSEL) ---
  const handleSaveScannedScores = async (scannedList) => {
    if (!scannedList || scannedList.length === 0) return;

    // TILTÁS: Ha a verseny le van zárva, nem engedünk menteni
    if (competition?.status === 'Lezárt' || competition?.status === 'Ready to Upload') {
      alert("A verseny le van zárva, az eredmények már nem módosíthatók.");
      return;
    }

    try {
      // --- ÚJ: OFFLINE ELLENŐRZÉS ---
      if (!navigator.onLine) {
        const savedScores = JSON.parse(localStorage.getItem(`scores_${id}`) || '{}');
        const newAllShots = { ...allShotsByCompetitor };

        for (const comp of scannedList) {
          savedScores[comp.id] = comp.totalScore;
          if (comp.shots) {
            newAllShots[comp.id] = comp.shots;
          }

          await saveScoreOffline(id, comp.id, {
            totalScore: comp.totalScore,
            shots: comp.shots || [],
            status: "QR rögzítve (Offline)"
          });
        }

        localStorage.setItem(`scores_${id}`, JSON.stringify(savedScores));
        setAllShotsByCompetitor(newAllShots);

        // JAVÍTÁS: UI és regisztráltak frissítése offline módban is
        setParticipants(prev => prev.map(p => {
          const scanned = scannedList.find(s => s.id === p.id);
          return scanned ? { ...p, totalScore: scanned.totalScore, shots: scanned.shots || [], status: "QR rögzítve (Offline)" } : p;
        }));

        setLocalRegisteredIds(prev => {
          const newSet = new Set(prev);
          scannedList.forEach(comp => newSet.add(comp.id));
          return newSet;
        });

        alert(`${scannedList.length} íjász eredménye elmentve offline módba! 🏹💾`);
        setScannedSaveSuccessData(scannedList);
        return;
      }

      const batch = writeBatch(db);

      // 1. Betöltjük a korábbi pontokat LocalStorage-ból (visszafelé kompatibilitás miatt megtartjuk)
      const savedScores = JSON.parse(localStorage.getItem(`scores_${id}`) || '{}');
      const newAllShots = { ...allShotsByCompetitor };

      // 2. Befrissítjük az új pontokat
      scannedList.forEach(comp => {
        // LocalStorage frissítése
        savedScores[comp.id] = comp.totalScore;
        if (comp.shots) {
          newAllShots[comp.id] = comp.shots;
        }

        // --- FIRESTORE FRISSÍTÉS ---
        const participantRef = doc(db, "events", id, "participants", comp.id);
        batch.update(participantRef, {
          totalScore: comp.totalScore,
          shots: comp.shots || [],
          status: "Eredmény leadva"
        });

        // Frissítjük a memóriában lévő participants tömböt is
        setParticipants(prev => prev.map(p =>
          p.id === comp.id ? { ...p, totalScore: comp.totalScore, shots: comp.shots || [] } : p
        ));
      });

      // --- ÚJ: REGISZTRÁCIÓ FRISSÍTÉSE (Hogy ne tűnjenek el a listából) ---
      setLocalRegisteredIds(prev => {
        const newSet = new Set(prev);
        scannedList.forEach(comp => newSet.add(comp.id));
        return newSet;
      });

      // 3. Mentés
      await batch.commit();
      localStorage.setItem(`scores_${id}`, JSON.stringify(savedScores));
      setAllShotsByCompetitor(newAllShots);

      // 4. Megnyitjuk a saját Archery Nexus stílusú modal ablakunkat!
      setScannedSaveSource('qr_scan');
      setScannedSaveSuccessData(scannedList);
    } catch (err) {
      console.error("Hiba a mentéskor:", err);
      alert("Hiba történt a mentés során.");
    }
  };

  // --- KÉZI KÉNYSZERÍTETT BIZTONSÁGI MENTÉS (CSAK A BEÉRKEZETT PONTSZÁMOKRA) ---
  const [isForceBackuping, setIsForceBackuping] = useState(false);

  const handleForceBackupAllScores = async () => {
    if (isForceBackuping) return;

    const scoredParticipants = participants.filter(p => p.totalScore !== undefined);

    if (scoredParticipants.length === 0) {
      alert("Még nincsenek beérkezett eredmények a mentéshez!");
      return;
    }

    setIsForceBackuping(true);

    try {
      // 1. LOCALSTORAGE MENTÉS
      const savedScores = JSON.parse(localStorage.getItem(`scores_${id}`) || '{}');
      const newAllShots = { ...allShotsByCompetitor };

      scoredParticipants.forEach(p => {
        savedScores[p.id] = p.totalScore;
        if (p.shots && p.shots.length > 0) {
          newAllShots[p.id] = p.shots;
        }
      });

      localStorage.setItem(`scores_${id}`, JSON.stringify(savedScores));
      setAllShotsByCompetitor(newAllShots);

      // 2. INDEXEDDB OFFLINE MENTÉS
      for (const p of scoredParticipants) {
        await saveScoreOffline(id, p.id, {
          totalScore: p.totalScore,
          shots: p.shots || [],
          isManuallyEdited: p.isManuallyEdited || false,
          status: p.status || (navigator.onLine ? "Eredmény leadva" : "Eredmény leadva (Offline)")
        });
      }

      // 3. FIRESTORE MENTÉS (HA VAN NET)
      if (navigator.onLine) {
        const batch = writeBatch(db);
        const collectionName = isArchived ? "events_closed" : "events";

        scoredParticipants.forEach(p => {
          if (!p.id.toString().startsWith('temp_')) {
            const pRef = doc(db, collectionName, id, "participants", p.id);
            batch.update(pRef, {
              totalScore: p.totalScore,
              shots: p.shots || [],
              status: "Eredmény leadva"
            });
          }
        });

        await batch.commit();
      }

      alert(`Összes beérkezett eredmény (${scoredParticipants.length} fő) sikeresen rögzítve és elmentve a helyi memóriában és a felhőben! 🏹💾✅`);
    } catch (error) {
      console.error("Hiba a kényszerített biztonsági mentéskor:", error);
      alert("Az eredmények helyben elmentődtek a memóriába! 🏹💾");
    } finally {
      setIsForceBackuping(false);
    }
  };

  // --- ÚJ: MANUÁLIS EREDMÉNY MENTÉSE ---
  const handleSaveManualScore = async () => {
    if (!manualScoreEntry.participant) {
      setManualScoreError("Kérjük, válassz ki egy íjászt!");
      return;
    }

    // TILTÁS: Ha a verseny le van zárva, nem engedünk menteni
    if (competition?.status === 'Lezárt' || competition?.status === 'Ready to Upload') {
      setManualScoreError("A verseny le van zárva, az eredmények már nem módosíthatók.");
      return;
    }

    const calculatedScore = Object.entries(manualScoreEntry.zones).reduce((acc, [zone, count]) => {
      const val = zone === 'X' ? 11 : parseInt(zone) || 0;
      return acc + (val * (parseInt(count) || 0));
    }, 0);

    const currentShots = Object.values(manualScoreEntry.zones).reduce((acc, curr) => acc + (parseInt(curr) || 0), 0);
    const bowCatShort = manualScoreEntry.participant.bowCategory?.split('_').pop()?.toUpperCase() || '';
    let expectedShotsPerTarget = Number(competition?.shotsPerTarget) || 0;
    if (competition?.crossbowSingleShot && (bowCatShort === 'CRB' || bowCatShort === 'SZAMSZERIJ')) {
      expectedShotsPerTarget = 1;
    }
    const maxShots = (Number(competition?.numberOfTargets) || 0) * expectedShotsPerTarget;

    let finalScore = parseInt(manualScoreEntry.totalScore) || 0;
    let finalShots = manualScoreEntry.participant.shots || []; // Meglévő lövések megtartása alapesetben

    // --- ÚJ: INTELLIGENS SORREND-MEGŐRZŐ LOGIKA ---
    // Megnézzük, hogy a manuális ablakban lévő zónák eloszlása megegyezik-e a már tárolt lövésekkel
    const existingShots = manualScoreEntry.participant.shots || [];
    const existingCounts = {};
    existingShots.forEach(s => { if (s.value) existingCounts[s.value] = (existingCounts[s.value] || 0) + 1; });

    const isDistributionChanged = Object.entries(manualScoreEntry.zones).some(([zone, count]) => {
        return (parseInt(count) || 0) !== (existingCounts[zone] || 0);
    });

    // CSAK AKKOR építjük újjá a tömböt (veszítjük el a sorrendet), ha:
    // 1. Még nincsenek lövések (tiszta manuális bevitel)
    // 2. Megváltozott a zónák eloszlása (valódi szerkesztés történt)
    if (existingShots.length === 0 || isDistributionChanged) {
        if (finalScore === calculatedScore && currentShots === maxShots && currentShots > 0) {
          const newShots = [];
          Object.entries(manualScoreEntry.zones)
            .sort((a, b) => {
              const valA = a[0] === 'X' ? 11.5 : parseInt(a[0]) || 0;
              const valB = b[0] === 'X' ? 11.5 : parseInt(b[0]) || 0;
              return valB - valA;
            })
            .forEach(([zone, count]) => {
                const value = zone === 'X' ? 11 : parseInt(zone);
                const numCount = parseInt(count) || 0;
                for (let i = 0; i < numCount; i++) {
                    newShots.push({
                        value: zone,
                        sum: value,
                        // Ha manuális, nem tudunk pontos célt/pozíciót, marad a fiktív sorrend
                        target: Math.floor((newShots.length) / expectedShotsPerTarget) + 1,
                        position: (newShots.length % expectedShotsPerTarget) + 1
                    });
                }
            });
          finalShots = newShots;
        }
    }

    setManualScoreError(null);

    // --- OFFLINE MENTÉS ---
    if (!navigator.onLine) {
      try {
        await saveScoreOffline(id, manualScoreEntry.participant.id, {
            totalScore: finalScore,
            shots: finalShots,
            status: "Eredmény leadva (Offline)",
            isManuallyEdited: true,
            shootOffRank: null // Új pontszámnál töröljük a szétlövés eredményt
        });
        alert("Eredmény elmentve offline módba! 🏹💾");
        setParticipants(prev => prev.map(p =>
            p.id === manualScoreEntry.participant.id ? { ...p, totalScore: finalScore, shots: finalShots, isManuallyEdited: true, shootOffRank: null } : p
        ));
        setShowManualScoreModal(false);
        return;
      } catch (e) {
        console.error("Offline mentési hiba:", e);
      }
    }

    const savedScores = JSON.parse(localStorage.getItem(`scores_${id}`) || '{}');
    savedScores[manualScoreEntry.participant.id] = finalScore;

    const updateFirestore = async () => {
      try {
        const pRef = doc(db, "events", id, "participants", manualScoreEntry.participant.id);
        await updateDoc(pRef, {
          totalScore: finalScore,
          shots: finalShots,
          status: "Eredmény leadva",
          isManuallyEdited: true,
          shootOffRank: null // Új pontszámnál töröljük a szétlövés eredményt
        });
      } catch (e) {
        console.error("Firestore mentési hiba:", e);
        await saveScoreOffline(id, manualScoreEntry.participant.id, { totalScore: finalScore, shots: finalShots, status: "Eredmény leadva (Várakozik)", isManuallyEdited: true, shootOffRank: null });
      }
    };
    updateFirestore();

    localStorage.setItem(`scores_${id}`, JSON.stringify(savedScores));

    setAllShotsByCompetitor(prev => ({
      ...prev,
      [manualScoreEntry.participant.id]: finalShots
    }));

    setParticipants(prev => prev.map(p =>
      p.id === manualScoreEntry.participant.id ? { ...p, totalScore: finalScore, shots: finalShots, isManuallyEdited: true, shootOffRank: null } : p
    ));
    setLocalRegisteredIds(prev => new Set(prev).add(manualScoreEntry.participant.id));

    setShowManualScoreModal(false);
    setScannedSaveSource('new_manual');
    setScannedSaveSuccessData([{
      fullName: manualScoreEntry.participant.fullName,
      totalScore: finalScore
    }]);
  };

  const handleNextManualScore = () => {
    setScannedSaveSuccessData(null);
    setManualScoreEntry({ participant: null, zones: {}, totalScore: 0 });
    setManualSearchTerm('');
    setShowManualScoreModal(true);
  };

  // --- ÚJ: SZÉTLÖVÉS MENTÉSE (OFFLINE KÉPES) ---
  const handleSaveShootOff = async () => {
    if (isArchived || competition?.status === 'Lezárt') {
      alert("A verseny le van zárva, az eredmények már nem módosíthatók.");
      return;
    }

    setShootOffSaving(true);

    try {
        const participantUpdates = [];

        // 1. Összegyűjtjük a frissítendő adatokat
        shootOffGroup.forEach(p => {
            const rank = shootOffRanks[p.id];
            if (rank) {
                participantUpdates.push({
                    id: p.id,
                    shootOffRank: parseInt(rank)
                });
            }
        });

        // 2. OFFLINE MENTÉS
        if (!navigator.onLine) {
            for (const update of participantUpdates) {
                await saveScoreOffline(id, update.id, { shootOffRank: update.shootOffRank });
            }
            alert(`Offline: Szétlövés eredménye rögzítve! 🏹💾`);
        } else {
            // 3. ONLINE MENTÉS
            const batch = writeBatch(db);
            participantUpdates.forEach(update => {
                const pRef = doc(db, "events", id, "participants", update.id);
                batch.update(pRef, { shootOffRank: update.shootOffRank });
            });
            await batch.commit();
        }

        // 4. HELYI MEMÓRIA FRISSÍTÉSE (Azonnali UI reakció)
        setParticipants(prev => prev.map(p => {
            const update = participantUpdates.find(u => u.id === p.id);
            return update ? { ...p, shootOffRank: update.shootOffRank } : p;
        }));

        setShowShootOffModal(false);
    } catch (e) {
        console.error("Hiba a szétlövés mentésekor:", e);
        setShowShootOffModal(false);
        alert("Hiba történt a mentés során.");
    } finally {
        setShootOffSaving(false);
        setShowShootOffModal(false);
    }
  };

  // --- ÚJ: VERSENY LEZÁRÁSA ---
  const handleCloseCompetition = async () => {
    // JAVÍTÁS: Csak azokat ellenőrizzük, akik megérkeztek (localRegisteredIds)
    const registeredParticipants = participants.filter(p => localRegisteredIds.has(p.id));
    const allScored = registeredParticipants.length > 0 && registeredParticipants.every(p => p.totalScore !== undefined);

    if (!allScored) {
      setShowCloseCompetitionError(true);
      setTimeout(() => setShowCloseCompetitionError(false), 5000); // 5 mp után eltűnik
      return;
    }

    setShowFinalCloseConfirmModal(true);
  };

  const handleFinalConfirmCloseCompetition = async () => {
    try {
      const newStatus = 'Ready to Upload';
      const closedAt = new Date().toISOString();

      // --- RANGSOR ÉS STATISZTIKA GENERÁLÁSA ---
      const finalisedParticipants = [...participants].map(p => {
        // Alap statisztika számolása (Zónák összesítése)
        const shots = p.shots || allShotsByCompetitor[p.id] || [];
        const counts = {};
        // Alapértelmezett zónák inicializálása
        (competition?.scoringValues || ['11', '10', '8', '5', '0']).forEach(z => counts[z] = 0);
        // Lövések összeszámolása
        shots.forEach(s => {
          if (s.value) counts[s.value] = (counts[s.value] || 0) + 1;
        });

        return { ...p, hitZoneCounts: counts };
      });

      // Csoportosítás és Helyezés kiosztás
      const groups = {};
      finalisedParticipants.forEach(p => {
        if (p.isCancelled || p.totalScore === undefined) return;
        const key = getCategoryKey(p);
        if (!groups[key]) groups[key] = [];
        groups[key].push(p);
      });

      // Összehasonlító függvény (Ugyanaz mint a resultsData-nál)
      const compare = (a, b) => {
        if (Number(b.totalScore) !== Number(a.totalScore)) return Number(b.totalScore) - Number(a.totalScore);

        const rules = competition?.tieBreakingRules || [];
        for (const rule of rules) {
          let zones = [];
          let isFewer = false;

          // Szabályok leképezése technikai ID-ról zónákra
          if (rule === 'more_elevens_xs') zones = ['11', 'X'];
          else if (rule === 'more_tens') zones = ['10'];
          else if (rule === 'more_eights') zones = ['8'];
          else if (rule === 'more_fives') zones = ['5'];
          else if (rule === 'fewer_zeros') { zones = ['0']; isFewer = true; }
          else if (rule === 'shoot_off') continue; // A szétlövést kézzel kezeljük a táblázatban
          else continue;

          const countA = Object.entries(a.hitZoneCounts || {}).filter(([k]) => zones.includes(k)).reduce((s, [, v]) => s + v, 0);
          const countB = Object.entries(b.hitZoneCounts || {}).filter(([k]) => zones.includes(k)).reduce((s, [, v]) => s + v, 0);

          if (countB !== countA) {
            return isFewer ? (countA - countB) : (countB - countA);
          }
        }
        return 0;
      };

      // Helyezések beírása
      Object.values(groups).forEach(group => {
        group.sort(compare);
        group.forEach((p, index) => {
          // Megkeressük az eredeti objektumot és beleírjuk a helyezést
          const target = finalisedParticipants.find(fp => fp.id === p.id);
          if (target) target.rank = index + 1;
        });
      });

      // --- OFFLINE TÁMOGATÁS ---
      if (!navigator.onLine) {
        const updatedCompetition = {
          ...competition,
          status: newStatus,
          closedAt: closedAt
        };

        // 1. Mentés a laptopra (A véglegesített résztvevőkkel!)
        await saveCompetitionOffline(updatedCompetition, finalisedParticipants);

        // 2. ÚJ: Minden résztvevő rangsorát és statisztikáját bepakoljuk a várólistába szinkronhoz
        for (const p of finalisedParticipants) {
          if (p.totalScore !== undefined) {
             await saveScoreOffline(id, p.id, {
                totalScore: p.totalScore,
                shots: p.shots || [],
                rank: p.rank || null,
                hitZoneCounts: p.hitZoneCounts || {},
                status: "Eredmény leadva (Lezárt)"
             });
          }
        }

        // 3. Verseny állapotát is várólistára tesszük
        await saveCompetitionUpdateOffline(id, {
            status: newStatus,
            closedAt: closedAt
        });

        // Helyi állapot frissítése
        setCompetition(updatedCompetition);
        setParticipants(finalisedParticipants);
        setShowFinalCloseConfirmModal(false);
        setShowSoftCloseInfoModal(true);
        return;
      }

      // ONLINE: Eredeti Firestore logika + Nevezők frissítése
      const batch = writeBatch(db);

      // 1. Verseny státusz
      const eventRef = doc(db, "events", id);
      batch.update(eventRef, {
        status: newStatus,
        closedAt: serverTimestamp()
      });

      // 2. Minden nevezőhöz beírjuk a végleges adatokat (hogy a szerveren is ott legyen)
      finalisedParticipants.forEach(p => {
        const pRef = doc(db, "events", id, "participants", p.id);
        batch.update(pRef, {
          rank: p.rank || null,
          hitZoneCounts: p.hitZoneCounts || {}
        });
      });

      await batch.commit();

      // MENTÉS INDEXEDDB-BE IS (A Dashboard feltöltés gombja innen fogja venni!)
      await saveCompetitionOffline({ ...competition, status: newStatus, closedAt: closedAt }, finalisedParticipants);

      // Helyi állapot frissítése
      setCompetition(prev => ({ ...prev, status: newStatus }));
      setParticipants(finalisedParticipants);
      setShowFinalCloseConfirmModal(false);
      setShowSoftCloseInfoModal(true);
    } catch (error) {
      console.error("Hiba a lezáráskor:", error);
      alert("A lezárás sikertelen!");
    }
  };

  // ÚJ: AUTOMATIKUS SZINKRONIZÁLÁS LOGIKA (Csendes háttérfolyamat)
  const syncOfflineDataSilently = async () => {
    if (!navigator.onLine || isSyncing) return;

    // --- TÉNYLEGES HÁLÓZAT ELLENŐRZÉS (PING) ---
    try {
      const ping = await fetch('https://www.google.com/favicon.ico', { mode: 'no-cors', cache: 'no-store' });
      if (!ping) return;
    } catch (e) {
      return; // Nincs valódi adatforgalom
    }

    // 1. Íjászok szinkronizálása
    const pendingParticipants = await getPendingScores(id);

    // 2. Verseny adatok szinkronizálása
    const pendingComps = await getPendingCompetitionUpdates();

    if (pendingParticipants.length === 0 && pendingComps.length === 0) {
      if (pendingOfflineCount !== 0) setPendingOfflineCount(0);
      return;
    }

    setIsSyncing(true);
    try {
      // --- DARABOLÁS: 400-as csomagokban szinkronizálunk (Firestore 500-as limit miatt) ---
      const BATCH_SIZE = 400;

      // Műveletek gyűjtése
      const allPending = [...pendingParticipants.map(p => ({ type: 'participant', data: p })),
                          ...pendingComps.map(c => ({ type: 'competition', data: c }))];

      for (let i = 0; i < allPending.length; i += BATCH_SIZE) {
        const chunk = allPending.slice(i, i + BATCH_SIZE);
        const batch = writeBatch(db);
        const processedItems = [];

        chunk.forEach(item => {
          if (item.type === 'participant') {
            const data = item.data;
            processedItems.push({ type: 'participant', id: data.id });

            if (data.type === 'new_participant') {
              // Ha új nevező, a már legenerált ID-t használjuk
              const pRef = doc(db, "events", id, "participants", data.id);
              const { id: unusedId, competitionId, type, ...cleanData } = data;
              batch.set(pRef, { ...cleanData, registeredVia: 'web-sync' });
              batch.update(doc(db, "events", id), { participantsCount: increment(1) });
            } else if (data.type === 'update_participant') {
              const pRef = doc(db, "events", id, "participants", data.id);
              batch.update(pRef, data.updateData || data);
            } else if (data.type === 'delete_participant') {
              const pRef = doc(db, "events", id, "participants", data.id);
              batch.delete(pRef);
              batch.update(doc(db, "events", id), { participantsCount: increment(-1) });
            } else {
              const pRef = doc(db, "events", id, "participants", data.id);
              const updateObj = {
                totalScore: data.totalScore,
                shots: data.shots || [],
                status: data.status || "Eredmény leadva",
                isManuallyEdited: data.isManuallyEdited || false
              };
              if (data.rank) updateObj.rank = data.rank;
              if (data.hitZoneCounts) updateObj.hitZoneCounts = data.hitZoneCounts;
              batch.update(pRef, updateObj);
            }
          } else {
            // Verseny módosítás
            const compUpdate = item.data;
            processedItems.push({ type: 'competition', id: compUpdate.id });
            const compRef = doc(db, "events", id);
            const { id: unused, timestamp, ...fields } = compUpdate;
            batch.update(compRef, fields);
          }
        });

        await batch.commit();

        // Sikeres batch után takarítás a várólistából
        for (const item of processedItems) {
          if (item.type === 'participant') await clearPendingScore(item.id);
          else await clearPendingCompetitionUpdate(item.id);
        }
      }

      setPendingOfflineCount(0);
      console.log("Offline adatok sikeresen szinkronizálva! 🔄☁️");
    } catch (e) {
      console.error("Szinkronizálási hiba:", e);
    } finally {
      setIsSyncing(false);
    }
  };

  // Eseményfigyelők és időzítő a szinkronhoz
  useEffect(() => {
    // 1. Azonnali szinkron ha visszajön a net
    const handleOnline = () => syncOfflineDataSilently();
    window.addEventListener('online', handleOnline);

    // 2. Periodikus ellenőrzés (30 másodpercenként)
    const interval = setInterval(async () => {
      const pending = await getPendingScores(id);
      setPendingOfflineCount(pending.length);
      if (pending.length > 0 && navigator.onLine) {
        syncOfflineDataSilently();
      }
    }, 30000);

    // 3. Kezdeti ellenőrzés belépéskor
    syncOfflineDataSilently();

    return () => {
      window.removeEventListener('online', handleOnline);
      clearInterval(interval);
    };
  }, [id]);

  // ÚJ: Görgetés figyelő a "Vissza a tetejére" gombhoz
  useEffect(() => {
    const handleScroll = () => {
      if (contentRef.current) {
        setShowScrollTop(contentRef.current.scrollTop > 300);
      }
    };

    const currentRef = contentRef.current;
    if (currentRef) {
      currentRef.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const scrollToTop = () => {
    if (contentRef.current) {
      contentRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };
  const registrationData = useMemo(() => {
    // Szűrés kereső alapján
    const filtered = participants.filter(p =>
      p.fullName?.toLowerCase().includes(regSearchTerm.toLowerCase())
    );

    // Két csoportra osztás
    const pending = filtered.filter(p => !localRegisteredIds.has(p.id))
      .sort((a, b) => a.fullName?.localeCompare(b.fullName));

    const arrived = filtered.filter(p => localRegisteredIds.has(p.id))
      .sort((a, b) => a.fullName?.localeCompare(b.fullName));

    return { pending, arrived };
  }, [participants, localRegisteredIds, regSearchTerm]);

  const menuItems = [
    { id: 'overview', label: 'Áttekintés', icon: <FiInfo /> },
    { id: 'teams', label: 'Csapatbeosztás', icon: <FiGrid /> },
    { id: 'competitors', label: 'Nevezők', icon: <FiUsers /> },
    { id: 'qr-scanner', label: 'QR Beolvasás', icon: <FiCamera /> },
    { id: 'results', label: 'Eredmények', icon: <FiBarChart2 /> },
    { id: 'course-map', label: 'Pálya térkép', icon: <FiMap /> },
    { id: 'targets', label: 'Célok/Távok', icon: <FiMap /> },
    { id: 'documents', label: 'Dokumentumok', icon: <FiFileText /> },
    { id: 'notifications', label: 'Értesítés küldése\na versenyzőknek', icon: <FiMessageSquare /> },
  ];

  const filteredParticipants = useMemo(() => {
    let filtered = participants.filter(p =>
      p.fullName?.toLowerCase().includes(participantSearchTerm.toLowerCase())
    );

    if (showOnSiteOnly) {
      const targetDateStr = competition?.competitionDate || new Date().toISOString().slice(0, 10);
      filtered = filtered.filter(p => isParticipantCreatedToday(p, targetDateStr));
    }

    if (teamFilter !== null && !participantSearchTerm.trim()) {
      filtered = filtered.filter(p => Number(p.team) === teamFilter);
    }

    if (!sortConfig.key) return filtered;

    return [...filtered].sort((a, b) => {
      let aVal = a[sortConfig.key] || '';
      let bVal = b[sortConfig.key] || '';

      // Speciális kezelés: Korosztály (logikai sorrend a globális konstansból)
      if (sortConfig.key === 'ageCategory') {
        aVal = AGE_ORDER[a.ageCategory] || 99;
        bVal = AGE_ORDER[b.ageCategory] || 99;
      }
      // Speciális kezelés: Íjkategória (rövidítés alapján)
      else if (sortConfig.key === 'bowCategory') {
        aVal = a.bowCategory?.split('_').pop() || '';
        bVal = b.bowCategory?.split('_').pop() || '';
      }
      // Speciális kezelés: Csapat (számként kezelve)
      else if (sortConfig.key === 'team') {
        aVal = parseInt(a.team) || 999;
        bVal = parseInt(b.team) || 999;
      }
      // Speciális kezelés: Megérkezett (regisztrációs állapot)
      else if (sortConfig.key === 'arrived') {
        aVal = localRegisteredIds.has(a.id) ? 1 : 0;
        bVal = localRegisteredIds.has(b.id) ? 1 : 0;
      }
      // Általános szöveges rendezés (Név, stb.)
      else {
        aVal = aVal.toString().toLowerCase();
        bVal = bVal.toString().toLowerCase();
      }

      if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [participants, participantSearchTerm, sortConfig, teamFilter, localRegisteredIds, showOnSiteOnly]);

  if (loading) {
    return (
      <div style={loadingContainerStyle}>
        <div style={spinnerStyle}></div>
        <p>Versenyiroda betöltése...</p>
      </div>
    );
  }

  const generateParticipantId = (p) => {
    if (!competition?.competitionDate || !p.userId) return "N/A";
    const dateParts = competition.competitionDate.split('-');
    if (dateParts.length !== 3) return "N/A";
    const yy = dateParts[0].slice(-2);
    const mm = dateParts[1];
    const dd = dateParts[2];
    const uidSuffix = p.userId.slice(-4);
    return `${yy}${mm}${dd}${uidSuffix}`;
  };

  const generateParticipantQrString = (p) => {
    const scoring = competition?.scoringValues?.join(',') || '11,10,8,5,0';
    const dnsId = generateParticipantId(p);

    // --- ÚJ: Intelligens kategória felirat a QR-ba ---
    let bowCat = p.bowCategory?.split('_').pop()?.toUpperCase() || p.bowCategory;

    if (p.bowCategory === 'tortenelmi_vadaszij_fa' || p.bowCategory === 'orom_vadaszij_fa') {
      bowCat = "Vadászíj favessző";
    } else if (p.bowCategory === 'tortenelmi_vadaszij_karbon' || p.bowCategory === 'orom_vadaszij_karbon') {
      bowCat = "Vadászíj karbon";
    } else if (p.bowCategory === 'tortenelmi_ij' || p.bowCategory === 'orom_tortenelmi_ij') {
      bowCat = "Történelmi íj";
    }
    const ageCat = translationMap[p.ageCategory] || p.ageCategory;
    const genderNum = p.gender === 'Férfi' ? 0 : 1;
    const targets = competition?.numberOfTargets || 0;

    // --- CRB (SZÁMSZERÍJ) SPECIÁLIS 1-LÖVÉS LOGIKA ---
    let shots = competition?.shotsPerTarget || 0;
    if (competition?.crossbowSingleShot && (bowCat === 'CRB' || bowCat === 'SZAMSZERIJ')) {
      shots = 1;
    }

    const totalShots = (Number(targets) || 0) * (Number(shots) || 0);

    return `${scoring};${totalShots};${dnsId};${p.fullName};${bowCat};${ageCat};${genderNum};${targets};${shots}`;
  };

  const toggleSelectAll = () => {
    if (selectedIds.size === filteredParticipants.length) {
      setSelectedIds(new Set());
    } else {
      setSelectedIds(new Set(filteredParticipants.map(p => p.id)));
    }
  };

  const toggleSelectOne = (id) => {
    const newSelected = new Set(selectedIds);
    if (newSelected.has(id)) {
      newSelected.delete(id);
    } else {
      newSelected.add(id);
    }
    setSelectedIds(newSelected);
  };

  const handlePrintMap = () => {
    if (!competition?.courseMapData) {
      setShowUnsavedMapWarning(true);
      return;
    }
    setShowMapPrintModal(true);
    // A nyomtatás indítása a portálon belül fog megtörténni, miután a térkép betöltött
  };

  const handleShareToFacebook = () => {
    const shareUrl = `https://archerynexus.com/verseny/${id}`;
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
    window.open(facebookShareUrl, '_blank', 'width=600,height=400');
  };

  const cleanExpiredNotifications = async () => {
    try {
      const fourteenDaysAgo = new Date(Date.now() - 14 * 24 * 60 * 60 * 1000);
      const notifRef = collection(db, "notifications");

      // 1. Töröljük a lejárt expireAt-es értesítéseket
      const q1 = query(notifRef, where("expireAt", "<=", new Date()));
      const snap1 = await getDocs(q1);

      // 2. Töröljük a régi, expireAt nélküli, de 14 napnál régebbi értesítéseket is
      const q2 = query(notifRef, where("createdAt", "<=", fourteenDaysAgo));
      const snap2 = await getDocs(q2);

      const docsToDeleteMap = new Map();
      snap1.docs.forEach(d => docsToDeleteMap.set(d.id, d.ref));
      snap2.docs.forEach(d => docsToDeleteMap.set(d.id, d.ref));

      if (docsToDeleteMap.size > 0) {
        const batch = writeBatch(db);
        docsToDeleteMap.forEach(ref => batch.delete(ref));
        await batch.commit();
      }
    } catch (e) {
      console.error("Hiba a lejárt értesítések törlésekor:", e);
    }
  };

  const handleSendBroadcastNotification = async () => {
    if (!broadcastMessage.trim()) {
      alert("Kérlek, írd be az értesítés szövegét!");
      return;
    }

    if (!window.confirm("Biztosan elküldöd ezt az értesítést minden versenyzőnek?")) {
      return;
    }

    setIsSendingBroadcast(true);
    try {
      // Lejárt értesítések automatikus takarítása elküldéskor
      await cleanExpiredNotifications();

      const batch = writeBatch(db);
      let sentCount = 0;
      const now = new Date();
      const expireAt = new Date(now.getTime() + 14 * 24 * 60 * 60 * 1000); // 14 nap múlva lejár

      participants.forEach(p => {
        const pId = p.userId || p.id;
        if (pId && !pId.toString().startsWith('temp_') && !pId.toString().startsWith('G')) {
          const notifRef = doc(collection(db, "notifications"));
          batch.set(notifRef, {
            toUserId: pId,
            fromUserId: auth.currentUser?.uid || "",
            fromUserName: competition?.competitionName || "Versenyiroda",
            title: competition?.competitionName || "Verseny értesítés",
            body: broadcastMessage.trim(),
            type: "competition_broadcast",
            competitionId: id,
            status: "unread",
            createdAt: serverTimestamp(),
            expireAt: expireAt
          });
          sentCount++;
        }
      });

      if (sentCount > 0) {
        await batch.commit();
        alert(`Értesítés sikeresen elküldve ${sentCount} versenyzőnek! 🏹📢`);
        setBroadcastMessage('');
      } else {
        alert("Nem találtam olyan résztvevőt, aki applikációs fiókkal regisztrált volna.");
      }
    } catch (error) {
      console.error("Hiba az értesítés küldésekor:", error);
      alert("Hiba történt az értesítés küldése során.");
    } finally {
      setIsSendingBroadcast(false);
    }
  };

  const handleSaveTargets = async () => {
    setIsSavingTargets(true);
    try {
      const collectionName = isArchived ? "events_closed" : "events";
      const docRef = doc(db, collectionName, id);
      await updateDoc(docRef, {
        targetDetails: localTargetDetails
      });
      setCompetition(prev => ({ ...prev, targetDetails: localTargetDetails }));
      alert("Célok és távolságok sikeresen mentve!");
    } catch (error) {
      console.error("Hiba a mentéskor:", error);
      alert("Hiba történt a mentés során.");
    } finally {
      setIsSavingTargets(false);
    }
  };

  const handleTogglePublishTargets = async () => {
    const newState = !competition.targetsPublished;

    // Csak elrejtésnél váltunk azonnal, publikálásnál megerősítést kérünk
    if (newState && !showPublishTargetsConfirm) {
      setShowPublishTargetsConfirm(true);
      return;
    }

    setIsPublishingTargets(true);
    try {
      const collectionName = isArchived ? "events_closed" : "events";
      const docRef = doc(db, collectionName, id);
      await updateDoc(docRef, {
        targetsPublished: newState
      });
      setCompetition(prev => ({ ...prev, targetsPublished: newState }));
      setShowPublishTargetsConfirm(false); // Modal bezárása siker esetén
      alert(newState ? "A távolságok publikálva lettek! 🏹🚀" : "A távolságok mostantól rejtettek.");
    } catch (error) {
      console.error("Hiba a publikáláskor:", error);
      alert("Hiba történt a művelet során.");
    } finally {
      setIsPublishingTargets(false);
    }
  };

  // --- ÚJ: PÁLYATÉRKÉP PUBLIKÁLÁSA ---
  const handleTogglePublishMap = async () => {
    const newState = !competition.courseMapPublished;

    // Ha elrejtés
    if (!newState) {
      setIsPublishingMap(true);
      try {
        const collectionName = isArchived ? "events_closed" : "events";
        await updateDoc(doc(db, collectionName, id), {
          courseMapPublished: false,
          courseMapImageUrl: "",
          courseMapPublishedAt: null
        });
        setCompetition(prev => ({ ...prev, courseMapPublished: false, courseMapImageUrl: "", courseMapPublishedAt: null }));
        alert("A pályatérkép mostantól rejtett.");
      } catch (e) {
        console.error("Hiba a térkép elrejtésekor:", e);
      } finally {
        setIsPublishingMap(false);
      }
      return;
    }

    // HA SAJÁT EGYEDI TÉRKÉP VAN KIVÁLASZTVA
    if (competition?.isCustomMap && competition?.customMapImageUrl) {
      setIsPublishingMap(true);
      try {
        const collectionName = isArchived ? "events_closed" : "events";
        await updateDoc(doc(db, collectionName, id), {
          courseMapPublished: true,
          courseMapImageUrl: competition.customMapImageUrl,
          courseMapPublishedAt: new Date().toISOString()
        });

        setCompetition(prev => ({
          ...prev,
          courseMapPublished: true,
          courseMapImageUrl: competition.customMapImageUrl,
          courseMapPublishedAt: new Date().toISOString()
        }));

        alert("Saját pályatérkép publikálva! 🏹🗺️");
      } catch (error) {
        console.error("Hiba a saját térkép publikálásakor:", error);
        alert("Hiba történt a saját térkép publikálása során.");
      } finally {
        setIsPublishingMap(false);
      }
      return;
    }

    // HA INTERAKTÍV GOOGLE MAPS VAN KIVÁLASZTVA
    if (!competition?.courseMapData && !competition?.courseMapPublished) {
      setShowUnsavedMapWarning(true);
      return;
    }

    if (!showPublishMapConfirm) {
      setShowPublishMapConfirm(true);
      return;
    }

    setShowPublishMapConfirm(false);
    setIsPublishingMap(true);

    try {
      // 1. html2canvas betöltése
      await loadHtml2Canvas();

      // 2. Screenshot mód bekapcsolása (ez megnyitja a portált)
      setIsSnapshotMode(true);
      setShowMapPrintModal(true);

      // A kép generálását a PrintMapPortal végzi, mi csak várjuk a hívást az onScreenshotReady-n keresztül.
      // Ezt egy trükkel oldjuk meg: a handleTogglePublishMap itt véget ér,
      // és egy új függvényt adunk át a portálnak.
    } catch (error) {
      console.error("Error starting publication:", error);
      alert("Hiba történt a folyamat indításakor.");
      setIsPublishingMap(false);
    }
  };

  const handleScreenshotReceived = async (base64Image) => {
    try {
      const publishFunc = httpsCallable(functions, 'publishMapImage');
      const result = await publishFunc({
        eventId: id,
        base64Image: base64Image
      });

      // A linkhez adunk egy verziót, hogy a böngészők kényszerítve legyenek a frissítésre
      const finalImageUrl = result.data.imageUrl;

      setCompetition(prev => ({
        ...prev,
        courseMapPublished: true,
        courseMapImageUrl: finalImageUrl,
        courseMapPublishedAt: new Date()
      }));

      alert("Pályatérkép publikálva! 🏹📸");
    } catch (error) {
      console.error("Error uploading screenshot:", error);
      alert("Hiba történt a kép feltöltésekor.");
    } finally {
      setIsSnapshotMode(false);
      setShowMapPrintModal(false);
      setIsPublishingMap(false);
    }
  };

  const isDarkScanning = activeTab === 'qr-scanner';

  return (
    <div style={{ ...pageContainerStyle, backgroundColor: isDarkScanning ? '#121212' : '#f4f6f8', transition: 'background-color 0.4s ease' }} className="office-page-container">
      {/* --- MEGJEGYZÉS POPUP --- */}
      {activeComment && (
        <div
          onClick={() => setActiveComment(null)}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 9999, backgroundColor: 'transparent'
          }}
        >
            <div style={{
              position: 'absolute',
              left: Math.min(activeComment.x, window.innerWidth - 450),
              top: Math.min(activeComment.y, window.innerHeight - 300),
              backgroundColor: 'white',
              borderRadius: '12px',
              boxShadow: '0 15px 40px rgba(0,0,0,0.25)',
              width: '400px',
              maxWidth: '90vw',
              overflow: 'hidden',
              border: '1px solid #ccc'
            }}>
              <div style={{ backgroundColor: '#b30000', color: 'white', padding: '8px 15px', fontWeight: 'bold', fontSize: '0.9rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>Megjegyzés</span>
                <FiX style={{ cursor: 'pointer' }} onClick={() => setActiveComment(null)} />
              </div>
              <div style={{
                padding: '20px',
                fontSize: '1rem',
                color: '#333',
                whiteSpace: 'pre-wrap',
                lineHeight: '1.5',
                maxHeight: '80vh',
                overflowY: 'auto'
              }}>
                {activeComment.text}
              </div>
            </div>
        </div>
      )}
      {/* --- ARCHERY NEXUS STÍLUSÚ SIKERES MENTÉS MODAL --- */}
      {scannedSaveSuccessData && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '450px' }}>
            {/* Zöld pipa visszajelző ikon */}
            <div style={{
              width: '60px',
              height: '60px',
              backgroundColor: '#e6fffa',
              color: '#2c7a7b',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '2rem',
              margin: '0 auto 15px auto',
              fontWeight: 'bold'
            }}>
              ✓
            </div>

            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>
              Sikeres rögzítés!
            </h3>

            <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '20px', lineHeight: '1.4' }}>
              <strong>{scannedSaveSuccessData.length} fő</strong> eredménye sikeresen rögzítésre került az Eredmények fülön!
            </p>

            {/* Rögzített íjászok és pontjaik áttekintő listája */}
            <div style={{
              backgroundColor: '#fafafa',
              border: '1px solid #eee',
              borderRadius: '8px',
              padding: '10px 15px',
              marginBottom: '20px',
              maxHeight: '150px',
              overflowY: 'auto',
              textAlign: 'left'
            }}>
              {scannedSaveSuccessData.map((item, idx) => (
                <div key={idx} style={{
                  display: 'flex',
                  justify: 'space-between',
                  padding: '5px 0',
                  fontSize: '0.85rem',
                  borderBottom: idx < scannedSaveSuccessData.length - 1 ? '1px solid #eee' : 'none'
                }}>
                  <span style={{ fontWeight: 'bold', color: '#333' }}>{item.fullName}</span>
                  <span style={{ color: '#b30000', fontWeight: 'bold' }}>{item.totalScore} pont</span>
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {scannedSaveSource === 'new_manual' && (
                <button
                  style={{
                    ...modalDeleteButtonStyle,
                    backgroundColor: '#28a745',
                    width: '100%'
                  }}
                  onClick={handleNextManualScore}
                >
                  Rendben, jöhet a következő!
                </button>
              )}
              <button
                style={{
                  ...modalDeleteButtonStyle,
                  backgroundColor: '#b30000',
                  width: '100%'
                }}
                onClick={() => setScannedSaveSuccessData(null)}
              >
                Rendben
              </button>
            </div>
          </div>
        </div>
      )}
      {/* --- LÁNCBONTÁS MEGERŐSÍTŐ MODAL --- */}
      {unlinkLinkIdToConfirm && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '400px' }}>
            <FiAlertTriangle size={50} color="#b30000" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Láncolás felbontása</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              Biztosan felbontod ezt a láncolást?<br/>
              A csoport tagjai független íjászokká válnak.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button
                style={modalCancelButtonStyle}
                onClick={() => setUnlinkLinkIdToConfirm(null)}
              >
                Mégse
              </button>
              <button
                style={modalDeleteButtonStyle}
                onClick={handleConfirmUnlinkGroup}
              >
                Igen, felbontom
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- EGYEDI TÖRLÉSI ABLAK (MODAL) --- */}
      {showDeleteModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <FiAlertTriangle size={50} color="#b30000" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Biztosan törlöd?</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              Valóban törölni szeretnéd <br/>
              <strong>{participantToDelete?.fullName}</strong> <br/>
              nevezését? Ez a művelet végleges.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button
                style={modalCancelButtonStyle}
                onClick={() => {
                  setShowDeleteModal(false);
                  setParticipantToDelete(null);
                }}
              >
                Mégse
              </button>
              <button
                style={modalDeleteButtonStyle}
                onClick={handleFinalDeleteParticipant}
              >
                Igen, törlöm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- TÁVOK PUBLIKÁLÁSA MEGERŐSÍTŐ MODAL --- */}
      {showPublishTargetsConfirm && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '450px' }}>
            <div style={{ backgroundColor: '#b30000', color: '#fff', padding: '20px', margin: '-30px -30px 20px -30px', borderRadius: '15px 15px 0 0' }}>
               <h3 style={{ margin: 0 }}>Távolságok publikálása 🏹</h3>
            </div>
            <p style={{ color: '#333', textAlign: 'left', lineHeight: '1.6', fontSize: '0.95rem', marginBottom: '25px' }}>
              Biztosan közzéteszed a pályaadatokat? <br/><br/>
              Ezután <strong>minden résztvevő</strong> látni fogja a célok neveit és a pontos távolságokat az alkalmazásban és a weboldalon is.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button
                style={modalCancelButtonStyle}
                onClick={() => setShowPublishTargetsConfirm(false)}
                disabled={isPublishingTargets}
              >
                Mégse
              </button>
              <button
                style={{ ...modalDeleteButtonStyle, backgroundColor: '#28a745' }}
                onClick={handleTogglePublishTargets}
                disabled={isPublishingTargets}
              >
                {isPublishingTargets ? 'Publikálás...' : 'Igen, publikálom'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- PÁLYATÉRKÉP PUBLIKÁLÁSA MEGERŐSÍTŐ MODAL --- */}
      {showPublishMapConfirm && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '450px' }}>
            <div style={{ backgroundColor: '#b30000', color: '#fff', padding: '20px', margin: '-30px -30px 20px -30px', borderRadius: '15px 15px 0 0' }}>
               <h3 style={{ margin: 0 }}>Pályatérkép publikálása 🗺️</h3>
            </div>
            <p style={{ color: '#333', textAlign: 'left', lineHeight: '1.6', fontSize: '0.95rem', marginBottom: '25px' }}>
              Biztosan közzéteszed a pályatérképet? <br/><br/>
              Ezután <strong>minden résztvevő</strong> látni fogja a megrajzolt útvonalat és a célok elhelyezkedését az alkalmazásban egy kép formájában.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button
                style={modalCancelButtonStyle}
                onClick={() => setShowPublishMapConfirm(false)}
                disabled={isPublishingMap}
              >
                Mégse
              </button>
              <button
                style={{ ...modalDeleteButtonStyle, backgroundColor: '#28a745' }}
                onClick={handleTogglePublishMap}
                disabled={isPublishingMap}
              >
                {isPublishingMap ? 'Publikálás...' : 'Igen, publikálom'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- CSAPATOK PUBLIKÁLÁSA MEGERŐSÍTŐ MODAL --- */}
      {showPublishTeamsConfirm && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '450px' }}>
            <div style={{ backgroundColor: '#b30000', color: '#fff', padding: '20px', margin: '-30px -30px 20px -30px', borderRadius: '15px 15px 0 0' }}>
               <h3 style={{ margin: 0 }}>Csapatbeosztás publikálása 🏹</h3>
            </div>
            <p style={{ color: '#333', textAlign: 'left', lineHeight: '1.6', fontSize: '0.95rem', marginBottom: '25px' }}>
              Biztosan közzéteszed a csapatbeosztást (rajtlistát)? <br/><br/>
              Ezután <strong>minden íjász</strong> látni fogja a csapatszámát és a csapattársait az alkalmazásban és a weboldalon a <strong>"Csapatok"</strong> fülön.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button
                style={modalCancelButtonStyle}
                onClick={() => setShowPublishTeamsConfirm(false)}
                disabled={isPublishingTeams}
              >
                Mégse
              </button>
              <button
                style={{ ...modalDeleteButtonStyle, backgroundColor: '#28a745' }}
                onClick={handleTogglePublishTeams}
                disabled={isPublishingTeams}
              >
                {isPublishingTeams ? 'Publikálás...' : 'Igen, publikálom'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- CSAPAT PONTOZÓ MODAL --- */}
      {showTeamScoreModal && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '800px', textAlign: 'left' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #b30000', paddingBottom: '10px' }}>
              <h3 style={{ margin: 0, color: '#b30000' }}>{teamScoringData.number}. csapat eredményei</h3>
              <div
                style={{ cursor: 'pointer', backgroundColor: '#f2f2f2', borderRadius: '50%', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => setShowTeamScoreModal(false)}
              >
                <FiX size={20} color="#333" />
              </div>
            </div>

            <p style={{ color: '#666', fontSize: '0.85rem', marginBottom: '20px' }}>
              Írd be a versenyzők zónatalálatait és összpontszámát. Ha az összeg és a lövésszám stimmel, az eredmény "hivatalos" lesz.
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', maxHeight: '60vh', overflowY: 'auto', paddingRight: '15px' }}>
              {teamScoringData.members.map(m => {
                const scoringValues = competition?.scoringValues || ['11', '10', '8', '5', '0'];
                const sortedZones = [...scoringValues].sort((a, b) => {
                  const valA = a === 'X' ? 11.5 : parseInt(a);
                  const valB = b === 'X' ? 11.5 : parseInt(b);
                  return valB - valA;
                });

                // Kalkulációk a visszajelzéshez
                const mZones = teamScoringData.memberZones[m.id] || {};
                const currentTotalArrows = Object.values(mZones).reduce((acc, curr) => acc + (parseInt(curr) || 0), 0);
                const currentCalculatedSum = Object.entries(mZones).reduce((acc, [z, count]) => {
                  const val = z === 'X' ? 11 : parseInt(z) || 0;
                  return acc + (val * (parseInt(count) || 0));
                }, 0);

                const bowCatShort = m.bowCategory?.split('_').pop()?.toUpperCase() || '';
                let expectedShotsPerTarget = Number(competition?.shotsPerTarget) || 0;
                if (competition?.crossbowSingleShot && (bowCatShort === 'CRB' || bowCatShort === 'SZAMSZERIJ')) {
                  expectedShotsPerTarget = 1;
                }
                const maxExpected = (Number(competition?.numberOfTargets) || 0) * expectedShotsPerTarget;
                const isShotsMatch = currentTotalArrows === maxExpected;
                const enteredTotal = parseInt(teamScoringData.scores[m.id]) || 0;
                const isSumMatch = currentCalculatedSum === enteredTotal && enteredTotal > 0;

                return (
                  <div key={m.id} style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '12px', border: '1px solid #eee' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                      <div>
                        <div style={{ fontWeight: 'bold', fontSize: '1rem' }}>{m.fullName}</div>
                        <div style={{ fontSize: '0.75rem', color: '#888' }}>
                          {translationMap[m.bowCategory] || m.bowCategory} | {translationMap[m.ageCategory] || m.ageCategory}
                        </div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: '0.7rem', color: '#888', fontWeight: 'bold' }}>LÖVÉSSZÁM</div>
                        <div style={(() => {
                          const isError = currentTotalArrows > maxExpected;
                          return {
                            fontSize: isError ? '1.1rem' : '0.9rem',
                            fontWeight: '900',
                            color: isShotsMatch ? '#28a745' : (isError ? '#dc3545' : '#b30000'),
                            animation: isError ? 'pulse-warning-error 0.6s infinite ease-in-out' : 'none',
                            backgroundColor: isError ? 'rgba(220, 53, 69, 0.1)' : 'transparent',
                            border: isError ? '1px solid #dc3545' : 'none',
                            padding: isError ? '2px 8px' : '0',
                            borderRadius: '6px',
                            display: 'inline-block',
                            transition: 'all 0.3s ease'
                          };
                        })()}>
                          {currentTotalArrows} / {maxExpected}
                        </div>
                      </div>
                    </div>

                    <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                      {/* Zóna inputok */}
                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', flex: 1 }}>
                        {sortedZones.map(zone => (
                          <div key={zone} style={{ display: 'flex', flexDirection: 'column', gap: '4px', width: '60px' }}>
                            <div style={{
                              textAlign: 'center', backgroundColor: getColorForZoneValue(zone), color: 'white',
                              borderRadius: '4px', fontSize: '0.7rem', fontWeight: 'bold', padding: '2px'
                            }}>
                              {zone}p
                            </div>
                            <input
                              type="number"
                              value={mZones[zone] || ''}
                              onChange={(e) => handleTeamZoneChange(m.id, zone, e.target.value)}
                              style={{ ...formInputStyle, textAlign: 'center', padding: '6px', fontSize: '0.9rem' }}
                              placeholder="0"
                            />
                          </div>
                        ))}
                      </div>

                      {/* Összpontszám beviteli mező */}
                      <div style={{ width: '120px', borderLeft: '1px solid #ddd', paddingLeft: '15px', marginLeft: '5px' }}>
                        <div style={{ fontSize: '0.7rem', color: '#888', fontWeight: 'bold', marginBottom: '4px' }}>ÖSSZPONTSZÁM</div>
                        <div style={{ position: 'relative' }}>
                          <input
                            type="text"
                            value={teamScoringData.scores[m.id] || ''}
                            onChange={(e) => handleTeamScoreChange(m.id, e.target.value)}
                            style={{
                              ...formInputStyle,
                              textAlign: 'center',
                              fontSize: '1.2rem',
                              fontWeight: '900',
                              color: isSumMatch ? '#28a745' : '#b30000',
                              borderColor: isSumMatch ? '#28a745' : '#ddd'
                            }}
                            placeholder="0"
                          />
                          <div style={{ fontSize: '0.62rem', color: isSumMatch ? '#28a745' : '#666', marginTop: '3px', textAlign: 'center', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                            {enteredTotal > 0 && !isSumMatch && currentTotalArrows > 0 && `Matek: ${currentCalculatedSum}p | `}
                            Max: {calculateMaxPossibleScore(m)}p
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end', marginTop: '30px' }}>
              <button style={modalCancelButtonStyle} onClick={() => setShowTeamScoreModal(false)}>Mégse</button>
              <button
                style={qrButtonStyle}
                onClick={handleSaveTeamScores}
              >
                Eredmények rögzítése
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- PONT SZERKESZTŐ MODAL --- */}
      {showEditScoreModal && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '400px', textAlign: 'left' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #b30000', paddingBottom: '10px' }}>
              <h3 style={{ margin: 0, color: '#b30000' }}>Pontszám módosítása</h3>
              <div
                style={{ cursor: 'pointer', backgroundColor: '#f2f2f2', borderRadius: '50%', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => setShowEditScoreModal(false)}
              >
                <FiX size={20} color="#333" />
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <div style={{ fontWeight: 'bold', fontSize: '1.1rem', marginBottom: '5px' }}>{scoreEditData.name}</div>
              <p style={{ color: '#666', fontSize: '0.85rem' }}>Írd be az új összpontszámot:</p>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <input
                type="text"
                value={scoreEditData.score}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === '' || /^[0-9\b]+$/.test(val)) {
                    const numVal = parseInt(val) || 0;
                    const p = participants.find(p => p.id === scoreEditData.id);
                    const maxScore = calculateMaxPossibleScore(p);
                    const finalVal = Math.min(numVal, maxScore).toString();
                    setScoreEditData({ ...scoreEditData, score: val === '' ? '' : finalVal });
                  }
                }}
                style={{ ...formInputStyle, fontSize: '1.5rem', fontWeight: '900', textAlign: 'center', color: '#b30000' }}
                placeholder="0"
                autoFocus
              />
            </div>

            <div style={{
              backgroundColor: '#fff5f5',
              padding: '12px',
              borderRadius: '8px',
              border: '1px solid #ffcccc',
              display: 'flex',
              gap: '10px',
              marginBottom: '25px'
            }}>
              <FiAlertTriangle size={24} color="#b30000" style={{ flexShrink: 0 }} />
              <p style={{ fontSize: '0.75rem', color: '#b30000', margin: 0, lineHeight: '1.4' }}>
                <strong>Figyelem:</strong> A kézi módosítás törli a részletes zónatalálatokat (11, 10, 8, stb.)!
              </p>
            </div>

            <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
              <button style={modalCancelButtonStyle} onClick={() => setShowEditScoreModal(false)}>Mégse</button>
              <button
                style={qrButtonStyle}
                onClick={handleSaveManualScoreEdit}
              >
                Módosítás mentése
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- SOFT CLOSE TÁJÉKOZTATÓ MODAL --- */}
      {showSoftCloseInfoModal && (
        <div style={modalOverlayStyle} onClick={() => setShowSoftCloseInfoModal(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '450px' }} onClick={(e) => e.stopPropagation()}>
            <FiCheck size={50} color="#28a745" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Versenyiroda lezárva</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.6', fontSize: '0.95rem' }}>
              Az eredmények rögzítése ezen a versenyen befejeződött. <br/><br/>
              A rangsor véglegesítéséhez és a nyilvános publikáláshoz használd az
              <strong style={{ color: '#28a745' }}> "Eredmények feltöltése"</strong> (zöld) gombot
              a <strong>Lezárt versenyek</strong> fülön az Irányítópulton!
            </p>
            <button
              style={{ ...modalDeleteButtonStyle, backgroundColor: '#b30000', width: '100%' }}
              onClick={() => setShowSoftCloseInfoModal(false)}
            >
              Értem
            </button>
          </div>
        </div>
      )}

      {/* --- VÉGLEGES EREDMÉNY LEZÁRÁS MEGERŐSÍTŐ MODAL --- */}
      {showFinalCloseConfirmModal && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '450px' }}>
            <FiAlertTriangle size={50} color="#b30000" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Eredmények véglegesítése</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              Biztosan lezárod a versenyt? <br/>
              <strong>Ezután az eredmények már nem módosíthatók manuálisan sem!</strong> <br/>
              A lezárásról minden résztvevő Push értesítést kap.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button
                style={modalCancelButtonStyle}
                onClick={() => setShowFinalCloseConfirmModal(false)}
              >
                Mégse
              </button>
              <button
                style={{ ...modalDeleteButtonStyle, backgroundColor: '#28a745' }}
                onClick={handleFinalConfirmCloseCompetition}
              >
                Igen, lezárom
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- MENTETLEN TÉRKÉP FIGYELMEZTETŐ MODAL --- */}
      {showUnsavedMapWarning && (
        <div style={modalOverlayStyle} onClick={() => setShowUnsavedMapWarning(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '400px' }} onClick={(e) => e.stopPropagation()}>
            <FiAlertTriangle size={50} color="#b30000" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Hiányzó térképadatok</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.6', fontSize: '0.95rem' }}>
              A térkép publikálásához és nyomtatásához előbb <strong>mentsd el a térképet</strong> a szerkesztőfelület alján található gombbal!
            </p>
            <button
              style={{ ...modalDeleteButtonStyle, backgroundColor: '#b30000', width: '100%' }}
              onClick={() => setShowUnsavedMapWarning(false)}
            >
              Értem
            </button>
          </div>
        </div>
      )}

      {/* --- MANUÁLIS EREDMÉNY RÖGZÍTÉSE MODAL --- */}
      {showManualScoreModal && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '500px', textAlign: 'left' }}>
            <h3 style={{ ...resultGroupTitleStyle, marginBottom: '20px' }}>Eredmény manuális rögzítése</h3>

            {/* Név keresése felajánlásokkal */}
            <div style={inputGroupStyle}>
              <label style={labelStyle}>Versenyző neve</label>
              <div style={{ position: 'relative' }}>
                <input
                  style={formInputStyle}
                  type="text"
                  placeholder="Írd be a nevet..."
                  value={manualSearchTerm}
                  onChange={(e) => {
                    setManualSearchTerm(e.target.value);
                    if (manualScoreEntry.participant) {
                      setManualScoreEntry({ ...manualScoreEntry, participant: null });
                    }
                  }}
                />

                {manualSearchTerm.length >= 2 && !manualScoreEntry.participant && (
                  <div style={{
                    position: 'absolute', top: '100%', left: 0, right: 0,
                    backgroundColor: 'white', border: '1px solid #ddd',
                    borderRadius: '8px', boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                    zIndex: 10, maxHeight: '200px', overflowY: 'auto'
                  }}>
                    {participants
                      .filter(p => p.totalScore === undefined) // KISZŰRJÜK AZOKAT, AKIKNEK MÁR VAN EREDMÉNYE
                      .filter(p => (p.fullName || '').toLowerCase().includes((manualSearchTerm || '').toLowerCase()))
                      .map(p => (
                        <div
                          key={p.id}
                          onClick={() => {
                            setManualScoreEntry({ ...manualScoreEntry, participant: p, totalScore: '', zones: {} });
                            setManualSearchTerm(p.fullName || 'Névtelen nevező');
                          }}
                          style={{ padding: '10px 15px', cursor: 'pointer', borderBottom: '1px solid #eee' }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                        >
                          <strong>{p.fullName || 'Névtelen nevező'}</strong>
                          <span style={{ fontSize: '0.8rem', color: '#888', marginLeft: '10px' }}>
                            ({formatClubName(p.club) || 'Egyéb'})
                          </span>
                        </div>
                      ))
                    }
                  </div>
                )}
              </div>
            </div>

            {/* Kiválasztott íjász adatai */}
            {manualScoreEntry.participant && (
              <div style={{ ...profileRegCardStyle, backgroundColor: '#fff9f9', borderColor: '#ffcccc', marginTop: '10px', position: 'relative', minHeight: '110px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', paddingRight: '100px' }}>
                  <div style={{ fontSize: '0.85rem' }}>
                    <strong>Egyesület:</strong> {manualScoreEntry.participant.club || 'Egyéb'}
                  </div>
                  <div style={{ fontSize: '0.85rem' }}>
                    <strong>Kategória:</strong> {translationMap[manualScoreEntry.participant.bowCategory] || manualScoreEntry.participant.bowCategory}
                  </div>
                  <div style={{ fontSize: '0.85rem' }}>
                    <strong>Korosztály:</strong> {translationMap[manualScoreEntry.participant.ageCategory] || manualScoreEntry.participant.ageCategory}
                  </div>
                  <div style={{ fontSize: '0.85rem' }}>
                    <strong>Nem:</strong> {manualScoreEntry.participant.gender}
                  </div>
                </div>

                {/* ÉLŐ PONTSZÁM KIJELZÉS JOBB ALSÓ SAROKBAN */}
                <div style={{
                  position: 'absolute', right: '15px', bottom: '10px',
                  textAlign: 'right'
                }}>
                  <div style={{ fontSize: '0.7rem', color: '#888', fontWeight: 'bold', textTransform: 'uppercase' }}>Pontszám</div>
                  <input
                    type="number"
                    value={manualScoreEntry.totalScore}
                    onChange={(e) => {
                      const strVal = e.target.value;
                      if (strVal === '') {
                        setManualScoreEntry({ ...manualScoreEntry, totalScore: '' });
                        return;
                      }
                      const val = parseInt(strVal) || 0;
                      const maxScore = calculateMaxPossibleScore(manualScoreEntry.participant);
                      const finalVal = Math.min(val, maxScore);
                      setManualScoreEntry({ ...manualScoreEntry, totalScore: finalVal });
                    }}
                    placeholder="0"
                    className="red-placeholder-input"
                    style={{
                      fontSize: '1.8rem',
                      fontWeight: '900',
                      color: '#b30000',
                      lineHeight: '1',
                      width: '100px',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      textAlign: 'right',
                      padding: '2px 5px',
                      backgroundColor: '#fff'
                    }}
                  />
                  <style>{`
                    .red-placeholder-input::placeholder {
                      color: #b30000 !important;
                      opacity: 1;
                    }
                    .red-placeholder-input::-webkit-input-placeholder {
                      color: #b30000 !important;
                    }
                    .red-placeholder-input::-moz-placeholder {
                      color: #b30000 !important;
                    }
                  `}</style>
                  <div style={{ fontSize: '0.65rem', color: '#666', marginTop: '4px', fontWeight: 'bold' }}>
                    Max. elérhető: {calculateMaxPossibleScore(manualScoreEntry.participant)}p
                  </div>
                </div>
              </div>
            )}

            {/* Zónák bevitele */}
            <div style={{ marginTop: '20px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <label style={{ ...labelStyle, marginBottom: 0 }}>Találatok száma (Zónánként)</label>

                {/* LÖVÉSSZÁMLÁLÓ (Pl. 0 / 40) */}
                <div style={{ fontSize: '0.9rem', fontWeight: 'bold', color: '#666' }}>
                  Összes lövés:
                  <span style={(() => {
                    const currentShots = Object.values(manualScoreEntry.zones).reduce((acc, curr) => acc + (parseInt(curr) || 0), 0);
                    const bowCatShort = manualScoreEntry.participant?.bowCategory?.split('_').pop()?.toUpperCase() || '';
                    let expectedShotsPerTarget = Number(competition?.shotsPerTarget) || 0;
                    if (competition?.crossbowSingleShot && (bowCatShort === 'CRB' || bowCatShort === 'SZAMSZERIJ')) {
                      expectedShotsPerTarget = 1;
                    }
                    const maxShots = (Number(competition?.numberOfTargets) || 0) * expectedShotsPerTarget;
                    const isError = currentShots > maxShots;

                    return {
                      marginLeft: '8px',
                      display: 'inline-block',
                      transition: 'all 0.3s ease',
                      padding: isError ? '2px 10px' : '0',
                      borderRadius: '6px',
                      backgroundColor: isError ? 'rgba(220, 53, 69, 0.1)' : 'transparent',
                      border: isError ? '1px solid #dc3545' : 'none',
                      color: currentShots === maxShots ? '#28a745' : (isError ? '#dc3545' : '#b30000'),
                      animation: isError ? 'pulse-warning-error 0.6s infinite ease-in-out' : 'none',
                      fontWeight: '900',
                      fontSize: isError ? '1.1rem' : '0.9rem'
                    };
                  })()}>
                    {Object.values(manualScoreEntry.zones).reduce((acc, curr) => acc + (parseInt(curr) || 0), 0)}
                    / {(() => {
                      const bowCatShort = manualScoreEntry.participant?.bowCategory?.split('_').pop()?.toUpperCase() || '';
                      let expectedShotsPerTarget = Number(competition?.shotsPerTarget) || 0;
                      if (competition?.crossbowSingleShot && (bowCatShort === 'CRB' || bowCatShort === 'SZAMSZERIJ')) {
                        expectedShotsPerTarget = 1;
                      }
                      return (Number(competition?.numberOfTargets) || 0) * expectedShotsPerTarget;
                    })()}
                  </span>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))', gap: '10px' }}>
                {(competition?.scoringValues || ['11', '10', '8', '5', '0'])
                  .sort((a, b) => {
                    const valA = a === 'X' ? 11.5 : parseInt(a);
                    const valB = b === 'X' ? 11.5 : parseInt(b);
                    return valB - valA;
                  })
                  .map(zone => (
                  <div key={zone} style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    <div style={{
                      textAlign: 'center', backgroundColor: '#b30000', color: 'white',
                      borderRadius: '4px', padding: '2px', fontSize: '0.8rem', fontWeight: 'bold'
                    }}>
                      {zone}p
                    </div>
                    <input
                      type="number"
                      min="0"
                      style={{ ...formInputStyle, textAlign: 'center', padding: '5px' }}
                      value={manualScoreEntry.zones[zone] || ''}
                      onChange={(e) => {
                        const val = e.target.value === '' ? '' : parseInt(e.target.value);
                        const newZones = { ...manualScoreEntry.zones, [zone]: val };

                        // ÚJ: Az összpontszám automatikus újraszámolása, de CSAK ha a pontszámot NEM írták át kézzel
                        const newTotal = Object.entries(newZones).reduce((acc, [z, count]) => {
                          const v = z === 'X' ? 11 : parseInt(z) || 0;
                          return acc + (v * (parseInt(count) || 0));
                        }, 0);

                        setManualScoreEntry({
                          ...manualScoreEntry,
                          zones: newZones,
                          totalScore: newTotal === 0 ? '' : newTotal
                        });
                        if (manualScoreError) setManualScoreError(null);
                      }}
                      placeholder="0"
                    />
                  </div>
                ))}
              </div>
            </div>

            {manualScoreError && (
              <div style={{
                marginTop: '20px',
                padding: '12px 15px',
                backgroundColor: '#fff5f5',
                border: '1px solid #feb2b2',
                borderRadius: '8px',
                color: '#c53030',
                fontSize: '0.85rem',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                fontWeight: 'bold'
              }}>
                <FiAlertTriangle size={20} />
                {manualScoreError}
              </div>
            )}

            <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end', marginTop: '30px' }}>
              <button style={modalCancelButtonStyle} onClick={() => setShowManualScoreModal(false)}>Mégse</button>
              <button
                style={{
                  ...qrButtonStyle,
                  padding: '12px 20px',
                  backgroundColor: (() => {
                    if (competition?.status === 'Lezárt') return '#ccc';
                    const currentShots = Object.values(manualScoreEntry.zones).reduce((acc, curr) => acc + (parseInt(curr) || 0), 0);
                    const bowCatShort = manualScoreEntry.participant?.bowCategory?.split('_').pop()?.toUpperCase() || '';
                    let expectedShotsPerTarget = Number(competition?.shotsPerTarget) || 0;
                    if (competition?.crossbowSingleShot && (bowCatShort === 'CRB' || bowCatShort === 'SZAMSZERIJ')) {
                      expectedShotsPerTarget = 1;
                    }
                    const maxShots = (Number(competition?.numberOfTargets) || 0) * expectedShotsPerTarget;
                    const isTotalScoreEntered = Number(manualScoreEntry.totalScore) > 0;
                    return (currentShots === maxShots || isTotalScoreEntered) ? '#b30000' : '#ccc';
                  })(),
                  borderColor: (() => {
                    if (competition?.status === 'Lezárt') return '#ccc';
                    const currentShots = Object.values(manualScoreEntry.zones).reduce((acc, curr) => acc + (parseInt(curr) || 0), 0);
                    const bowCatShort = manualScoreEntry.participant?.bowCategory?.split('_').pop()?.toUpperCase() || '';
                    let expectedShotsPerTarget = Number(competition?.shotsPerTarget) || 0;
                    if (competition?.crossbowSingleShot && (bowCatShort === 'CRB' || bowCatShort === 'SZAMSZERIJ')) {
                      expectedShotsPerTarget = 1;
                    }
                    const maxShots = (Number(competition?.numberOfTargets) || 0) * expectedShotsPerTarget;
                    const isTotalScoreEntered = Number(manualScoreEntry.totalScore) > 0;
                    return (currentShots === maxShots || isTotalScoreEntered) ? '#b30000' : '#ccc';
                  })(),
                  cursor: (() => {
                    if (competition?.status === 'Lezárt') return 'not-allowed';
                    const currentShots = Object.values(manualScoreEntry.zones).reduce((acc, curr) => acc + (parseInt(curr) || 0), 0);
                    const bowCatShort = manualScoreEntry.participant?.bowCategory?.split('_').pop()?.toUpperCase() || '';
                    let expectedShotsPerTarget = Number(competition?.shotsPerTarget) || 0;
                    if (competition?.crossbowSingleShot && (bowCatShort === 'CRB' || bowCatShort === 'SZAMSZERIJ')) {
                      expectedShotsPerTarget = 1;
                    }
                    const maxShots = (Number(competition?.numberOfTargets) || 0) * expectedShotsPerTarget;
                    const isTotalScoreEntered = Number(manualScoreEntry.totalScore) > 0;
                    return (currentShots === maxShots || isTotalScoreEntered) ? 'pointer' : 'default';
                  })()
                }}
                onClick={handleSaveManualScore}
              >
                Eredmény hozzáadása
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- EREDMÉNYEK EXPORTÁLÁSA VÁLASZTÓ MODAL --- */}
      {showResultsExportModal && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '450px', textAlign: 'left' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #b30000', paddingBottom: '10px' }}>
              <h3 style={{ margin: 0, color: '#b30000' }}>Eredmények exportálása</h3>
              <div
                style={{ cursor: 'pointer', backgroundColor: '#f2f2f2', borderRadius: '50%', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => setShowResultsExportModal(false)}
              >
                <FiX size={20} color="#333" />
              </div>
            </div>

            <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '25px' }}>
              Válaszd ki az exportálandó lista típusát:
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '30px' }}>
              <label style={{
                display: 'flex', alignItems: 'center', gap: '12px', padding: '15px',
                borderRadius: '10px', border: `2px solid ${resultsExportType === 'full' ? '#b30000' : '#eee'}`,
                backgroundColor: resultsExportType === 'full' ? '#fff5f5' : '#fafafa',
                cursor: 'pointer', transition: '0.2s'
              }}>
                <input
                  type="radio"
                  name="exportType"
                  value="full"
                  checked={resultsExportType === 'full'}
                  onChange={() => setResultsExportType('full')}
                  style={{ accentColor: '#b30000', width: '18px', height: '18px' }}
                />
                <div>
                  <div style={{ fontWeight: 'bold', color: '#333' }}>Teljes eredménylista</div>
                  <div style={{ fontSize: '0.75rem', color: '#777' }}>Minden beírt pontszámmal rendelkező íjász kategóriánként.</div>
                </div>
              </label>

              <label style={{
                display: 'flex', alignItems: 'center', gap: '12px', padding: '15px',
                borderRadius: '10px', border: `2px solid ${resultsExportType === 'podium' ? '#b30000' : '#eee'}`,
                backgroundColor: resultsExportType === 'podium' ? '#fff5f5' : '#fafafa',
                cursor: 'pointer', transition: '0.2s'
              }}>
                <input
                  type="radio"
                  name="exportType"
                  value="podium"
                  checked={resultsExportType === 'podium'}
                  onChange={() => setResultsExportType('podium')}
                  style={{ accentColor: '#b30000', width: '18px', height: '18px' }}
                />
                <div>
                  <div style={{ fontWeight: 'bold', color: '#333' }}>Csak a dobogósok</div>
                  <div style={{ fontSize: '0.75rem', color: '#777' }}>Kategóriánként csak az 1., 2. és 3. helyezettek listája.</div>
                </div>
              </label>
            </div>

            <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
              <button style={modalCancelButtonStyle} onClick={() => setShowResultsExportModal(false)}>Mégse</button>
              <button
                style={{ ...qrButtonStyle, padding: '12px 25px' }}
                onClick={handleExportResultsToExcel}
              >
                <FiDownload /> Exportálás
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- ÚJ: SZÉTLÖVÉS (SHOOT-OFF) RÖGZÍTŐ MODAL --- */}
      {showShootOffModal && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '400px', textAlign: 'left' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #b30000', paddingBottom: '10px' }}>
              <h3 style={{ margin: 0, color: '#b30000' }}>Szétlövés eredménye</h3>
              <div
                style={{ cursor: 'pointer', backgroundColor: '#f2f2f2', borderRadius: '50%', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => setShowShootOffModal(false)}
              >
                <FiX size={20} color="#333" />
              </div>
            </div>

            <p style={{ color: '#666', fontSize: '0.85rem', marginBottom: '20px' }}>
              Add meg az íjászok helyezését a szétlövés alapján (1., 2., stb.). Az algoritmus ez alapján fogja rangsorolni őket.
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '25px' }}>
              {shootOffGroup.map(p => (
                <div key={p.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f9f9f9', padding: '10px', borderRadius: '8px', border: '1px solid #eee' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 'bold', fontSize: '0.95rem' }}>{p.fullName}</div>
                    <div style={{ fontSize: '0.7rem', color: '#888' }}>Össz: {p.totalScore} pont</div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>Hely:</span>
                    <input
                      type="number"
                      min="1"
                      max={shootOffGroup.length}
                      value={shootOffRanks[p.id] || ''}
                      onChange={(e) => setShootOffRanks(prev => ({ ...prev, [p.id]: e.target.value }))}
                      style={{ ...formInputStyle, width: '60px', textAlign: 'center', padding: '8px' }}
                      placeholder="-"
                    />
                  </div>
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
              <button style={modalCancelButtonStyle} onClick={() => setShowShootOffModal(false)}>Mégse</button>
              <button
                style={{ ...qrButtonStyle, opacity: shootOffSaving ? 0.7 : 1 }}
                onClick={handleSaveShootOff}
                disabled={shootOffSaving}
              >
                {shootOffSaving ? 'Mentés...' : 'Eredmény mentése'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- QR KÓD NYOMTATÓ MODAL (PORTAL) --- */}
      {showQrModal && createPortal(
        <div id="archery-nexus-qr-print-portal" className={qrPrintFormat === 'label_4x11' ? 'format-4x11' : (qrPrintFormat === 'label_margins' ? 'format-label-margins' : (qrPrintFormat === 'label' ? 'format-label' : 'format-a4'))}>
          <div className="no-print print-header-controls">
            <div style={{ textAlign: 'left' }}>
              <h3 style={{ margin: 0 }}>Nevezők QR kódjai ({selectedIds.size} fő kijelölve)</h3>
              <p style={{ margin: '5px 0 0 0', color: '#666' }}>{competition?.competitionName}</p>
            </div>

            <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {/* RENDEZÉS SOR */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end' }}>
                  <span style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#666', minWidth: '80px', textAlign: 'right' }}>Rendezés:</span>
                  <select
                    value={qrSortOrder}
                    onChange={(e) => setQrSortOrder(e.target.value)}
                    style={{
                      padding: '4px 8px',
                      borderRadius: '6px',
                      border: '1px solid #ccc',
                      fontSize: '0.85rem',
                      backgroundColor: 'white',
                      cursor: 'pointer',
                      width: '180px'
                    }}
                  >
                    <option value="name">Név szerint (ABC)</option>
                    <option value="team">Csapatszám szerint</option>
                  </select>
                </div>

                {/* FORMÁTUM SOR */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end' }}>
                  <span style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#666', minWidth: '80px', textAlign: 'right' }}>Formátum:</span>
                  <select
                    value={qrPrintFormat}
                    onChange={(e) => setQrPrintFormat(e.target.value)}
                    style={{
                      padding: '4px 8px',
                      borderRadius: '6px',
                      border: '1px solid #ccc',
                      fontSize: '0.85rem',
                      backgroundColor: 'white',
                      cursor: 'pointer',
                      width: '180px'
                    }}
                  >
                    <option value="a4">Normál A4</option>
                    <option value="label">Matrica A4 (24db 70x37)</option>
                    <option value="label_margins">Matrica A4 (24db - 13mm/9mm margó)</option>
                    <option value="label_4x11">Matrica A4 (44db - 48.5x25.4)</option>
                  </select>
                </div>

                {/* ÚJ: KIHAGYANDÓ MATRICÁK SOR (Csak matrica módban) */}
                {(qrPrintFormat === 'label' || qrPrintFormat === 'label_margins' || qrPrintFormat === 'label_4x11') && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end' }}>
                    <span style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#b30000', minWidth: '80px', textAlign: 'right' }}>Kezdés (kihagy):</span>
                    <input
                      type="number"
                      min="0"
                      max={qrPrintFormat === 'label_4x11' ? '43' : '23'}
                      value={qrSkipCount}
                      onChange={(e) => setQrSkipCount(Math.max(0, Math.min(qrPrintFormat === 'label_4x11' ? 43 : 23, parseInt(e.target.value) || 0)))}
                      style={{
                        padding: '4px 8px',
                        borderRadius: '6px',
                        border: '1px solid #b30000',
                        fontSize: '0.85rem',
                        width: '180px',
                        backgroundColor: '#fff'
                      }}
                    />
                  </div>
                )}
              </div>

              <div style={{ display: 'flex', gap: '10px' }}>
                <button style={printButtonStyle} onClick={() => window.print()}>
                  <FiPrinter /> Nyomtatás
                </button>
                <button style={closeButtonStyle} onClick={() => setShowQrModal(false)}>
                  <FiX /> Bezárás
                </button>
              </div>
            </div>
          </div>

          {/* ÚJ: CENTRÁLT NYOMTATÁSI TIPP SÚGÓ DOBOZ KÜLÖN BLOKKBAN A FEJLÉC ALATT */}
          {(qrPrintFormat === 'label' || qrPrintFormat === 'label_margins' || qrPrintFormat === 'label_4x11') && qrSkipCount > 0 && (
            <div className="no-print" style={{
              backgroundColor: '#fff9c4',
              border: '1px solid #fbc02d',
              borderRadius: '8px',
              padding: '10px 16px',
              fontSize: '0.85rem',
              color: '#5f4b00',
              margin: '0 auto 25px auto',
              textAlign: 'center',
              maxWidth: '1000px',
              boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
            }}>
              💡 <strong>Nyomtatási tipp:</strong> A kihagyás a lap <u>bal felső sarkától</u> számít (balról jobbra, fentről lefelé). Ha a nyomtató alulról húzza be a papírt, fordítsa el a matrica lapot 180°-kal!
            </div>
          )}

          <div className="printable-qr-grid" style={qrGridStyle}>
            {/* ÜRES HELYŐRZŐK A KIHAGYÁSHOZ */}
            {(qrPrintFormat === 'label' || qrPrintFormat === 'label_margins' || qrPrintFormat === 'label_4x11') && Array.from({ length: qrSkipCount }).map((_, i) => (
              <div key={`skip-${i}`} style={{ ...qrCardStyle, border: 'none', boxShadow: 'none', visibility: 'hidden' }} />
            ))}

            {participants
              .filter(p => selectedIds.has(p.id))
              .sort((a, b) => {
                if (qrSortOrder === 'name') {
                  return (a.fullName || '').localeCompare(b.fullName || '', 'hu');
                } else if (qrSortOrder === 'team') {
                  const teamA = parseInt(a.team) || 999;
                  const teamB = parseInt(b.team) || 999;
                  if (teamA !== teamB) return teamA - teamB;
                  return (a.fullName || '').localeCompare(b.fullName || '', 'hu');
                }
                return 0;
              })
              .map((p) => (
                <div key={p.id}
                  style={qrCardStyle}
                  className="qr-card"
                >
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
                    <QRCodeSVG value={generateParticipantQrString(p)} size={qrPrintFormat === 'label_4x11' ? 56 : ((qrPrintFormat === 'label' || qrPrintFormat === 'label_margins') ? 70 : 80)} />
                    <div style={{
                      fontSize: qrPrintFormat === 'label_4x11' ? '0.55rem' : ((qrPrintFormat === 'label' || qrPrintFormat === 'label_margins') ? '0.7rem' : '0.75rem'),
                      fontWeight: '900',
                      color: '#b30000',
                      fontFamily: 'monospace',
                      marginTop: '1px',
                      letterSpacing: '0.2px',
                      textAlign: 'center',
                      lineHeight: '1'
                    }}>
                      {generateParticipantId(p)}
                    </div>
                  </div>
                  <div style={{ ...qrCardInfoStyle, paddingLeft: qrPrintFormat === 'label_4x11' ? '4px' : qrCardInfoStyle.paddingLeft }}>
                    <div style={{ ...qrCardNameStyle, fontSize: qrPrintFormat === 'label_4x11' ? '0.7rem' : (qrPrintFormat === 'label' ? '0.85rem' : '1rem'), lineHeight: '1.1' }}>
                      {p.fullName}
                    </div>
                    <div style={{ fontSize: qrPrintFormat === 'label_4x11' ? '0.52rem' : '0.7rem', color: '#666', marginTop: '0px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.1' }}>
                      {formatClubName(p.club) || 'Egyéni induló'}
                    </div>
                    <div style={{ fontSize: qrPrintFormat === 'label_4x11' ? '0.6rem' : (qrPrintFormat === 'label' ? '0.75rem' : '0.85rem'), color: '#333', marginTop: '1px', fontWeight: 'bold', lineHeight: '1.1' }}>
                      {getShortBowCategoryLabel(p.bowCategory)} - {translationMap[p.ageCategory] || p.ageCategory}
                    </div>
                    {p.team && (
                      <div style={{ fontSize: qrPrintFormat === 'label_4x11' ? '0.52rem' : (qrPrintFormat === 'label' ? '0.75rem' : '0.85rem'), color: '#b30000', marginTop: '0px', lineHeight: '1.1' }}>
                        Csapat: <span style={{ fontWeight: 'bold' }}>{p.team}</span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
          </div>

          <style>{`
            #archery-nexus-qr-print-portal {
              position: fixed; top: 0; left: 0; right: 0; bottom: 0;
              background: white; z-index: 10005; padding: 40px; overflow-y: auto;
            }
            .print-header-controls {
              display: flex; justify-content: space-between; align-items: center;
              margin-bottom: 30px; padding-bottom: 20px; border-bottom: 1px solid #eee;
              max-width: 1000px; margin: 0 auto 30px;
            }

            @media print {
              @page {
                size: A4 portrait;
                margin: ${qrPrintFormat === 'label_4x11' ? '8mm 8mm 9mm 8mm' : (qrPrintFormat === 'label_margins' ? '13mm 9mm 13mm 9mm' : (qrPrintFormat === 'label' ? '0' : '5mm'))} !important;
              }

              * { box-sizing: border-box !important; }

              html, body {
                width: 100% !important;
                height: auto !important;
                margin: 0 !important;
                padding: 0 !important;
                overflow: visible !important;
                background: white !important;
              }

              /* A teljes fő React gyökeret elrejtjük */
              #root { display: none !important; }
              body > *:not(#archery-nexus-qr-print-portal) { display: none !important; }

              #archery-nexus-qr-print-portal {
                position: static !important;
                display: block !important;
                width: 100% !important;
                margin: 0 !important;
                padding: ${qrPrintFormat === 'label' ? '0' : '0'} !important;
                overflow: visible !important;
              }

              .no-print { display: none !important; }

              .format-a4 .printable-qr-grid {
                display: grid !important;
                grid-template-columns: repeat(3, 1fr) !important;
                grid-auto-rows: 32mm !important;
                gap: 1.5mm !important;
                width: 100% !important;
              }

              .format-label .printable-qr-grid, .format-label-margins .printable-qr-grid {
                display: grid !important;
                grid-template-columns: 70mm 70mm 70mm !important;
                grid-auto-rows: 37mm !important;
                gap: 0 !important;
                width: 210mm !important;
                padding: 0 !important;
                margin: 0 !important;
              }

              .format-4x11 .printable-qr-grid {
                display: grid !important;
                grid-template-columns: repeat(4, 48.5mm) !important;
                grid-auto-rows: 25.4mm !important;
                gap: 0 !important;
                width: 210mm !important;
                padding: 0 !important;
                margin: 0 !important;
              }

              .format-a4 .qr-card {
                border: 0.5px solid #ccc !important;
                padding: 2mm 3mm !important;
                display: flex !important;
                flex-direction: row !important;
                align-items: center !important;
                overflow: hidden !important;
                page-break-inside: avoid !important;
                break-inside: avoid !important;
                background: white !important;
                height: 32mm !important;
              }

              .format-label .qr-card, .format-label-margins .qr-card {
                border: none !important;
                padding: 2mm 3mm 2mm 7mm !important;
                display: flex !important;
                flex-direction: row !important;
                align-items: center !important;
                overflow: hidden !important;
                page-break-inside: avoid !important;
                break-inside: avoid !important;
                background: white !important;
                width: 70mm !important;
                height: 37mm !important;
              }

              .format-4x11 .qr-card {
                border: none !important;
                padding: 1mm 1mm 1mm 1mm !important;
                display: flex !important;
                flex-direction: row !important;
                align-items: center !important;
                overflow: hidden !important;
                page-break-inside: avoid !important;
                break-inside: avoid !important;
                background: white !important;
                width: 48.5mm !important;
                height: 25.4mm !important;
              }

              * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            }
          `}</style>
        </div>,
        document.body
      )}

      {/* --- ÚJ NEVEZŐ HOZZÁADÁSA MODAL --- */}
      {showAddModal && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '600px', textAlign: 'left' }}>
            <h3 style={{ ...resultGroupTitleStyle, marginBottom: '20px' }}>Helyszíni nevező regisztrálása</h3>

            <div style={formGridStyle}>
              <div style={inputGroupStyle}>
                <label style={labelStyle}>Név</label>
                <input
                  style={formInputStyle}
                  type="text"
                  value={newParticipant.fullName}
                  onChange={(e) => setNewParticipant({...newParticipant, fullName: e.target.value})}
                  placeholder="Versenyző teljes neve"
                />
              </div>

              <div style={inputGroupStyle}>
                <label style={labelStyle}>Egyesület / Csapat</label>
                <div style={{ position: 'relative' }}>
                  <input
                    style={formInputStyle}
                    type="text"
                    value={newParticipant.club}
                    onChange={(e) => handleClubChange(e.target.value, false)}
                    placeholder="Egyesület neve (üresen: Egyéb)"
                  />
                  {showAddClubSuggestions && (
                    <div style={autocompleteContainerStyle}>
                      {clubSuggestions.map((club, idx) => (
                        <div
                          key={idx}
                          style={autocompleteItemStyle}
                          onClick={() => {
                            setNewParticipant({ ...newParticipant, club: club });
                            setShowAddClubSuggestions(false);
                          }}
                        >
                          {club}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div style={inputGroupStyle}>
                <label style={labelStyle}>Versenyengedély</label>
                <input
                  style={formInputStyle}
                  type="text"
                  value={newParticipant.license}
                  onChange={(e) => setNewParticipant({...newParticipant, license: e.target.value})}
                  placeholder="Engedély száma (opcionális)"
                />
              </div>

              <div style={inputGroupStyle}>
                <label style={labelStyle}>Íjkategória</label>
                <select
                  style={{ ...selectStyle, width: '100%' }}
                  value={newParticipant.bowCategory}
                  onChange={(e) => setNewParticipant({...newParticipant, bowCategory: e.target.value})}
                >
                  <option value="">Válassz kategóriát...</option>
                  {competition?.categories?.map(catId => {
                    const label = translationMap[catId] || catId;
                    return <option key={catId} value={catId}>{label}</option>;
                  })}
                </select>
              </div>

              <div style={inputGroupStyle}>
                <label style={labelStyle}>Korosztály</label>
                <select
                  style={{ ...selectStyle, width: '100%' }}
                  value={newParticipant.ageCategory}
                  onChange={(e) => setNewParticipant({...newParticipant, ageCategory: e.target.value})}
                >
                  <option value="">Válassz korosztályt...</option>
                  {competition?.ageCategories?.map(ageId => {
                    const label = translationMap[ageId] || ageId;
                    return <option key={ageId} value={ageId}>{label}</option>;
                  })}
                </select>
              </div>

              <div style={inputGroupStyle}>
                <label style={labelStyle}>Nem</label>
                <select
                  style={{ ...selectStyle, width: '100%' }}
                  value={newParticipant.gender}
                  onChange={(e) => setNewParticipant({...newParticipant, gender: e.target.value})}
                >
                  <option value="Férfi">Férfi</option>
                  <option value="Nő">Nő</option>
                </select>
              </div>

              <div style={inputGroupStyle}>
                <label style={labelStyle}>Ebéd</label>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', backgroundColor: '#fafafa', padding: '10px', borderRadius: '8px', border: '1px solid #eee' }}>
                  {['A', 'B', 'C'].map(menuKey => {
                    const menu = competition?.lunches?.[menuKey];
                    if (!menu || !menu.name) return null;
                    const count = newParticipant.lunchSelections?.[menuKey] || 0;
                    return (
                      <div key={menuKey} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <span style={{ fontWeight: 'bold', color: '#b30000', width: '15px' }}>{menuKey}</span>
                        <span style={{ flex: 1, fontSize: '0.85rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={menu.name}>
                          {menu.name}
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <button
                            type="button"
                            onClick={() => handleLunchChange(menuKey, -1, false)}
                            style={{ width: '26px', height: '26px', borderRadius: '50%', border: '1px solid #ccc', backgroundColor: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                          >-</button>
                          <span style={{ fontWeight: 'bold', minWidth: '20px', textAlign: 'center' }}>{count}</span>
                          <button
                            type="button"
                            onClick={() => handleLunchChange(menuKey, 1, false)}
                            style={{ width: '26px', height: '26px', borderRadius: '50%', border: '1px solid #b30000', backgroundColor: '#fff', color: '#b30000', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                          >+</button>
                        </div>
                      </div>
                    );
                  })}
                  {(!competition?.lunches || !Object.values(competition.lunches).some(m => m.name)) && (
                    <span style={{ fontSize: '0.8rem', color: '#888', fontStyle: 'italic' }}>Nincs beállított menü</span>
                  )}
                </div>
              </div>

              <div style={inputGroupStyle}>
                <label style={labelStyle}>Csapat</label>
                <select
                  style={selectStyle}
                  value={newParticipant.team || ''}
                  onChange={(e) => setNewParticipant({...newParticipant, team: e.target.value === '' ? null : parseInt(e.target.value)})}
                >
                  <option value="">Nincs csapatban (Várólista)</option>
                  {Array.from({ length: Number(competition?.numberOfTeams) || 20 }, (_, i) => i + 1).map(num => (
                    <option key={num} value={num}>{num}. csapat</option>
                  ))}
                </select>
              </div>

              <div style={{ ...inputGroupStyle, gridColumn: 'span 2' }}>
                <label style={labelStyle}>Megjegyzés</label>
                <textarea
                  style={{ ...formInputStyle, minHeight: '60px', paddingTop: '10px' }}
                  value={newParticipant.comment}
                  onChange={(e) => setNewParticipant({...newParticipant, comment: e.target.value})}
                  placeholder="Pl. csapattárs kérése..."
                />
              </div>
            </div>

            <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end', marginTop: '25px' }}>
              <button style={modalCancelButtonStyle} onClick={() => setShowAddModal(false)} disabled={isSavingParticipant}>Mégse</button>
              <button
                style={{...qrButtonStyle, opacity: isSavingParticipant ? 0.7 : 1}}
                onClick={handleSaveNewParticipant}
                disabled={isSavingParticipant}
              >
                {isSavingParticipant ? 'Mentés...' : 'Mentés és Rögzítés'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- NEVEZŐ SZERKESZTÉSE MODAL --- */}
      {showEditModal && editData && (
        <div style={modalOverlayStyle}>
          <div style={{ ...modalContentStyle, maxWidth: '500px', textAlign: 'left' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #b30000', paddingBottom: '10px' }}>
              <h3 style={{ margin: 0, color: '#b30000' }}>Nevező adatainak módosítása</h3>
              <div
                style={{ cursor: 'pointer', backgroundColor: '#f2f2f2', borderRadius: '50%', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => setShowEditModal(false)}
              >
                <FiX size={20} color="#333" />
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <div style={inputGroupStyle}>
                <label style={labelStyle}>Név</label>
                <input
                  style={formInputStyle}
                  type="text"
                  value={editData.fullName}
                  onChange={(e) => setEditData({...editData, fullName: e.target.value})}
                />
              </div>

              <div style={inputGroupStyle}>
                <label style={labelStyle}>Egyesület</label>
                <div style={{ position: 'relative' }}>
                  <input
                    style={formInputStyle}
                    type="text"
                    value={editData.club || ''}
                    onChange={(e) => handleClubChange(e.target.value, true)}
                    placeholder="Egyesület neve"
                  />
                  {showEditClubSuggestions && (
                    <div style={autocompleteContainerStyle}>
                      {clubSuggestions.map((club, idx) => (
                        <div
                          key={idx}
                          style={autocompleteItemStyle}
                          onClick={() => {
                            setEditData({ ...editData, club: club });
                            setShowEditClubSuggestions(false);
                          }}
                        >
                          {club}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div style={inputGroupStyle}>
                <label style={labelStyle}>Versenyengedély</label>
                <input
                  style={formInputStyle}
                  type="text"
                  value={editData.license || ''}
                  onChange={(e) => setEditData({...editData, license: e.target.value})}
                  placeholder="Engedély száma"
                />
              </div>

              <div style={inputGroupStyle}>
                <label style={labelStyle}>Íjkategória</label>
                <select
                  style={selectStyle}
                  value={editData.bowCategory}
                  onChange={(e) => setEditData({...editData, bowCategory: e.target.value})}
                >
                  {competition?.categories?.map(catId => (
                    <option key={catId} value={catId}>{translationMap[catId] || catId}</option>
                  ))}
                </select>
              </div>

              <div style={inputGroupStyle}>
                <label style={labelStyle}>Korosztály</label>
                <select
                  style={selectStyle}
                  value={editData.ageCategory}
                  onChange={(e) => setEditData({...editData, ageCategory: e.target.value})}
                >
                  {competition?.ageCategories?.map(ageId => (
                    <option key={ageId} value={ageId}>{translationMap[ageId] || ageId}</option>
                  ))}
                </select>
              </div>

              <div style={inputGroupStyle}>
                <label style={labelStyle}>Nem</label>
                <select
                  style={selectStyle}
                  value={editData.gender}
                  onChange={(e) => setEditData({...editData, gender: e.target.value})}
                >
                  <option value="Férfi">Férfi</option>
                  <option value="Nő">Nő</option>
                </select>
              </div>

              {/* ÚJ EBÉD VÁLASZTÓ A SZERKESZTÉSNÉL IS */}
              <div style={inputGroupStyle}>
                <label style={labelStyle}>Ebéd</label>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', backgroundColor: '#fafafa', padding: '10px', borderRadius: '8px', border: '1px solid #eee' }}>
                  {['A', 'B', 'C'].map(menuKey => {
                    const menu = competition?.lunches?.[menuKey];
                    if (!menu || !menu.name) return null;
                    const count = editData.lunchSelections?.[menuKey] || 0;
                    return (
                      <div key={menuKey} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <span style={{ fontWeight: 'bold', color: '#b30000', width: '15px' }}>{menuKey}</span>
                        <span style={{ flex: 1, fontSize: '0.85rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={menu.name}>
                          {menu.name}
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <button
                            type="button"
                            onClick={() => handleLunchChange(menuKey, -1, true)}
                            style={{ width: '26px', height: '26px', borderRadius: '50%', border: '1px solid #ccc', backgroundColor: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                          >-</button>
                          <span style={{ fontWeight: 'bold', minWidth: '20px', textAlign: 'center' }}>{count}</span>
                          <button
                            type="button"
                            onClick={() => handleLunchChange(menuKey, 1, true)}
                            style={{ width: '26px', height: '26px', borderRadius: '50%', border: '1px solid #b30000', backgroundColor: '#fff', color: '#b30000', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                          >+</button>
                        </div>
                      </div>
                    );
                  })}
                  {(!competition?.lunches || !Object.values(competition.lunches).some(m => m.name)) && (
                    <span style={{ fontSize: '0.8rem', color: '#888', fontStyle: 'italic' }}>Nincs beállított menü</span>
                  )}
                </div>
              </div>

              <div style={inputGroupStyle}>
                <label style={labelStyle}>Csapat</label>
                <select
                  style={selectStyle}
                  value={editData.team || ''}
                  onChange={(e) => setEditData({...editData, team: e.target.value === '' ? null : parseInt(e.target.value)})}
                >
                  <option value="">Nincs csapatban (Várólista)</option>
                  {Array.from({ length: Number(competition?.numberOfTeams) || 20 }, (_, i) => i + 1).map(num => (
                    <option key={num} value={num}>{num}. csapat</option>
                  ))}
                </select>
              </div>

              <div style={inputGroupStyle}>
                <label style={labelStyle}>Megjegyzés</label>
                <textarea
                  style={{ ...formInputStyle, minHeight: '60px', paddingTop: '10px' }}
                  value={editData.comment || ''}
                  onChange={(e) => setEditData({...editData, comment: e.target.value})}
                  placeholder="Megjegyzés..."
                />
              </div>
            </div>

            <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end', marginTop: '30px' }}>
              <button style={modalCancelButtonStyle} onClick={() => setShowEditModal(false)}>Mégse</button>
              <button style={qrButtonStyle} onClick={handleUpdateParticipant}>Módosítások mentése</button>
            </div>
          </div>
        </div>
      )}

      {/* --- CSAPATBEOSZTÁS NYOMTATÓ MODAL (PORTAL) --- */}
      {showTeamsPrintModal && createPortal(
        <div id="archery-nexus-print-portal">
          <div className="no-print print-header-controls">
            <div style={{ textAlign: 'left' }}>
              <h3 style={{ margin: 0 }}>Csapatbeosztás (Rajtlista)</h3>
              <p style={{ margin: '5px 0 0 0', color: '#666' }}>{competition?.competitionName}</p>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button style={{ ...printButtonStyle, backgroundColor: '#b30000' }} onClick={() => window.print()}><FiPrinter /> Nyomtatás</button>
              <button style={{ ...closeButtonStyle, backgroundColor: '#6c757d' }} onClick={() => setShowTeamsPrintModal(false)}><FiX /> Bezárás</button>
            </div>
          </div>

          <div className="print-grid-container">
            {/* 1. LAP FEJLÉC - CSAK EGYSZER */}
            <div className="print-brand-header">
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                <img src={logo} alt="Logo" style={{ height: '70px' }} />
                <div style={{ textAlign: 'left' }}>
                  <h1 style={{ margin: 0, color: '#b30000', fontSize: '3rem', fontWeight: '900' }}>ArcheryNexus</h1>
                </div>
              </div>

              {/* FACEBOOK QR KÓD ÉS SZÖVEG (JOBB OLDAL) */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '2px 10px', borderRadius: '10px', border: '1px solid #eee', backgroundColor: '#fdfdfd' }}>
                <div style={{ textAlign: 'right', maxWidth: '130px' }}>
                  <p style={{ margin: 0, fontSize: '0.95rem', fontWeight: '900', color: '#333', lineHeight: '1.1' }}>
                    Kövess minket facebookon is!
                  </p>
                </div>
                <QRCodeSVG
                  value="https://www.facebook.com/profile.php?id=61580003427158"
                  size={80}
                  level="M"
                  includeMargin={false}
                />
              </div>
            </div>

            {/* STRUKTÚRA TÁBLÁZAT A MARGÓKHOZ */}
            <table className="print-main-table-wrapper">
              <thead>
                <tr>
                  <td>
                    <div className="print-page-top-margin"></div>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="print-teams-grid">
                      {teamsData.filter(team => team.members && team.members.length > 0).map((team) => (
                        <div key={team.number} className="print-team-card">
                          <h4 style={teamPrintHeaderStyle}>{team.number}. Csapat</h4>
                          <table style={teamPrintTableStyle}>
                            <thead>
                              <tr>
                                <th style={{ ...teamPrintThStyle, width: '42%' }}>Név</th>
                                <th style={{ ...teamPrintThStyle, width: '23%', fontSize: '0.65rem', lineHeight: '1.1' }}>Kat./<br/>Kor</th>
                                <th style={{ ...teamPrintThStyle, width: '35%' }}>Egyesület</th>
                              </tr>
                            </thead>
                            <tbody>
                              {team.members.map((m) => (
                                <tr key={m.id}>
                                  <td style={{ ...teamPrintTdStyle, fontWeight: 'bold', verticalAlign: 'top' }}>
                                    {m.fullName}
                                  </td>
                                  <td style={{ ...teamPrintTdStyle, verticalAlign: 'top', fontSize: '0.8rem' }}>
                                    <div style={{ fontWeight: 'bold' }}>{getShortBowCategoryLabel(m.bowCategory)}</div>
                                    <div style={{ color: '#666' }}>{translationMap[m.ageCategory] || m.ageCategory}</div>
                                  </td>
                                  <td style={{ ...teamPrintTdStyle, verticalAlign: 'top', fontSize: '0.7rem', position: 'relative', overflow: 'hidden' }}>
                                    <div className="print-club-fade">
                                      {m.club || 'Egyéni induló'}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                              {team.members.length === 0 && (
                                <tr><td colSpan="3" style={{ ...teamPrintTdStyle, color: '#ccc', fontStyle: 'italic', textAlign: 'center' }}>Üres csapat</td></tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      ))}
                    </div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>
                    <div className="print-footer-nexus">
                      <span>Nyomtatva: {new Date().toLocaleDateString('hu-HU')}</span>
                      <span>www.archerynexus.com</span>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <style>{`
            #archery-nexus-print-portal {
              position: fixed; top: 0; left: 0; right: 0; bottom: 0;
              background: white; z-index: 10005; padding: 40px; overflow-y: auto;
            }
            .print-header-controls {
              display: flex; justify-content: space-between; align-items: center;
              margin-bottom: 30px; padding-bottom: 20px; border-bottom: 1px solid #eee;
              max-width: 1100px; margin: 0 auto 30px;
            }
            .print-grid-container { max-width: 1100px; margin: 0 auto; }
            .print-main-table-wrapper { width: 100%; border-collapse: collapse; border: none; }
            .print-page-top-margin { height: 0px; }
            .print-brand-header, .print-footer-nexus { display: none; }

            .print-teams-grid {
              display: grid; grid-template-columns: repeat(3, 1fr); gap: 2mm;
            }
            .print-team-card { border: 1px solid #eee; border-radius: 8px; padding: 15px; }

            .print-club-fade {
              height: 3.6em; /* FIX magasság 3 sorhoz, hogy a fade ne másszon feljebb */
              line-height: 1.2;
              overflow: hidden;
              position: relative;
              padding-right: 2px;
            }
            .print-club-fade::after {
              content: "";
              position: absolute;
              bottom: 0;
              right: 0;
              width: 50%; /* Csak a sor végét halványítjuk */
              height: 1.2em; /* Csak az utolsó (3.) sor magasságában */
              background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 90%);
              pointer-events: none;
            }

            @media print {
              @page { size: A4 portrait; margin: 0 !important; }

              /* ATOMBIZTOS MÉRETEZÉS */
              * { box-sizing: border-box !important; }
              html, body {
                width: 210mm !important;
                height: auto !important;
                margin: 0 !important;
                padding: 0 !important;
                overflow: visible !important;
                background: white !important;
              }
              #root { display: none !important; }
              body > *:not(#archery-nexus-print-portal) { display: none !important; }

              #archery-nexus-print-portal {
                position: static !important;
                display: block !important;
                width: 210mm !important;
                margin: 0 auto !important;
                padding: 10mm 15mm !important;
                overflow: visible !important;
              }

              #archery-nexus-print-portal * { visibility: visible !important; }

              .no-print { display: none !important; }

              .print-brand-header {
                display: flex !important;
                justify-content: space-between !important;
                align-items: center !important;
                gap: 25px !important;
                margin-bottom: 15px !important;
                border-bottom: 4px solid #b30000 !important;
                padding-bottom: 10px !important;
                width: 100% !important;
              }

              .print-page-top-margin {
                display: block !important;
                height: 15mm !important; /* EZ TOLJA LE A TARTALMAT MINDEN LAPON */
              }

              .print-teams-grid {
                display: grid !important;
                grid-template-columns: 1fr 1fr 1fr !important;
                gap: 1.5mm !important;
                width: 100% !important;
                justify-content: center !important;
              }

              .print-team-card {
                border: 0.5px solid #000 !important;
                padding: 3mm !important;
                page-break-inside: avoid !important;
                break-inside: avoid !important;
                background: white !important;
              }

              .print-footer-nexus {
                display: flex !important;
                justify-content: space-between !important;
                font-size: 10px !important;
                color: #555 !important;
                border-top: 0.5px solid #eee !important;
                padding-top: 5px !important;
                margin-top: 10mm !important;
              }

              * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            }
          `}</style>
        </div>,
        document.body
      )}

      {/* --- CÉLOK NYOMTATÓ MODAL (PORTAL) --- */}
      {showTargetsPrintModal && createPortal(
        <div id="archery-nexus-targets-print-portal">
          <div className="no-print print-header-controls">
            <div style={{ textAlign: 'left' }}>
              <h3 style={{ margin: 0 }}>Célok és Távolságok listája</h3>
              <p style={{ margin: '5px 0 0 0', color: '#666' }}>{competition?.competitionName}</p>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button style={{ ...printButtonStyle, backgroundColor: '#b30000' }} onClick={() => window.print()}>
                <FiPrinter /> Nyomtatás
              </button>
              <button style={{ ...closeButtonStyle, backgroundColor: '#6c757d' }} onClick={() => setShowTargetsPrintModal(false)}>
                <FiX /> Bezárás
              </button>
            </div>
          </div>

          <div className="print-targets-container">
            <div className="print-brand-header">
              <img src={logo} alt="Logo" style={{ height: '45px' }} />
              <div style={{ textAlign: 'left' }}>
                <h1 style={{ margin: 0, color: '#b30000', fontSize: '1.8rem', fontWeight: '900' }}>ArcheryNexus</h1>
                <p style={{ margin: 0, fontSize: '0.85rem', color: '#333', fontWeight: 'bold' }}>Pályabejárási Lap - {competition?.competitionName}</p>
              </div>
            </div>

            <table className="print-targets-table" style={{ width: '100%', borderCollapse: 'collapse', marginTop: '6px', fontSize: '0.8rem' }}>
              <thead>
                <tr style={{ backgroundColor: '#f2f2f2', height: '8mm' }}>
                  <th style={{ border: '1px solid #333', padding: '0 6px', textAlign: 'center', width: '40px', height: '8mm' }}>#</th>
                  <th style={{ border: '1px solid #333', padding: '0 6px', textAlign: 'left', height: '8mm' }}>Cél megnevezése</th>
                  <th style={{ border: '1px solid #333', padding: '0 6px', textAlign: 'center', width: '70px', color: '#b30000', height: '8mm' }}>Piros (m)</th>
                  <th style={{ border: '1px solid #333', padding: '0 6px', textAlign: 'center', width: '70px', color: '#007bff', height: '8mm' }}>Kék (m)</th>
                  <th style={{ border: '1px solid #333', padding: '0 6px', textAlign: 'center', width: '70px', color: '#333', height: '8mm' }}>Fehér (m)</th>
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: Number(competition?.numberOfTargets) || 0 }, (_, i) => i + 1).map(num => (
                  <tr key={num} style={{ height: '9.1mm' }}>
                    <td style={{ border: '1px solid #333', padding: '0 6px', textAlign: 'center', fontWeight: 'bold', height: '9.1mm' }}>{num}.</td>
                    <td style={{ border: '1px solid #333', padding: '0 6px', textAlign: 'left', fontWeight: 'bold', height: '9.1mm' }}>
                      {localTargetDetails[num]?.name || '-'}
                    </td>
                    <td style={{ border: '1px solid #333', padding: '0 6px', textAlign: 'center', fontWeight: 'bold', color: '#b30000', height: '9.1mm' }}>
                      {localTargetDetails[num]?.distRed || '-'}
                    </td>
                    <td style={{ border: '1px solid #333', padding: '0 6px', textAlign: 'center', fontWeight: 'bold', color: '#007bff', height: '9.1mm' }}>
                      {localTargetDetails[num]?.distBlue || '-'}
                    </td>
                    <td style={{ border: '1px solid #333', padding: '0 6px', textAlign: 'center', fontWeight: 'bold', color: '#333', height: '9.1mm' }}>
                      {localTargetDetails[num]?.distWhite || '-'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <style>{`
            #archery-nexus-targets-print-portal {
              position: fixed; top: 0; left: 0; right: 0; bottom: 0;
              background: white; z-index: 10005; padding: 20px; overflow-y: auto;
            }
            .print-header-controls {
              display: flex; justify-content: space-between; align-items: center;
              margin-bottom: 20px; padding-bottom: 15px; border-bottom: 1px solid #eee;
              max-width: 800px; margin: 0 auto 20px;
            }
            .print-targets-container { max-width: 800px; margin: 0 auto; }

            @media print {
              @page { size: A4 portrait; margin: 5mm !important; }
              #root { display: none !important; }
              body > *:not(#archery-nexus-targets-print-portal) { display: none !important; }
              html, body {
                width: 100% !important;
                height: auto !important;
                margin: 0 !important;
                padding: 0 !important;
                background: white !important;
              }
              #archery-nexus-targets-print-portal {
                position: static !important;
                display: block !important;
                width: 100% !important;
                margin: 0 !important;
                padding: 0 !important;
                overflow: visible !important;
              }
              .no-print { display: none !important; }
              .print-targets-container {
                width: 100% !important;
                max-width: none !important;
                margin: 0 !important;
                padding: 0 !important;
              }
              .print-brand-header {
                display: flex !important;
                align-items: center !important;
                gap: 20px !important;
                margin-bottom: 8px !important;
                border-bottom: 3px solid #b30000 !important;
                padding-bottom: 6px !important;
              }
              .print-targets-table {
                width: 100% !important;
                border-collapse: collapse !important;
                table-layout: fixed !important;
                margin-top: 6px !important;
              }
              .print-targets-table th {
                border: 1px solid #333 !important;
                vertical-align: middle !important;
                box-sizing: border-box !important;
                background-color: #f2f2f2 !important;
                font-weight: bold !important;
                padding: 0 6px !important;
                font-size: 0.8rem !important;
                text-align: center !important;
                height: 8mm !important;
              }
              .print-targets-table td {
                border: 1px solid #333 !important;
                vertical-align: middle !important;
                box-sizing: border-box !important;
                padding: 0 6px !important;
                font-size: 0.8rem !important;
                height: 9.1mm !important;
              }
              .print-targets-table tbody tr {
                height: 9.1mm !important;
                page-break-inside: avoid !important;
                break-inside: avoid !important;
              }
                page-break-inside: avoid !important;
                break-inside: avoid !important;
              }
              * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
            }
          `}</style>
        </div>,
        document.body
      )}

      {/* LÁTHATATLAN TRIGGER SÁV A MENÜ ELŐHOZÁSÁHOZ */}
      {!isSidebarOpen && (
        <div
          onMouseEnter={() => setIsSidebarOpen(true)}
          style={{
            position: 'fixed',
            left: 0,
            top: '64px',
            bottom: 0,
            width: '15px',
            zIndex: 1000,
            backgroundColor: 'transparent'
          }}
        />
      )}

      {/* OLDALSÁV (SIDEBAR) */}
      <div
        style={sidebarStyle(isSidebarOpen)}
        className="no-print"
        onMouseLeave={() => setIsSidebarOpen(false)}
      >
        {/* FOGANTYÚ GOMB (HANDLE) */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            setIsSidebarOpen(!isSidebarOpen);
          }}
          style={{
            position: 'absolute',
            top: '40%',
            right: '-40px',
            width: '40px',
            height: '100px',
            backgroundColor: '#b30000',
            color: 'white',
            border: 'none',
            borderRadius: '0 8px 8px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: '4px 0 10px rgba(0,0,0,0.1)',
            zIndex: 1002,
            padding: '5px'
          }}
          title={isSidebarOpen ? "Menü elrejtése" : "Menü megjelenítése"}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span style={{
              writingMode: 'vertical-rl',
              textOrientation: 'upright',
              fontSize: '0.8rem',
              fontWeight: '900',
              letterSpacing: '-2px',
              lineHeight: '1'
            }}>Menü</span>
            {isSidebarOpen ? <FiChevronLeft size={16} /> : <FiChevronRight size={16} />}
          </div>
        </button>

        <div style={sidebarHeaderStyle}>
          <button onClick={() => navigate('/egyesulet-dashboard')} style={backButtonStyle}>
            <FiArrowLeft /> Vissza
          </button>
          <h3 style={sidebarTitleStyle}>{competition?.competitionName}</h3>

          {/* --- ÚJ: SZINKRONIZÁLÁS ÁLLAPOT JELZŐ --- */}
          {(pendingOfflineCount > 0 || isSyncing) && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '6px 10px',
              backgroundColor: isSyncing ? '#e6f6ff' : '#fff5f5',
              borderRadius: '6px',
              marginBottom: '10px',
              border: `1px solid ${isSyncing ? '#bee3f8' : '#feb2b2'}`,
              fontSize: '0.75rem',
              color: isSyncing ? '#2b6cb0' : '#c53030',
              fontWeight: 'bold',
              animation: isSyncing ? 'pulse-sync 1.5s infinite' : 'none'
            }}>
              <span>{isSyncing ? '🔄 Szinkronizálás...' : `⏳ ${pendingOfflineCount} adat feltöltésre vár`}</span>
            </div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <span style={statusBadgeStyle}>{competition?.status || 'Aktív'}</span>
            {(isArchived || competition?.status === 'Ready to Upload') && (
              <span style={{
                backgroundColor: '#eee',
                color: '#666',
                padding: '2px 8px',
                borderRadius: '4px',
                fontSize: '0.7rem',
                fontWeight: 'bold',
                textAlign: 'center',
                border: '1px solid #ddd'
              }}>
                {competition?.status === 'Ready to Upload' ? 'ZÁRVA / FELTÖLTÉSRE VÁR' : 'ARCHIVÁLT'}
              </span>
            )}
          </div>
        </div>

        <nav style={navStyle}>
          {menuItems.map((item) => {
            if (item.id === 'documents') {
              return (
                <div key="documents-dropdown" style={{ display: 'flex', flexDirection: 'column' }}>
                  <button
                    type="button"
                    onClick={() => setIsDocsMenuOpen(!isDocsMenuOpen)}
                    style={{
                      ...tabButtonStyle(activeTab === 'score-sheet' || activeTab === 'documents'),
                      display: 'flex',
                      justify: 'space-between',
                      alignItems: 'center',
                      width: '100%'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={iconStyle}><FiFileText /></span>
                      <span>Dokumentumok</span>
                    </div>
                    {isDocsMenuOpen ? <FiChevronUp size={16} /> : <FiChevronDown size={16} />}
                  </button>

                  {isDocsMenuOpen && (
                    <div style={{ paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '2px', marginTop: '2px', marginBottom: '6px' }}>
                      <button
                        type="button"
                        onClick={() => {
                          setActiveTab('score-sheet');
                          setIsSidebarOpen(false);
                        }}
                        style={{
                          ...tabButtonStyle(activeTab === 'score-sheet'),
                          fontSize: '0.85rem',
                          padding: '8px 12px',
                          backgroundColor: activeTab === 'score-sheet' ? '#fff5f5' : 'transparent',
                          color: activeTab === 'score-sheet' ? '#b30000' : '#333',
                          borderRadius: '6px'
                        }}
                      >
                        🎯 Beírólap
                      </button>

                      <button
                        type="button"
                        disabled
                        style={{
                          ...tabButtonStyle(false),
                          fontSize: '0.85rem',
                          padding: '8px 12px',
                          color: '#aaa',
                          opacity: 0.5,
                          cursor: 'not-allowed'
                        }}
                        title="Hamarosan"
                      >
                        📜 Oklevél (Hamarosan)
                      </button>
                    </div>
                  )}
                </div>
              );
            }

            return (
              <button
                key={item.id}
                onClick={() => {
                  setActiveTab(item.id);
                  setIsSidebarOpen(false); // Bezárjuk navigáció után
                }}
                style={tabButtonStyle(activeTab === item.id)}
              >
                <span style={iconStyle}>{item.icon}</span>
                {item.label}
              </button>
            );
          })}

          <div style={{ margin: '15px 0', borderTop: '1px solid #eee' }}></div>

          <button
            onClick={handleShareToFacebook}
            style={{...tabButtonStyle(false), color: '#1877F2', fontWeight: 'bold'}}
          >
            <span style={iconStyle}><FaFacebook size={18} /></span>
            Verseny megosztása
          </button>
        </nav>
      </div>

      {/* KATTINTÁS-ELNYELŐ RÉTEG (OVERLAY) */}
      {isSidebarOpen && (
        <div
          onClick={() => setIsSidebarOpen(false)}
          style={{
            position: 'fixed',
            top: '64px',
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.1)',
            backdropFilter: 'blur(2px)',
            zIndex: 1000,
            transition: 'opacity 0.3s ease'
          }}
        />
      )}

      {/* FŐ TARTALOM (CONTENT AREA) */}
      <div ref={contentRef} style={{ ...contentStyle, paddingTop: (activeTab === 'competitors' || activeTab === 'qr-scanner' || activeTab === 'course-map') ? '0' : ((activeTab === 'score-sheet' || activeTab === 'documents') ? '15px' : '20px') }}>
        {activeTab !== 'competitors' && activeTab !== 'qr-scanner' && activeTab !== 'course-map' && activeTab !== 'results' && activeTab !== 'teams' && activeTab !== 'score-sheet' && activeTab !== 'documents' && (
          <header style={headerStyle}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <h2>{menuItems.find(m => m.id === activeTab)?.label}</h2>
            </div>
            <div style={headerStatsStyle}>
              <span>Nevezők: <strong>{participants.length}</strong></span>
              <span>Regisztrált: <strong>{arrivedCount}</strong></span>
              {activeTab === 'teams' && (
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <button
                    style={{
                      backgroundColor: '#b30000',
                      color: 'white', border: 'none', borderRadius: '8px', padding: '8px 15px', cursor: 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.85rem'
                    }}
                    onClick={handleSaveTeamAssignments}
                  >
                    <FiCheck /> Beosztás Mentése
                  </button>
                  <button
                    style={{
                      backgroundColor: '#b30000',
                      color: 'white', border: 'none', borderRadius: '8px', padding: '8px 15px', cursor: 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.85rem'
                    }}
                    onClick={() => setShowTeamsPrintModal(true)}
                  >
                    <FiPrinter /> Csapatlista nyomtatása
                  </button>
                </div>
              )}
            </div>
          </header>
        )}

        {activeTab === 'overview' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
            {/* VERSENY ALAPADATOK */}
            <div style={{ ...mainCardStyle, minHeight: 'auto' }}>
              <h4 style={{ color: '#b30000', marginBottom: '15px', borderBottom: '1px solid #eee', paddingBottom: '8px', display: 'flex', justifyContent: 'space-between' }}>
                Verseny részletei
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <span style={{ fontSize: '1rem' }}>{isRegistrationClosed ? '🔒' : '🔓'}</span>
                  <span style={statusBadgeStyle}>{competition?.status || 'Aktív'}</span>
                </div>
              </h4>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div>
                  <p style={{ margin: '8px 0' }}><strong>Dátum:</strong> {competition?.competitionDate}</p>
                  <p style={{ margin: '8px 0' }}><strong>Helyszín:</strong> {competition?.location}</p>
                  <p style={{ margin: '4px 0 8px 0', fontSize: '0.85rem', color: '#666', fontStyle: 'italic' }}>
                    <strong>GPS:</strong> {competition?.gpsLatitude && competition?.gpsLongitude ? `${competition.gpsLatitude}, ${competition.gpsLongitude}` : 'Nincs megadva'}
                  </p>
                </div>
                <div style={{ borderLeft: '1px solid #eee', paddingLeft: '20px' }}>
                  <p style={{ margin: '8px 0' }}><strong>Típus:</strong> {competition?.competitionType?.toUpperCase()}</p>
                  <p style={{ margin: '8px 0' }}><strong>Célok száma:</strong> {competition?.numberOfTargets}</p>
                  <p style={{ margin: '8px 0' }}><strong>Lövés/cél:</strong> {competition?.shotsPerTarget}</p>
                </div>
              </div>
            </div>

            {/* STATISZTIKAI WIDGETEK */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px' }}>
              <div style={statWidgetStyle}>
                <div style={statLabelStyle}>Részvétel</div>
                <div style={statValueStyle}>{arrivedCount} / {participants.length}</div>
                <div style={statSubLabelStyle}>{arrivedCount} fő megérkezett ({Math.round((arrivedCount / (participants.length || 1)) * 100)}%)</div>
              </div>

              <div style={statWidgetStyle}>
                <div style={statLabelStyle}>Ebéd összesítő</div>
                <div style={{ ...statValueStyle, color: '#f58231' }}>{dashboardStats.totalLunches} adag</div>
                <div style={{ ...statSubLabelStyle, display: 'flex', flexDirection: 'column', gap: '2px' }}>
                  <span>{dashboardStats.arrivedLunches} adag megérkezett</span>
                  {competition?.lunches && (
                    <div style={{ marginTop: '5px', borderTop: '1px solid #eee', paddingTop: '5px', fontSize: '0.7rem' }}>
                      {['A', 'B', 'C'].map(m => (
                        competition.lunches[m]?.name ? (
                          <div key={m} style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span>{m}. menü ({competition.lunches[m].name.substring(0, 15)}...):</span>
                            <strong>{dashboardStats.menuCounts[m]} db</strong>
                          </div>
                        ) : null
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div
                style={{ ...statWidgetStyle, cursor: 'pointer', userSelect: 'none' }}
                onMouseDown={() => setShowFinancials(true)}
                onMouseUp={() => setShowFinancials(false)}
                onMouseLeave={() => setShowFinancials(false)}
                title="Tartsd nyomva a megtekintéshez"
              >
                <div style={statLabelStyle}>Pénzügyi becslés (Beérkezett vs Várható)</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '15px', marginTop: '5px' }}>
                  <div style={{ flex: 1, textAlign: 'left' }}>
                    <div style={{ fontSize: '0.75rem', color: '#666', fontWeight: 'bold' }}>Beérkezett</div>
                    <div style={{
                      ...statValueStyle,
                      color: '#28a745',
                      fontSize: '1.2rem',
                      filter: showFinancials ? 'none' : 'blur(8px)',
                      transition: 'filter 0.2s ease'
                    }}>
                      {dashboardStats.totalEntryFees + dashboardStats.totalLunchFees} Ft
                    </div>
                    <div style={{
                      ...statSubLabelStyle,
                      filter: showFinancials ? 'none' : 'blur(4px)',
                      transition: 'filter 0.2s ease'
                    }}>
                      {dashboardStats.totalEntryFees} Ft nevezés + {dashboardStats.totalLunchFees} Ft ebéd
                    </div>
                  </div>
                  <div style={{ flex: 1, textAlign: 'right', borderLeft: '1px solid #eee', paddingLeft: '15px' }}>
                    <div style={{ fontSize: '0.75rem', color: '#666', fontWeight: 'bold' }}>Várható Összeg</div>
                    <div style={{
                      ...statValueStyle,
                      color: '#f58231',
                      fontSize: '1.2rem',
                      filter: showFinancials ? 'none' : 'blur(8px)',
                      transition: 'filter 0.2s ease'
                    }}>
                      {dashboardStats.expectedTotal} Ft
                    </div>
                    <div style={{
                      ...statSubLabelStyle,
                      filter: showFinancials ? 'none' : 'blur(4px)',
                      transition: 'filter 0.2s ease'
                    }}>
                      {dashboardStats.expectedEntryFees} Ft nevezés + {dashboardStats.expectedLunchFees} Ft ebéd
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* KATEGÓRIA BONTÁS */}
            <div style={mainCardStyle}>
              <h4 style={{ color: '#333', marginBottom: '15px', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>Nevezők kategóriánként</h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px' }}>
                {Object.values(dashboardStats.categories).sort((a,b) => b.count - a.count).map(cat => (
                  <div key={cat.label} style={{ padding: '12px', borderRadius: '8px', border: '1px solid #eee', backgroundColor: '#fafafa' }}>
                    <div style={{ fontWeight: 'bold', fontSize: '0.85rem', color: '#666', marginBottom: '5px' }}>{cat.label}</div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{cat.count} fő</span>
                      <span style={{ fontSize: '0.75rem', color: '#28a745' }}>{cat.arrived} megérkezett</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeTab === 'competitors' && (
          <div style={{ ...mainCardStyle, padding: '0', position: 'relative' }}>

            {/* AZ EGYSÉGES FIX TETŐ */}
            <div style={{
              position: 'sticky', top: '0', zIndex: 100,
              backgroundColor: 'white', boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
              padding: '0'
            }}>
              {/* Cím és Statisztika */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 20px', borderBottom: '1px solid #f0f0f0' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                  <h2 style={{ margin: 0 }}>Nevezők</h2>
                  {!isArchived && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                      <button onClick={handleToggleRegistrationLock} style={{ backgroundColor: isRegistrationClosed ? '#6c757d' : '#b30000', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '8px', fontSize: '0.8rem', fontWeight: 'bold', cursor: 'pointer' }}>
                        {isRegistrationClosed ? 'Regisztráció újranyitása' : 'Regisztráció lezárása'}
                      </button>
                      <span style={{
                        fontSize: '0.75rem',
                        color: '#333',
                        maxWidth: '450px',
                        lineHeight: '1.4',
                        backgroundColor: '#fff9c4', // Halvány sárga kiemelő
                        padding: '6px 12px',
                        borderRadius: '8px',
                        border: '1px solid #fbc02d',
                        display: 'inline-block'
                      }}>
                        <strong style={{ color: '#b30000' }}>* A nevezés végén zárd le a regisztrációt!</strong>
                        <span style={{ fontStyle: 'italic', marginLeft: '5px' }}>
                          Ezzel megjelölöd azokat, akik mégsem jöttek el, így ők nem fognak hiányozni az eredmények rögzítésekor.
                        </span>
                      </span>
                    </div>
                  )}
                </div>
                <div style={{ ...headerStatsStyle, margin: 0 }}>
                  <span>Nevezők: <strong>{participants.length}</strong></span>
                  <span>Megérkezett: <strong style={{ color: '#28a745' }}>{arrivedCount}</strong></span>
                </div>
              </div>

              {/* Kereső és Gombok */}
              <div style={{ ...actionBarStyle, padding: '12px 20px', margin: 0, borderBottom: '1px solid #f0f0f0' }}>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flex: 1 }}>
                  <div style={{ ...searchContainerStyle, maxWidth: '400px', flex: 1 }}>
                    <FiSearch style={searchIconStyle} />
                    <input type="text" placeholder="Keresés név alapján..." value={participantSearchTerm} onChange={(e) => setParticipantSearchTerm(e.target.value)} style={searchInputStyle} />
                  </div>
                  <button style={qrButtonStyle} onClick={() => !isRegistrationClosed && setShowAddModal(true)} disabled={isRegistrationClosed}>
                    <FiPlus /> Új nevező
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setShowOnSiteOnly(prev => !prev);
                      setTeamFilter(null);
                    }}
                    style={{
                      padding: '8px 14px',
                      backgroundColor: showOnSiteOnly ? '#fff5f5' : '#fff',
                      color: showOnSiteOnly ? '#b30000' : '#444',
                      border: showOnSiteOnly ? '2px solid #b30000' : '1px solid #ccc',
                      borderRadius: '8px',
                      fontWeight: 'bold',
                      fontSize: '0.85rem',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      boxShadow: showOnSiteOnly ? '0 2px 8px rgba(179,0,0,0.2)' : '0 2px 5px rgba(0,0,0,0.05)',
                      transition: 'all 0.2s ease'
                    }}
                    title="Szűrés a mai napon helyszínen manuálisan felvett nevezőkre"
                  >
                    <span>👤 Helyszíni nevezők: {onSiteCount} fő</span>
                  </button>
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button style={qrButtonStyle} onClick={() => setShowQrModal(true)}><MdQrCode size={18} /> QR kódok generálása</button>
                  <button style={exportButtonStyle} onClick={handleExportToExcel}>
                    <FiDownload /> Export
                  </button>
                </div>
              </div>

              {/* Csapatrács */}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', padding: '12px 20px', backgroundColor: '#f9fafb', borderBottom: '1px solid #eee', position: 'relative' }}>
                {teamsData.map((t) => {
                  const arrived = t.members.filter(m => localRegisteredIds.has(m.id) || m.totalScore !== undefined).length;
                  const total = t.members.length;
                  let bg = '#fff';
                  if (total > 0) bg = arrived === total ? '#28a745' : (arrived > 0 ? '#ffc107' : '#fff');
                  const isSelected = teamFilter === t.number;
                  return (
                    <div
                      key={t.number}
                      onMouseEnter={(e) => {
                        const rect = e.currentTarget.getBoundingClientRect();
                        setTooltipPos({ x: rect.left, y: rect.top + window.scrollY });
                        setHoveredTeam(t);
                      }}
                      onMouseLeave={() => setHoveredTeam(null)}
                      onClick={() => setTeamFilter(isSelected ? null : t.number)}
                      style={{
                        width: '28px', height: '28px', backgroundColor: bg,
                        border: isSelected ? '2.5px solid #b30000' : '1px solid #ddd',
                        borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: '0.8rem', fontWeight: '900', cursor: 'pointer',
                        transform: isSelected ? 'scale(1.25)' : 'scale(1)',
                        transition: 'all 0.2s ease',
                        boxShadow: isSelected ? '0 0 12px rgba(179, 0, 0, 0.3)' : 'none',
                        zIndex: isSelected ? 2 : 1
                      }}
                    >
                      {t.number}
                    </div>
                  );
                })}
              </div>

              <table style={{ ...tableStyle, tableLayout: 'fixed', width: 'calc(100% - 40px)', minWidth: '1325px', borderCollapse: 'collapse', margin: '0 20px' }}>
                <thead>
                  <tr style={{ backgroundColor: 'white' }}>
                    <th style={{ ...thStyle, width: '40px', textAlign: 'center' }}><input type="checkbox" onChange={toggleSelectAll} /></th>
                    <th style={{ ...thStyle, width: '80px' }}>ID.</th>
                    <th style={{ ...thStyle, width: '130px', cursor: 'pointer' }} onClick={() => requestSort('fullName')}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        Név {sortConfig.key === 'fullName' ? (sortConfig.direction === 'asc' ? <FiArrowUp size={14} color="#b30000" /> : <FiArrowDown size={14} color="#b30000" />) : <FiArrowUp size={14} color="#ccc" />}
                      </div>
                    </th>
                    <th style={{ ...thStyle, width: '95px', textAlign: 'center', cursor: 'pointer' }} onClick={() => requestSort('arrived')}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', fontSize: '0.75rem' }}>
                        Megérkezett {sortConfig.key === 'arrived' ? (sortConfig.direction === 'asc' ? <FiArrowUp size={14} color="#b30000" /> : <FiArrowDown size={14} color="#b30000" />) : <FiArrowUp size={14} color="#ccc" />}
                      </div>
                    </th>
                    <th style={{ ...thStyle, width: '65px', textAlign: 'center', cursor: 'pointer' }} onClick={() => requestSort('team')}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                        Csapat {sortConfig.key === 'team' ? (sortConfig.direction === 'asc' ? <FiArrowUp size={14} color="#b30000" /> : <FiArrowDown size={14} color="#b30000" />) : <FiArrowUp size={14} color="#ccc" />}
                      </div>
                    </th>
                    <th style={{ ...thStyle, width: '65px', textAlign: 'center' }}>Engedély</th>
                    <th style={{ ...thStyle, width: '140px', cursor: 'pointer' }} onClick={() => requestSort('bowCategory')}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        Kategória {sortConfig.key === 'bowCategory' ? (sortConfig.direction === 'asc' ? <FiArrowUp size={14} color="#b30000" /> : <FiArrowDown size={14} color="#b30000" />) : <FiArrowUp size={14} color="#ccc" />}
                      </div>
                    </th>
                    <th style={{ ...thStyle, width: '85px', cursor: 'pointer' }} onClick={() => requestSort('ageCategory')}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        Koroszt. {sortConfig.key === 'ageCategory' ? (sortConfig.direction === 'asc' ? <FiArrowUp size={14} color="#b30000" /> : <FiArrowDown size={14} color="#b30000" />) : <FiArrowUp size={14} color="#ccc" />}
                      </div>
                    </th>
                    <th style={{ ...thStyle, width: '35px' }}>Nem</th>
                    <th style={{ ...thStyle, width: '80px', textAlign: 'right' }}>Nev. díj</th>
                    <th style={{ ...thStyle, width: '50px', textAlign: 'center' }}>Ebéd</th>
                    <th style={{ ...thStyle, width: '70px', textAlign: 'right' }}>Ebéd ár</th>
                    <th style={{ ...thStyle, width: '200px', textAlign: 'left' }}>Megjegyzés</th>
                    <th style={{ ...thStyle, width: '80px', textAlign: 'center' }}>Törlés</th>
                  </tr>
                </thead>
              </table>
            </div>

            {/* GÖRDÜLŐ TARTALOM */}
            <div style={{ padding: '0 20px' }}>
              <table style={{ ...tableStyle, tableLayout: 'fixed', width: '100%', minWidth: '1325px', borderCollapse: 'collapse' }}>
                <tbody>
                  {filteredParticipants.length > 0 ? (
                    filteredParticipants.map((p) => {
                      const displayId = generateParticipantId(p);
                      // --- DINAMIKUS EBÉDÁR SZÁMÍTÁS TÁBLÁZATHOZ ---
                      let lunchFee = 0;
                      if (Number(p.lunchCount) > 0) {
                        if (p.lunchSelections) {
                          Object.entries(p.lunchSelections).forEach(([menuKey, amount]) => {
                            const price = Number(competition?.lunches?.[menuKey]?.price) ||
                                          (menuKey === 'A' ? (Number(competition?.lunchPrice) || 0) : 0);
                            lunchFee += amount * price;
                          });
                        } else {
                          const menuKey = p.selectedMenu || 'A';
                          const price = Number(competition?.lunches?.[menuKey]?.price) || Number(competition?.lunchPrice) || 0;
                          lunchFee = Number(p.lunchCount) * price;
                        }
                      }
                      const entryFee = competition?.ageFees?.[p.ageCategory] || p.entryFee || 0;

                      return (
                        <tr key={p.id} style={trStyle}>
                          <td style={{ ...tdStyle, width: '40px', textAlign: 'center' }}><input type="checkbox" checked={selectedIds.has(p.id)} onChange={() => toggleSelectOne(p.id)} /></td>
                          <td style={{ ...tdStyle, width: '80px', padding: '12px 5px' }}>
                            <div
                              style={{
                                fontFamily: 'monospace',
                                fontWeight: 'bold',
                                color: '#b30000',
                                fontSize: '0.75rem',
                                whiteSpace: 'nowrap'
                              }}
                              title="Egyedi azonosító"
                            >
                              {displayId}
                            </div>
                          </td>
                          <td style={{ ...tdStyle, width: '130px' }}>
                            <div style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px' }}>
                              {p.registeredVia === 'android' && <AiFillAndroid size={16} color="#3DDC84" />}
                              {p.registeredVia === 'ios' && <AiFillApple size={16} color="#999999" />}
                              {p.registeredVia === 'web' && <FiGlobe size={16} color="#007bff" />}
                              {p.fullName}
                            </div>
                            <div style={{ fontSize: '0.7rem', color: '#888' }}>{formatClubName(p.club) || '-'}</div>
                          </td>
                          <td style={{ ...tdStyle, width: '95px', textAlign: 'center' }}>
                            <button
                              onClick={() => handleToggleRegistration(p.id)}
                              style={{
                                width: '32px', height: '32px', borderRadius: '50%', border: 'none',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                margin: '0 auto',
                                cursor: isRegistrationClosed ? 'not-allowed' : 'pointer',
                                backgroundColor: (localRegisteredIds.has(p.id) || p.totalScore !== undefined) ? '#28a745' : (isRegistrationClosed ? '#dc3545' : '#eee'),
                                color: '#fff'
                              }}
                            >
                              {(localRegisteredIds.has(p.id) || p.totalScore !== undefined) ? <FiCheck size={16} /> : (isRegistrationClosed ? <FiX size={16} /> : <FiAlertCircle size={16} />)}
                            </button>
                          </td>
                          <td style={{ ...tdStyle, width: '65px', textAlign: 'center', fontWeight: 'bold' }}>{p.team || '-'}</td>
                          <td style={{ ...tdStyle, width: '65px', textAlign: 'center' }}>{p.licenseNumber || p.license || '-'}</td>
                          <td style={{ ...tdStyle, width: '140px' }}>{translationMap[p.bowCategory] || p.bowCategory}</td>
                          <td style={{ ...tdStyle, width: '85px' }}>{translationMap[p.ageCategory] || p.ageCategory}</td>
                          <td style={{ ...tdStyle, width: '35px' }}>{p.gender === 'Férfi' ? 'Férfi' : 'Nő'}</td>
                          <td style={{ ...tdStyle, width: '80px', textAlign: 'right' }}>{entryFee} Ft</td>
                          <td style={{ ...tdStyle, width: '50px', textAlign: 'center' }}>
                            {p.lunchCount > 0 ? (
                              <div style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>
                                {p.lunchSelections ? (
                                  Object.entries(p.lunchSelections)
                                    .filter(([, amt]) => amt > 0)
                                    .map(([k, a]) => `${k}:${a}`)
                                    .join(" ")
                                ) : (p.selectedMenu || 'A')}
                                <br/>
                                <span style={{ fontSize: '0.7rem', fontWeight: 'normal', color: '#888' }}>{p.lunchCount}db</span>
                              </div>
                            ) : '-'}
                          </td>
                          <td style={{ ...tdStyle, width: '70px', textAlign: 'right' }}>
                            {competition?.lunchPaidElsewhere ? (
                              <span style={{ fontSize: '0.7rem', color: '#d48806', fontWeight: 'bold' }}>Büfében</span>
                            ) : (
                              lunchFee > 0 ? `${lunchFee} Ft` : '-'
                            )}
                          </td>
                          <td
                            style={{
                              ...tdStyle,
                              width: '200px',
                              textAlign: 'left',
                              cursor: p.comment ? 'pointer' : 'default',
                              position: 'relative', // ÚJ: Szükséges a sarok jelzőhöz
                              paddingRight: '20px' // Hely a piros jelzésnek
                            }}
                            onClick={(e) => {
                              if (p.comment) {
                                const rect = e.currentTarget.getBoundingClientRect();
                                setActiveComment({ text: p.comment, x: rect.left, y: rect.top + window.scrollY });
                              }
                            }}
                          >
                            <div
                              style={{
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                lineHeight: '1.2',
                                color: '#666',
                                fontSize: '0.75rem',
                                fontStyle: 'italic'
                              }}
                            >
                              {p.comment || '-'}
                            </div>

                            {/* PIROS SAROK JELZŐ (+) ha hosszú a szöveg */}
                            {p.comment && p.comment.length > 50 && (
                              <div style={{
                                position: 'absolute',
                                right: '5px',
                                bottom: '5px',
                                color: '#b30000',
                                fontWeight: '900',
                                fontSize: '1.2rem',
                                lineHeight: '1',
                                textShadow: '0 0 2px white'
                              }}>
                                +
                              </div>
                            )}
                          </td>
                          <td style={{ ...tdStyle, width: '80px', textAlign: 'center' }}>
                            <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                              <button onClick={() => handleEditClick(p)} style={{ ...deleteButtonStyle, color: '#666' }}><FiEdit3 size={16} /></button>
                              <button onClick={() => handleDeleteParticipant(p)} style={deleteButtonStyle}><FiTrash2 size={16} /></button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr><td colSpan="14" style={{ textAlign: 'center', padding: '40px', color: '#999' }}>Nincs nevező a listában.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {activeTab === 'teams' && (
          <DndContext
            sensors={sensors}
            collisionDetection={pointerWithin}
            onDragStart={isArchived ? null : handleDragStart}
            onDragOver={isArchived ? null : handleDragOver}
            onDragEnd={isArchived ? null : handleDragEnd}
            onDragCancel={handleDragCancel}
          >
            {/* AKCIÓSÁV A CSAPATOK TETEJEÉN (NYOMTATÁS ÉS PUBLIKÁLÁS) */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: 'white',
              padding: '12px 20px',
              borderRadius: '12px',
              marginBottom: '20px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              border: '1px solid #eee'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <h3 style={{ margin: 0, color: '#333', fontSize: '1.2rem', fontWeight: 'bold' }}>Csapatbeosztás</h3>
                <span style={{ fontSize: '0.85rem', color: '#666' }}>({participants.filter(p => p.team).length} / {participants.length} fő csapatban)</span>
              </div>

              <div style={{ display: 'flex', gap: '10px' }}>
                <button
                  type="button"
                  onClick={handleSaveTeamAssignments}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#b30000',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: 'bold',
                    fontSize: '0.85rem',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: '0 2px 6px rgba(179,0,0,0.25)'
                  }}
                >
                  <FiCheck /> Beosztás mentése
                </button>

                <button
                  type="button"
                  onClick={() => setShowTeamsPrintModal(true)}
                  style={exportButtonStyle}
                >
                  <FiPrinter /> Csapatlista nyomtatása
                </button>

                <button
                  type="button"
                  onClick={handleTogglePublishTeams}
                  disabled={isPublishingTeams}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: competition?.teamsPublished ? '#28a745' : '#6c757d',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: 'bold',
                    fontSize: '0.85rem',
                    cursor: isPublishingTeams ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: competition?.teamsPublished ? '0 2px 6px rgba(40,167,69,0.3)' : 'none',
                    transition: 'all 0.2s ease'
                  }}
                >
                  {competition?.teamsPublished ? (
                    <>
                      <FiCheck size={16} />
                      <span>✓ Csapatok publikálva</span>
                    </>
                  ) : (
                    <>
                      <FiGlobe size={16} />
                      <span>Csapatok publikálása</span>
                    </>
                  )}
                </button>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>

              {/* BAL OLDAL: CSAPATRÁCS */}
              <div style={{ flex: 1, display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px' }}>
                {teamsData.map((team) => (
                  <div key={team.number} id={`team-${team.number}`}>
                    <TeamBox
                      teamNumber={team.number}
                      totalTeams={teamsData.length}
                      participants={team.members}
                      linkBaseId={linkBaseId}
                      onLinkClick={handleToggleLink}
                      isArchived={isArchived}
                      onScoreTeam={handleOpenTeamScoreModal}
                      onUnlinkClick={(linkId) => setUnlinkLinkIdToConfirm(linkId)}
                      onSwapTeams={handleSwapTeams}
                    />
                  </div>
                ))}
              </div>

              {/* JOBB OLDAL: VÁRÓLISTA (POOL) */}
              <div ref={poolContainerRef} style={{ width: '300px', position: 'sticky', top: '20px' }}>
                <div style={{ ...mainCardStyle, height: 'calc(100vh - 120px)', minHeight: 'auto', padding: '15px', display: 'flex', flexDirection: 'column' }}>
                  <h4 style={{ margin: '0 0 15px 0', color: '#b30000', borderBottom: '2px solid #b30000', paddingBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
                    Várólista
                    <span style={{ fontSize: '0.8rem', color: '#666' }}>{poolData.length} fő</span>
                  </h4>

                  <div style={{ position: 'relative', marginBottom: '15px' }}>
                    <FiSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#888' }} />
                    <input
                      type="text"
                      placeholder="Név vagy egyesület..."
                      value={poolSearchTerm}
                      onChange={(e) => setPoolSearchTerm(e.target.value)}
                      style={{ ...formInputStyle, paddingLeft: '35px', paddingRight: '35px', fontSize: '0.85rem' }}
                    />
                  </div>

                  {/* ÚJ: DINAMIKUS SZŰRŐK A VÁRÓLISTÁHOZ */}
                  <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', marginBottom: '15px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #eee' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flex: 1, minWidth: 0 }}>
                      <span style={{ fontSize: '0.65rem', fontWeight: 'bold' }}>Kat.:</span>
                      <select
                        value={poolCategoryFilter}
                        onChange={(e) => setPoolCategoryFilter(e.target.value)}
                        style={{ ...selectStyle, padding: '4px', fontSize: '0.75rem', height: 'auto', flex: 1, minWidth: 0 }}
                      >
                        <option value="">Mind</option>
                        {competition?.categories?.map(catId => (
                          <option key={catId} value={catId}>{translationMap[catId] || catId}</option>
                        ))}
                      </select>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flex: 1, minWidth: 0 }}>
                      <span style={{ fontSize: '0.65rem', fontWeight: 'bold' }}>Kor:</span>
                      <select
                        value={poolAgeFilter}
                        onChange={(e) => setPoolAgeFilter(e.target.value)}
                        style={{ ...selectStyle, padding: '4px', fontSize: '0.75rem', height: 'auto', flex: 1, minWidth: 0 }}
                      >
                        <option value="">Mind</option>
                        {competition?.ageCategories?.map(ageId => (
                          <option key={ageId} value={ageId}>{translationMap[ageId] || ageId}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Droppable terület a visszahúzáshoz */}
                  <PoolBox
                    participants={poolData}
                    onLinkClick={handleToggleLink}
                    isArchived={isArchived}
                    linkBaseId={linkBaseId}
                    onUnlinkClick={(linkId) => setUnlinkLinkIdToConfirm(linkId)}
                    collapsedWaitlistLinks={collapsedWaitlistLinks}
                    onToggleWaitlistLinkCollapse={toggleWaitlistLinkCollapse}
                  />
                </div>
              </div>
            </div>

            <DragOverlay dropAnimation={{
              sideEffects: defaultDropAnimationSideEffects({
                styles: { active: { opacity: '0.5', }, },
              }),
            }}>
              {activeId ? (() => {
                const activeParticipant = participants.find(p => p.id === activeId);
                const movingMembers = activeParticipant?.linkId
                  ? participants.filter(p => p.linkId === activeParticipant.linkId)
                  : [activeParticipant];

                const isLinked = !!activeParticipant?.linkId;

                return (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    {isLinked ? (
                      <LinkedGroupWrapper linkId={activeParticipant.linkId}>
                        {movingMembers.map(m => (
                          <SortableParticipant
                            key={m.id}
                            id={m.id}
                            participant={m}
                            isOverlay
                            isInGroup={true}
                          />
                        ))}
                      </LinkedGroupWrapper>
                    ) : (
                      movingMembers.map(m => (
                        <SortableParticipant
                          key={m.id}
                          id={m.id}
                          participant={m}
                          isOverlay
                        />
                      ))
                    )}
                  </div>
                );
              })() : null}
            </DragOverlay>
          </DndContext>
        )}

        {activeTab === 'results' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            {/* HIBAÜZENET A LEZÁRÁSHOZ */}
            {showCloseCompetitionError && (
              <div style={{
                padding: '15px 20px',
                backgroundColor: '#fff5f5',
                border: '1px solid #feb2b2',
                borderRadius: '12px',
                color: '#c53030',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                animation: 'shake 0.5s ease'
              }}>
                <FiAlertCircle size={24} />
                <span>Hiba: Még nem minden versenyzőnek van rögzített pontszáma!</span>
                <style>{`
                  @keyframes shake {
                    0%, 100% { transform: translateX(0); }
                    25% { transform: translateX(-5px); }
                    75% { transform: translateX(5px); }
                  }
                `}</style>
              </div>
            )}

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                <h3 style={{ ...resultGroupTitleStyle, borderBottom: 'none', marginBottom: 0, paddingBottom: 0 }}>Eredmények</h3>
                {!isArchived && (
                  <button
                    onClick={() => {
                      if (competition?.status === 'Ready to Upload' || competition?.status === 'Lezárt') {
                        alert("A verseny már le van zárva!");
                        return;
                      }
                      handleCloseCompetition();
                    }}
                    style={{
                      padding: '10px 20px',
                      borderRadius: '8px',
                      border: 'none',
                      fontWeight: 'bold',
                      cursor: (competition?.status === 'Ready to Upload' || competition?.status === 'Lezárt') ? 'default' : 'pointer',
                      transition: '0.3s',
                      backgroundColor: (() => {
                        if (competition?.status === 'Ready to Upload' || competition?.status === 'Lezárt') {
                          return '#28a745';
                        }
                        const registered = participants.filter(p => localRegisteredIds.has(p.id));
                        return (registered.length > 0 && registered.every(p => p.totalScore !== undefined)) ? '#b30000' : '#ccc';
                      })(),
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                  >
                    <FiCheck size={18} /> {(competition?.status === 'Ready to Upload' || competition?.status === 'Lezárt') ? '✓ Eredmények lezárva' : 'Eredmények lezárása'}
                  </button>
                )}
                <button
                  onClick={() => setShowResultsExportModal(true)}
                  style={{
                    ...qrButtonStyle,
                    padding: '10px 20px',
                    backgroundColor: '#b30000',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  <FiDownload /> Export
                </button>
              </div>

              {/* BIZTONSÁGI MENTÉS GOMB - AZ EXPORT GOMBBAL EGY VONALBAN, JOBBRA TELJESEN */}
              <button
                type="button"
                onClick={handleForceBackupAllScores}
                disabled={isForceBackuping}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#17a2b8',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  fontWeight: 'bold',
                  fontSize: '0.85rem',
                  cursor: isForceBackuping ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  boxShadow: '0 2px 6px rgba(23,162,184,0.3)',
                  opacity: isForceBackuping ? 0.7 : 1
                }}
                title="Kényszerített biztonsági mentés az összes beérkezett eredményre a helyi adatbázisba és a felhőbe"
              >
                <span>{isForceBackuping ? 'Mentés...' : '💾 Biztonsági Mentés'}</span>
              </button>
            </div>

            <div style={{
              ...actionBarStyle,
              position: 'sticky',
              top: '-25px', // Mivel a kártya paddingje 25px, így kerül a legtetejére
              zIndex: 10,
              backgroundColor: 'white',
              padding: '10px 0',
              margin: '0',
              borderBottom: '1px solid #eee'
            }}>
              <div style={searchContainerStyle}>
                <FiSearch style={searchIconStyle} />
                <input
                  type="text"
                  placeholder="Keresés a rangsorban (név vagy egyesület)..."
                  value={resultsSearchTerm}
                  onChange={(e) => setResultsSearchTerm(e.target.value)}
                  style={searchInputStyle}
                />
              </div>

              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <button
                  style={{
                    ...qrButtonStyle,
                    backgroundColor: competition?.status === 'Lezárt' ? '#ccc' : '#b30000',
                    borderColor: competition?.status === 'Lezárt' ? '#ccc' : '#b30000',
                    cursor: competition?.status === 'Lezárt' ? 'not-allowed' : 'pointer'
                  }}
                  onClick={() => {
                    if (competition?.status === 'Lezárt') {
                      alert("A verseny le van zárva, az eredmények már nem módosíthatók.");
                      return;
                    }
                    setManualScoreEntry({ participant: null, zones: {}, totalScore: 0 });
                    setManualSearchTerm('');
                    setShowManualScoreModal(true);
                  }}
                >
                  <FiPlus /> Eredmény manuális rögzítése
                </button>

                {/* ÉREM SZÁMLÁLÓ MEGJELENÍTÉSE */}
                <div style={{ display: 'flex', gap: '15px', alignItems: 'center', backgroundColor: '#f8f9fa', padding: '10px 20px', borderRadius: '12px', border: '1px solid #eee' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span style={{ fontSize: '1.2rem' }}>🥇</span>
                    <span style={{ fontWeight: 'bold', fontSize: '1.1rem', color: '#d4af37' }}>{medalStats.gold}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span style={{ fontSize: '1.2rem' }}>🥈</span>
                    <span style={{ fontWeight: 'bold', fontSize: '1.1rem', color: '#aaa9ad' }}>{medalStats.silver}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span style={{ fontSize: '1.2rem' }}>🥉</span>
                    <span style={{ fontWeight: 'bold', fontSize: '1.1rem', color: '#cd7f32' }}>{medalStats.bronze}</span>
                  </div>
                  <div style={{ marginLeft: '10px', fontSize: '0.8rem', color: '#888', fontWeight: 'bold', textTransform: 'uppercase' }}>Szükséges érmek</div>
                </div>
              </div>
            </div>

            {/* ÚJ: CSAPATRÁCS AZ EREDMÉNYEKHEZ (PONTSZÁM ALAPÚ SZÍNEZÉSSEL) */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', padding: '4px 20px', backgroundColor: '#f9fafb', borderRadius: '12px', border: '1px solid #eee', margin: '0' }}>
              {teamsData.map((t) => {
                const total = t.members.length;
                const scored = t.members.filter(m => m.totalScore !== undefined).length;

                let bg = '#fff'; // Fehér ha üres
                if (total > 0) {
                  if (scored === total) bg = '#28a745'; // Zöld ha mindenki kész
                  else if (scored > 0) bg = '#ffc107'; // Sárga ha van már pont de nem mindenkié
                }

                const isSelected = teamFilter === t.number;
                return (
                  <div
                    key={`res-team-${t.number}`}
                    onClick={() => setTeamFilter(isSelected ? null : t.number)}
                    onMouseEnter={(e) => {
                      const rect = e.currentTarget.getBoundingClientRect();
                      setTooltipPos({ x: rect.left, y: rect.top + window.scrollY });
                      setHoveredTeam(t);
                    }}
                    onMouseLeave={() => setHoveredTeam(null)}
                    style={{
                      width: '28px', height: '28px', backgroundColor: bg,
                      border: isSelected ? '2.5px solid #b30000' : '1px solid #ddd',
                      borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: '0.8rem', fontWeight: '900', cursor: 'pointer',
                      transform: isSelected ? 'scale(1.25)' : 'scale(1)',
                      transition: 'all 0.2s ease',
                      boxShadow: isSelected ? '0 0 12px rgba(179, 0, 0, 0.3)' : 'none',
                      zIndex: isSelected ? 2 : 1
                    }}
                  >
                    {t.number}
                  </div>
                );
              })}
            </div>

            {/* EGYÉNI / CSAPAT KAPCSOLÓ (TOGGLE SWITCH) */}
            <div style={{ display: 'flex', justifyContent: 'center', margin: '6px 0 10px 0' }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#eee',
                borderRadius: '30px',
                padding: '4px',
                boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)',
                cursor: 'pointer'
              }}>
                <button
                  type="button"
                  onClick={() => setResultsViewMode('individual')}
                  style={{
                    padding: '8px 20px',
                    borderRadius: '25px',
                    border: 'none',
                    backgroundColor: resultsViewMode === 'individual' ? '#b30000' : 'transparent',
                    color: resultsViewMode === 'individual' ? 'white' : '#555',
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: resultsViewMode === 'individual' ? '0 2px 6px rgba(179,0,0,0.3)' : 'none'
                  }}
                >
                  Egyéni
                </button>
                <button
                  type="button"
                  onClick={() => setResultsViewMode('team')}
                  style={{
                    padding: '8px 16px',
                    borderRadius: '25px',
                    border: 'none',
                    backgroundColor: resultsViewMode === 'team' ? '#b30000' : 'transparent',
                    color: resultsViewMode === 'team' ? 'white' : '#555',
                    fontWeight: 'bold',
                    fontSize: '0.85rem',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: resultsViewMode === 'team' ? '0 2px 6px rgba(179,0,0,0.3)' : 'none'
                  }}
                >
                  Csapat
                </button>
                <button
                  type="button"
                  onClick={() => setResultsViewMode('topShooters')}
                  style={{
                    padding: '8px 16px',
                    borderRadius: '25px',
                    border: 'none',
                    backgroundColor: resultsViewMode === 'topShooters' ? '#b30000' : 'transparent',
                    color: resultsViewMode === 'topShooters' ? 'white' : '#555',
                    fontWeight: 'bold',
                    fontSize: '0.85rem',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: resultsViewMode === 'topShooters' ? '0 2px 6px rgba(179,0,0,0.3)' : 'none'
                  }}
                >
                  Legtöbbet lövők
                </button>
              </div>
            </div>

            {resultsViewMode === 'topShooters' ? (
              /* LEGTÖBBET LÖVŐK (TOP SHOOTERS) NÉZET */
              <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '10px' }}>
                <h3 style={{ ...resultGroupTitleStyle, fontSize: '1.1rem', marginBottom: '5px' }}>🏆 Legtöbbet lövők (Kategóriák Top 3)</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '20px' }}>
                  {/* BAL OLDAL: IRÁNYZÉK NÉLKÜLI */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <h4 style={{ margin: 0, padding: '10px', backgroundColor: '#e9ecef', borderRadius: '8px', color: '#333', textAlign: 'center', fontSize: '1rem', fontWeight: 'bold' }}>
                      🚫 Irányzék nélküli kategóriák
                    </h4>
                    {renderAbsoluteTopCard(topShootersData.sightlessBest, '#b30000', 'Legtöbb pont')}
                    {topShootersData.sightless.length > 0 ? (
                      topShootersData.sightless.map(cat => (
                        <div key={`sightless-${cat.bowCategory}`} style={{ ...mainCardStyle, margin: 0, padding: '15px', minHeight: 'auto', backgroundColor: '#fff' }}>
                          <h5 style={{ margin: '0 0 10px 0', fontSize: '0.95rem', color: '#b30000', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>
                            {cat.label}
                          </h5>
                          <table style={{ ...tableStyle, fontSize: '0.85rem', tableLayout: 'fixed', width: '100%' }}>
                            <tbody>
                              {cat.members.map((m, mIdx) => (
                                <tr key={m.id || mIdx}>
                                  <td style={{ ...tdStyle, padding: '5px', width: '35px', textAlign: 'center', fontWeight: 'bold', color: mIdx === 0 ? '#d4af37' : mIdx === 1 ? '#aaa9ad' : '#cd7f32' }}>
                                    {mIdx === 0 ? '🥇' : mIdx === 1 ? '🥈' : '🥉'}
                                  </td>
                                  <td style={{ ...tdStyle, padding: '5px', fontWeight: 'bold', width: '24%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.fullName}</td>
                                  <td style={{ ...tdStyle, padding: '5px', color: '#555', fontSize: '0.75rem', width: '18%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{translationMap[m.ageCategory] || m.ageCategory || '-'}</td>
                                  <td style={{ ...tdStyle, padding: '5px', color: '#666', fontSize: '0.75rem', width: '38%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{formatClubName(m.club) || '-'}</td>
                                  <td style={{ ...tdStyle, padding: '5px', textAlign: 'right', fontWeight: 'bold', color: '#b30000', width: '60px' }}>
                                    {m.totalScore} p
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ))
                    ) : (
                      <div style={{ textAlign: 'center', padding: '20px', color: '#888', fontStyle: 'italic' }}>Nincs adat az irányzék nélküli kategóriákban.</div>
                    )}
                  </div>

                  {/* JOBB OLDAL: IRÁNYZÉKOS */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <h4 style={{ margin: 0, padding: '10px', backgroundColor: '#e9ecef', borderRadius: '8px', color: '#333', textAlign: 'center', fontSize: '1rem', fontWeight: 'bold' }}>
                      🎯 Irányzékos kategóriák
                    </h4>
                    {renderAbsoluteTopCard(topShootersData.sightedBest, '#0056b3', 'Legtöbb pont')}
                    {topShootersData.sighted.length > 0 ? (
                      topShootersData.sighted.map(cat => (
                        <div key={`sighted-${cat.bowCategory}`} style={{ ...mainCardStyle, margin: 0, padding: '15px', minHeight: 'auto', backgroundColor: '#fff' }}>
                          <h5 style={{ margin: '0 0 10px 0', fontSize: '0.95rem', color: '#0056b3', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>
                            {cat.label}
                          </h5>
                          <table style={{ ...tableStyle, fontSize: '0.85rem', tableLayout: 'fixed', width: '100%' }}>
                            <tbody>
                              {cat.members.map((m, mIdx) => (
                                <tr key={m.id || mIdx}>
                                  <td style={{ ...tdStyle, padding: '5px', width: '35px', textAlign: 'center', fontWeight: 'bold', color: mIdx === 0 ? '#d4af37' : mIdx === 1 ? '#aaa9ad' : '#cd7f32' }}>
                                    {mIdx === 0 ? '🥇' : mIdx === 1 ? '🥈' : '🥉'}
                                  </td>
                                  <td style={{ ...tdStyle, padding: '5px', fontWeight: 'bold', width: '24%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.fullName}</td>
                                  <td style={{ ...tdStyle, padding: '5px', color: '#555', fontSize: '0.75rem', width: '18%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{translationMap[m.ageCategory] || m.ageCategory || '-'}</td>
                                  <td style={{ ...tdStyle, padding: '5px', color: '#666', fontSize: '0.75rem', width: '38%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{formatClubName(m.club) || '-'}</td>
                                  <td style={{ ...tdStyle, padding: '6px', textAlign: 'right', fontWeight: 'bold', color: '#0056b3', width: '60px' }}>
                                    {m.totalScore} p
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ))
                    ) : (
                      <div style={{ textAlign: 'center', padding: '20px', color: '#888', fontStyle: 'italic' }}>Nincs adat az irányzékos kategóriákban.</div>
                    )}
                  </div>
                </div>
              </div>
            ) : resultsViewMode === 'individual' ? (
              resultsData.length > 0 ? (
                <div style={resultsGridStyle}>
                {resultsData.map((group, idx) => (
                  <div key={idx} style={{ ...mainCardStyle, margin: 0, padding: '15px', minHeight: 'auto' }}>
                    <h3 style={{ ...resultGroupTitleStyle, fontSize: '1rem', marginBottom: '10px' }}>
                      {translationMap[group.bowCategory] || group.bowCategory} - {translationMap[group.ageCategory] || group.ageCategory} - {group.gender}
                    </h3>
                    <table style={{ ...tableStyle, fontSize: '0.85rem' }}>
                      <thead>
                        <tr>
                          <th style={{ ...thStyle, width: '30px', padding: '8px 5px' }}>#</th>
                          <th style={{ ...thStyle, padding: '8px 5px' }}>Név</th>
                          <th style={{ ...thStyle, width: '20px', padding: '8px 2px' }}></th> {/* ÚJ: Oszlop a figyelmeztetésnek */}
                          {/* DINAMIKUS ZÓNA FEJLÉCEK */}
                          {(competition?.scoringValues || ['11', '10', '8', '5', '0'])
                            .sort((a, b) => {
                              const valA = a === 'X' ? 11.5 : parseInt(a);
                              const valB = b === 'X' ? 11.5 : parseInt(b);
                              return valB - valA;
                            })
                            .map(zone => (
                              <th key={zone} style={{ ...thStyle, textAlign: 'center', width: '40px', padding: '8px 5px' }}>
                                {zone}
                              </th>
                            ))
                          }
                          <th style={{ ...thStyle, textAlign: 'right', padding: '8px 5px', width: '60px' }}>Pont</th>
                        </tr>
                      </thead>
                      <tbody>
                        {group.members.map((p, pIdx) => {
                          const hasScore = p.totalScore !== undefined;
                          // A helyezést csak az eredményeseknek számoljuk
                          const rank = hasScore ? (group.scoredMembers.indexOf(p) + 1) : null;
                          let podiumIcon = null;

                          // Találati zónák számolása (prioritás: felhő p.shots, utána helyi)
                          const shots = p.shots || allShotsByCompetitor[p.id] || [];
                          const hitZoneCounts = {};
                          const scoringValues = competition?.scoringValues || ['11', '10', '8', '5', '0'];
                          scoringValues.forEach(z => hitZoneCounts[z] = 0);
                          shots.forEach(s => {
                            if (s.value) {
                              hitZoneCounts[s.value] = (hitZoneCounts[s.value] || 0) + 1;
                            }
                          });

                          // HA SZÉTLÖVÉS KELL
                          if (p.needsShootOff) {
                            podiumIcon = (
                              <div title="Szétlövés szükséges" style={{ display: 'flex', justifyContent: 'center' }}>
                                <FiAlertCircle size={24} color="#dc3545" />
                              </div>
                            );
                          } else if (hasScore) {
                            if (rank === 1) podiumIcon = "🥇";
                            else if (rank === 2) podiumIcon = "🥈";
                            else if (rank === 3) podiumIcon = "🥉";
                          }

                          // Dobogós sáv háttérszín és bal oldali szegély
                          let rowBgColor = 'transparent';
                          let rowBorderLeft = 'none';

                          if (p.needsShootOff) {
                            rowBgColor = '#fff0f0';
                            rowBorderLeft = '4px solid #b30000';
                          } else if (hasScore && rank === 1) {
                            rowBgColor = '#ffee58'; // Arany (élénk tiszta sárga)
                            rowBorderLeft = '4px solid #f1c40f';
                          } else if (hasScore && rank === 2) {
                            rowBgColor = '#eceff1'; // Ezüst
                            rowBorderLeft = '4px solid #b0bec5';
                          } else if (hasScore && rank === 3) {
                            rowBgColor = '#ffe0b2'; // Bronz
                            rowBorderLeft = '4px solid #e67e22';
                          }

                          return (
                            <tr key={p.id} style={{
                              ...trStyle,
                              backgroundColor: rowBgColor,
                              opacity: hasScore ? 1 : 0.6 // Elhalványítás a szellemeknek
                            }}>
                              <td style={{
                                ...tdStyle,
                                fontWeight: 'bold',
                                padding: '8px 5px',
                                textAlign: 'center',
                                color: p.needsShootOff ? '#b30000' : (hasScore ? '#333' : '#ccc'),
                                // Bal oldali szegély a dobogósoknak és szétlövéseseknek
                                borderLeft: rowBorderLeft,
                              }}>
                                {podiumIcon || (p.needsShootOff ? '!' : (hasScore ? `${rank}.` : '-'))}
                              </td>
                              <td style={{ ...tdStyle, padding: '8px 5px', color: hasScore ? '#333' : '#666' }}>
                                <div style={{ fontWeight: 'bold' }}>{p.fullName}</div>
                                <div style={{ fontSize: '0.7rem', color: hasScore ? '#888' : '#999' }}>{formatClubName(p.club) || '-'}</div>
                                {p.shootOffRank && (
                                  <div style={{ fontSize: '0.7rem', color: '#b30000', fontWeight: 'bold', marginTop: '2px' }}>
                                    Szétlövés: {p.shootOffRank}. hely
                                  </div>
                                )}
                              </td>

                              {/* ÚJ: Külön cella a figyelmeztető ikonnak */}
                              <td style={{ ...tdStyle, width: '20px', padding: '8px 2px', textAlign: 'center' }}>
                                {p.isManuallyEdited && (
                                  <FiAlertCircle size={14} color="#b30000" title="A végpontszám kézzel lett módosítva vagy csoportosan beírva!" />
                                )}
                              </td>

                              {/* ZÓNA DARABSZÁMOK (Csak annyi <td> amennyi fejléc oszlop) */}
                              {scoringValues
                                .sort((a, b) => {
                                  const valA = a === 'X' ? 11.5 : (parseInt(a) || 0);
                                  const valB = b === 'X' ? 11.5 : (parseInt(b) || 0);
                                  return valB - valA;
                                })
                                .map((zone, zIdx) => (
                                  <td key={zone} style={{ ...tdStyle, textAlign: 'center', color: hasScore ? '#555' : '#eee' }}>
                                    {hasScore ? (hitZoneCounts[zone] || 0) : '-'}
                                  </td>
                                ))
                              }

                              <td style={{
                                ...tdStyle,
                                textAlign: 'right',
                                fontWeight: 'bold',
                                padding: '8px 5px',
                                color: hasScore ? '#b30000' : '#ddd',
                                // Piros vonal a jobb oldalon
                                borderRight: p.needsShootOff ? '4px solid #b30000' : 'none'
                              }}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px' }}>
                                  {hasScore && !isArchived && (
                                    <FiEdit2
                                      style={{ cursor: 'pointer', color: '#666', fontSize: '0.8rem' }}
                                      onClick={() => handleOpenEditScoreModal(p)}
                                      title="Pontszám kézi módosítása"
                                    />
                                  )}
                                  <span>{hasScore ? p.totalScore : '0'}</span>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                        {/* +1 ÜRES SOR A LISTA VÉGÉN (GOMB HELYE A SZÉTLÖVÉSHEZ HA KELL) */}
                        <tr style={{ height: '40px' }}>
                          <td style={{ ...tdStyle, borderBottom: 'none' }}></td>
                          <td colSpan="10" style={{ ...tdStyle, borderBottom: 'none', textAlign: 'left', paddingLeft: '15px' }}>
                            {group.members.some(p => p.needsShootOff) && !isArchived && (
                              <button
                                onClick={() => {
                                  // Kikeressük az összes embert, akinek szétlövés kell a csoportból
                                  const tiedGroup = group.members.filter(m => m.needsShootOff);
                                  setShootOffGroup(tiedGroup);

                                  // Betöltjük a már esetlegesen meglévő helyezéseket
                                  const initialRanks = {};
                                  tiedGroup.forEach(m => {
                                    if (m.shootOffRank) initialRanks[m.id] = m.shootOffRank.toString();
                                  });
                                  setShootOffRanks(initialRanks);

                                  setShowShootOffModal(true);
                                }}
                                style={{
                                  ...qrButtonStyle,
                                  backgroundColor: '#fff',
                                  color: '#b30000',
                                  border: '2px solid #b30000',
                                  padding: '6px 12px',
                                  fontSize: '0.8rem'
                                }}
                              >
                                Szétlövés rögzítése
                              </button>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>
            ) : (
              <div style={mainCardStyle}>
                <div style={placeholderStyle}>
                  <p>Nem található eredmény a megadott keresési feltételekkel.</p>
                </div>
              </div>
            )
            ) : (
              /* CSAPAT RANGLISTA NÉZET */
              <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '10px' }}>
                <h3 style={{ ...resultGroupTitleStyle, fontSize: '1.1rem', marginBottom: '5px' }}>🏆 Csapat Ranglista</h3>
                {teamLeaderboardData.length > 0 ? (
                  teamLeaderboardData.map((team, tIdx) => (
                    <div key={`team-rank-${team.number}`} style={{ ...mainCardStyle, margin: 0, padding: '20px', minHeight: 'auto', backgroundColor: '#fff', borderLeft: tIdx === 0 ? '5px solid #FFD700' : tIdx === 1 ? '5px solid #C0C0C0' : tIdx === 2 ? '5px solid #CD7F32' : '1px solid #ddd' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', borderBottom: '1px solid #eee', paddingBottom: '8px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <span style={{
                            width: '32px', height: '32px', borderRadius: '50%',
                            backgroundColor: tIdx === 0 ? '#FFD700' : tIdx === 1 ? '#C0C0C0' : tIdx === 2 ? '#CD7F32' : '#f1f3f5',
                            color: tIdx < 3 ? '#000' : '#333',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontWeight: 'bold', fontSize: '0.95rem', boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                          }}>
                            {tIdx + 1}.
                          </span>
                          <span style={{ fontWeight: 'bold', fontSize: '1.1rem', color: '#333' }}>
                            {team.number}. Csapat
                          </span>
                        </div>
                        <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#b30000' }}>
                          {team.totalScore} pont
                        </div>
                      </div>

                      <table style={{ ...tableStyle, fontSize: '0.85rem', tableLayout: 'fixed', width: '100%' }}>
                        <thead>
                          <tr>
                            <th style={{ ...thStyle, width: '35px', padding: '6px', textAlign: 'center' }}>#</th>
                            <th style={{ ...thStyle, width: '28%', padding: '6px' }}>Tag neve</th>
                            <th style={{ ...thStyle, width: '28%', padding: '6px' }}>Egyesület</th>
                            <th style={{ ...thStyle, width: '18%', padding: '6px' }}>Kategória</th>
                            <th style={{ ...thStyle, width: '12%', padding: '6px' }}>Koroszt.</th>
                            <th style={{ ...thStyle, width: '70px', textAlign: 'right', padding: '6px' }}>Pont</th>
                          </tr>
                        </thead>
                        <tbody>
                          {team.members.map((m, mIdx) => (
                            <tr key={m.id || mIdx}>
                              <td style={{ ...tdStyle, padding: '6px', textAlign: 'center', color: '#888', width: '35px' }}>{mIdx + 1}</td>
                              <td style={{ ...tdStyle, padding: '6px', fontWeight: 'bold', width: '28%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.fullName}</td>
                              <td style={{ ...tdStyle, padding: '6px', color: '#666', width: '28%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.club || '-'}</td>
                              <td style={{ ...tdStyle, padding: '6px', color: '#555', width: '18%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{translationMap[m.bowCategory] || m.bowCategory || '-'}</td>
                              <td style={{ ...tdStyle, padding: '6px', color: '#555', width: '12%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{translationMap[m.ageCategory] || m.ageCategory || '-'}</td>
                              <td style={{ ...tdStyle, padding: '6px', textAlign: 'right', fontWeight: 'bold', color: m.totalScore !== undefined ? '#2e7d32' : '#888', width: '70px' }}>
                                {m.totalScore !== undefined ? `${m.totalScore} p` : 'Még nincs'}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ))
                ) : (
                  <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>Nincs még beosztott csapat vagy pontszám.</div>
                )}
              </div>
            )}
          </div>
        )}

        {/* --- QR-BEOLVASÓ FÜL TARTALMA (ÁTADVA A MENTŐ FÜGGVÉNY ÉS A DARABOLÁS TÖLTŐCSÍK ÁLLAPOT IS) --- */}
{activeTab === 'qr-scanner' && (
  <QrCodeScannerTab
    onScanSuccess={handleQrScanResult}
    onSaveScores={handleSaveScannedScores}
    qrProgressInfo={qrProgressInfo}
    onCancelProgress={handleCancelPartialScan}
  />
)}

{/* --- DOKUMENTUMOK FÜL TARTALMA (BEÍRÓLAP GENERÁTOR) --- */}
{(activeTab === 'score-sheet' || activeTab === 'documents') && (
  <>
  <div style={{ display: 'flex', gap: '25px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
    {/* BAL OLDAL (1/3 SZÉLESSÉG) - VEZÉRLŐ PULT (NO-PRINT) */}
    <div className="no-print" style={{ ...mainCardStyle, minHeight: 'auto', padding: '20px', flex: '1', minWidth: '300px', maxWidth: '380px', position: 'sticky', top: '20px' }}>
      <div style={{ marginBottom: '15px', borderBottom: '2px solid #b30000', paddingBottom: '10px' }}>
        <h3 style={{ margin: 0, color: '#b30000', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FiFileText /> Beírólap Szerkesztő
        </h3>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
        {/* CÉLOK SZÁMA ÉS TALÁLATOK */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '12px', backgroundColor: '#fafafa', borderRadius: '8px', border: '1px solid #eee' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ fontSize: '0.9rem', fontWeight: 'bold', color: '#333' }}>Célok száma:</span>
            <span style={{ fontSize: '1.2rem', fontWeight: '900', color: '#b30000' }}>{competition?.numberOfTargets || 20} cél</span>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderTop: '1px dashed #eee', paddingTop: '8px' }}>
            <span style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#333' }}>Találatok:</span>
            <div style={{ display: 'flex', gap: '4px', alignItems: 'center', flexWrap: 'wrap', maxWidth: '200px', justifyContent: 'flex-start' }}>
              {(competition?.scoringValues || ['11', '10', '8', '5', '0'])
                .sort((a, b) => {
                  const valA = a === 'X' ? 11.5 : parseInt(a) || 0;
                  const valB = b === 'X' ? 11.5 : parseInt(b) || 0;
                  return valB - valA;
                })
                .map(val => (
                  <span key={val} style={{
                    backgroundColor: '#b30000',
                    color: 'white',
                    width: '24px',
                    height: '24px',
                    borderRadius: '4px',
                    fontSize: '0.8rem',
                    fontWeight: 'bold',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    lineHeight: '1'
                  }}>
                    {val}
                  </span>
                ))
              }
            </div>
          </div>
        </div>

        {/* TÁJOLÁS (ÁLLÓ / FEKVŐ) */}
        <div>
          <label style={{ ...labelStyle, marginBottom: '6px' }}>Nyomtatási tájolás:</label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '4px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '0.85rem' }}>
              <input
                type="radio"
                name="scoreSheetOrientation"
                value="portrait"
                checked={scoreSheetPageOrientation === 'portrait'}
                onChange={() => setScoreSheetPageOrientation('portrait')}
                style={{ accentColor: '#b30000' }}
              />
              📄 A4 Álló (Portrait) - 1 db / lap
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '0.85rem' }}>
              <input
                type="radio"
                name="scoreSheetOrientation"
                value="landscape"
                checked={scoreSheetPageOrientation === 'landscape'}
                onChange={() => setScoreSheetPageOrientation('landscape')}
                style={{ accentColor: '#b30000' }}
              />
              🖼️ A4 Fekvő (Landscape) - 2 db / lap
            </label>
          </div>
        </div>

        {/* MATRICA / QR MÓD */}
        <div>
          <label style={{ ...labelStyle, marginBottom: '6px' }}>QR-kód / Matrica mód:</label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '4px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '0.85rem' }}>
              <input
                type="radio"
                name="scoreSheetQr"
                value="blank"
                checked={scoreSheetQrOption === 'blank'}
                onChange={() => setScoreSheetQrOption('blank')}
                style={{ accentColor: '#b30000' }}
              />
              Üres hely hagyása (Matricázáshoz)
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '0.85rem' }}>
              <input
                type="radio"
                name="scoreSheetQr"
                value="printed"
                checked={scoreSheetQrOption === 'printed'}
                onChange={() => setScoreSheetQrOption('printed')}
                style={{ accentColor: '#b30000' }}
              />
              Névreszóló QR-kód rányomtatása
            </label>
          </div>
        </div>

        {/* NÉVRESZÓLÓ KIVÁLASZTÁS */}
        <div>
          <label style={{ ...labelStyle, marginBottom: '6px' }}>Nyomtatandó nevező(k):</label>
          <select
            disabled={scoreSheetQrOption === 'blank'}
            value={scoreSheetSelectedCompetitorId}
            onChange={(e) => setScoreSheetSelectedCompetitorId(e.target.value)}
            style={{ ...selectStyle, width: '100%', opacity: scoreSheetQrOption === 'blank' ? 0.5 : 1 }}
          >
            <option value="all">Minden nevező ({participants.length} fő)</option>
            {participants.map(p => (
              <option key={p.id} value={p.id}>{p.fullName} ({formatClubName(p.club) || 'Egyéni'})</option>
            ))}
          </select>
        </div>

        {/* NYOMTATÁS GOMB */}
        <button
          type="button"
          onClick={() => window.print()}
          style={{ ...exportButtonStyle, backgroundColor: '#b30000', color: 'white', border: 'none', padding: '12px 20px', fontSize: '1rem', width: '100%', marginTop: '10px', boxShadow: '0 4px 10px rgba(179,0,0,0.3)' }}
        >
          <FiPrinter size={18} /> Beírólap(ok) Nyomtatása
        </button>
      </div>
    </div>

    {/* JOBB OLDAL (2/3 SZÉLESSÉG) - ÉLŐ ELŐNÉZET (JOBB OSZLOPBAN EGYMÁS MELLETT) */}
    <div style={{ flex: '2', minWidth: '320px', overflowX: 'hidden' }}>
      <div className="printable-scoresheet-wrapper" style={{ width: '100%' }}>
        {(() => {
          const rawList = (scoreSheetQrOption === 'printed'
            ? (scoreSheetSelectedCompetitorId === 'all'
                ? (participants.length > 0 ? participants : [{ id: 'sample', fullName: 'Minta Versenyző', club: 'Minta SE', bowCategory: '3d_hdh_trrb', ageCategory: 'felnott' }])
                : [participants.find(p => p.id === scoreSheetSelectedCompetitorId) || { id: 'sample', fullName: 'Minta Versenyző', club: 'Minta SE', bowCategory: '3d_hdh_trrb', ageCategory: 'felnott' }])
            : [{ id: 'blank1', fullName: '', club: '', bowCategory: '', ageCategory: '' }]
          );

          const isLandscape = scoreSheetPageOrientation === 'landscape';
          const targetCount = Number(competition?.numberOfTargets) || 20;
          const totalTableRows = targetCount + 2;

          // Dinamikus sormagasság kiszámítása a TELJES A4-es magasság kitöltésére (mm-ben)
          const rowHeightMm = isLandscape
            ? Math.max(3.0, Math.min(8.0, parseFloat((152 / totalTableRows).toFixed(2))))
            : Math.max(4.0, Math.min(11.0, parseFloat((225 / totalTableRows).toFixed(2))));

          const dynamicTableFontSize = targetCount > 28
            ? (isLandscape ? '0.52rem' : '0.68rem')
            : (targetCount > 20 ? (isLandscape ? '0.62rem' : '0.75rem') : (isLandscape ? '0.72rem' : '0.85rem'));

          const dynamicHeaderHeight = targetCount > 28
            ? (isLandscape ? '4.8mm' : '6.5mm')
            : (targetCount > 20 ? (isLandscape ? '5.5mm' : '7.5mm') : (isLandscape ? '6.5mm' : '9mm'));

          const dynamicFooterMargin = targetCount > 28
            ? (isLandscape ? '3px' : '6px')
            : (targetCount > 20 ? (isLandscape ? '4px' : '8px') : (isLandscape ? '6px' : '12px'));

          const dynamicSecondRowMargin = targetCount > 28
            ? (isLandscape ? '3px' : '6px')
            : (targetCount > 20 ? (isLandscape ? '5px' : '10px') : (isLandscape ? '8px' : '15px'));

          const pagesList = [];
          if (isLandscape) {
            if (scoreSheetQrOption === 'blank') {
              pagesList.push([{ id: 'blank1', fullName: '', club: '', bowCategory: '', ageCategory: '' }, { id: 'blank2', fullName: '', club: '', bowCategory: '', ageCategory: '' }]);
            } else {
              for (let i = 0; i < rawList.length; i += 2) {
                pagesList.push(rawList.slice(i, i + 2));
              }
            }
          } else {
            rawList.forEach(item => pagesList.push([item]));
          }

          const renderSingleSheet = (comp, sheetIdx) => (
            <div key={comp.id || sheetIdx} style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justify: 'space-between',
              borderRight: (isLandscape && sheetIdx === 0) ? '1px dashed #000' : 'none',
              paddingRight: (isLandscape && sheetIdx === 0) ? '6mm' : '0',
              paddingLeft: (isLandscape && sheetIdx === 1) ? '6mm' : '0',
              boxSizing: 'border-box',
              minWidth: 0
            }}>
              {/* TOP COMPACT HEADER (LOGÓ, CÍM ÉS QR-MATRICA DOBOZ EGY SORBAN) */}
              <div style={{
                display: 'flex',
                justify: 'space-between',
                alignItems: 'center',
                gap: isLandscape ? '8px' : '12px',
                borderBottom: '2px solid #000',
                paddingBottom: isLandscape ? '4px' : '8px',
                marginBottom: isLandscape ? '6px' : '10px'
              }}>
                {/* LOGO */}
                <div style={{ flexShrink: 0, textAlign: 'center' }}>
                  <img
                    src={competition?.organizerLogoUrl || competition?.clubLogoUrl || competition?.logoUrl || competition?.logo || logo}
                    alt="Club Logo"
                    style={{ maxHeight: isLandscape ? '52px' : '78px', maxWidth: isLandscape ? '80px' : '115px', objectFit: 'contain' }}
                  />
                </div>

                {/* TITLE */}
                <div style={{ textAlign: 'center', flex: 1, padding: '0 5px' }}>
                  <h1 style={{ margin: 0, fontSize: isLandscape ? '0.9rem' : '1.25rem', color: '#000', fontWeight: 'bold', lineHeight: '1.1' }}>
                    {competition?.competitionName || 'VERSENY NEVE'}
                  </h1>
                </div>

                {/* MATRICA / COMPETITOR INFO DOBOZ - RÖGZÍTETT QR KÓD MÉRETTEL */}
                <div style={{
                  border: (scoreSheetQrOption === 'blank' || comp.id?.startsWith('blank')) ? '2px dashed #000' : '1px solid #ccc',
                  padding: isLandscape ? '3px 5px' : '5px 8px',
                  borderRadius: '6px',
                  minHeight: '72px',
                  width: isLandscape ? '215px' : '280px',
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#ffffff',
                  boxSizing: 'border-box',
                  flexShrink: 0
                }}>
                  {(scoreSheetQrOption === 'blank' || comp.id?.startsWith('blank')) ? (
                    <div style={{ color: '#888', fontStyle: 'italic', fontSize: isLandscape ? '0.72rem' : '0.82rem', textAlign: 'center', width: '100%' }}>
                      📌 QR-kód matrica helye
                    </div>
                  ) : (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', width: '100%' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
                        <QRCodeSVG value={generateParticipantQrString(comp)} size={70} />
                        <div style={{
                          fontSize: isLandscape ? '0.55rem' : '0.65rem',
                          fontWeight: '900',
                          color: '#b30000',
                          fontFamily: 'monospace',
                          marginTop: '1px',
                          letterSpacing: '0.2px',
                          textAlign: 'center',
                          lineHeight: '1'
                        }}>
                          {generateParticipantId(comp)}
                        </div>
                      </div>

                      <div style={{ textAlign: 'left', flex: 1, overflow: 'hidden' }}>
                        <div style={{ fontSize: isLandscape ? '0.78rem' : '0.9rem', fontWeight: 'bold', color: '#000', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.1' }}>
                          {comp.fullName}
                        </div>
                        <div style={{ fontSize: isLandscape ? '0.62rem' : '0.7rem', color: '#666', marginTop: '1px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.1' }}>
                          {formatClubName(comp.club) || 'Egyéni induló'}
                        </div>
                        <div style={{ fontSize: isLandscape ? '0.68rem' : '0.78rem', color: '#333', marginTop: '1px', fontWeight: 'bold', lineHeight: '1.1' }}>
                          {getShortBowCategoryLabel(comp.bowCategory)} - {translationMap[comp.ageCategory] || comp.ageCategory}
                        </div>
                        {comp.team && (
                          <div style={{ fontSize: isLandscape ? '0.65rem' : '0.72rem', color: '#b30000', marginTop: '1px', fontWeight: 'bold', lineHeight: '1.1' }}>
                            Csapat: {comp.team}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* DINAMIKUS SCORING TABLE - EGYENLŐ RUBRIKÁKKAL */}
              <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #000', textAlign: 'center', fontSize: dynamicTableFontSize, tableLayout: 'fixed' }}>
                <thead>
                  <tr style={{ backgroundColor: '#e9ecef', borderBottom: '2px solid #000', height: dynamicHeaderHeight }}>
                    <th style={{ border: '1px solid #000', width: isLandscape ? '38px' : '60px', padding: '1px' }}>Célok</th>
                    {(competition?.scoringValues || ['11', '10', '8', '5', '0']).map(val => (
                      <th key={val} style={{ border: '1px solid #000', padding: '1px', fontWeight: 'bold' }}>{val}</th>
                    ))}
                    <th style={{ border: '1px solid #000', width: isLandscape ? '55px' : '80px', padding: '1px' }}>Találat</th>
                    <th style={{ border: '1px solid #000', width: isLandscape ? '70px' : '100px', padding: '1px' }}>Göngyölített</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.from({ length: targetCount }, (_, i) => i + 1).map(num => (
                    <tr key={num} style={{ height: `${rowHeightMm}mm`, borderBottom: '1px solid #000' }}>
                      <td style={{ border: '1px solid #000', fontWeight: 'bold', backgroundColor: '#f8f9fa', padding: '0 2px' }}>{num}.</td>
                      {(competition?.scoringValues || ['11', '10', '8', '5', '0']).map(val => (
                        <td key={val} style={{ border: '1px solid #000', padding: 0 }}></td>
                      ))}
                      <td style={{ border: '1px solid #000', padding: 0 }}></td>
                      <td style={{ border: '1px solid #000', padding: 0 }}></td>
                    </tr>
                  ))}
                  <tr style={{ height: dynamicHeaderHeight, backgroundColor: '#f1f3f5', fontWeight: 'bold' }}>
                    <td style={{ border: '1px solid #000', textAlign: 'right', paddingRight: '6px' }}>Össz:</td>
                    {(competition?.scoringValues || ['11', '10', '8', '5', '0']).map(val => (
                      <td key={val} style={{ border: '1px solid #000', padding: 0 }}></td>
                    ))}
                    <td style={{ border: '1px solid #000', padding: 0 }}></td>
                    <td style={{ border: '1px solid #000', padding: 0 }}></td>
                  </tr>
                </tbody>
              </table>

              {/* VÉGEREDMÉNY FOOTER BOX & LÁBLÉC ÜZENET */}
              <div style={{ marginTop: dynamicFooterMargin, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: '10px' }}>
                {/* BAL OLDAL */}
                <div style={{ textAlign: 'left', fontSize: isLandscape ? '0.72rem' : '0.85rem', color: '#333', maxWidth: isLandscape ? '60%' : 'calc(100% - 210px)' }}>
                  <div style={{ fontWeight: 'bold', fontSize: isLandscape ? '0.8rem' : '0.95rem' }}>Köszönjük a részvételt! 🏹</div>
                  {(competition?.organizingClub || competition?.clubName) && (
                    <div style={{ fontSize: isLandscape ? '0.65rem' : '0.78rem', color: '#555', marginTop: '1px', lineHeight: '1.2' }}>
                      Szervező: <strong>{formatClubName(competition.organizingClub || competition.clubName)}</strong>
                    </div>
                  )}
                </div>

                {/* JOBB OLDAL: VÉGEREDMÉNY MEZŐ */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                  <span style={{ fontSize: isLandscape ? '0.95rem' : '1.2rem', fontWeight: 'bold', color: '#000' }}>Végeredmény:</span>
                  <div style={{ width: isLandscape ? '90px' : '130px', height: isLandscape ? '30px' : '38px', border: '2px solid #000', borderRadius: '4px', backgroundColor: '#fff' }}></div>
                </div>
              </div>
            </div>
          );

          return pagesList.map((pagePair, pageIdx) => (
            <div key={`page-${pageIdx}`} className="scoresheet-page" style={{
              backgroundColor: '#fff',
              padding: isLandscape ? '5mm 5mm' : '12mm 15mm',
              borderRadius: '12px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
              border: '1px solid #ddd',
              marginBottom: '20px',
              boxSizing: 'border-box',
              width: isLandscape ? '297mm' : '210mm',
              maxWidth: '100%',
              minHeight: isLandscape ? '210mm' : '297mm',
              margin: '0 auto 20px auto',
              display: isLandscape ? 'flex' : 'block',
              position: 'relative',
              overflow: 'hidden',
              gap: 0
            }}>
              {/* ÁTLÓS KÉPERNYŐS VÍZJEL */}
              <div className="no-print" style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(-30deg)',
                fontSize: isLandscape ? '2rem' : '2.5rem',
                fontWeight: '900',
                color: 'rgba(179, 0, 0, 0.12)',
                pointerEvents: 'none',
                whiteSpace: 'nowrap',
                userSelect: 'none',
                zIndex: 10,
                letterSpacing: '2px'
              }}>
                ÉLŐ NYOMTATÁSI ELŐNÉZET
              </div>

              {pagePair.map((comp, sIdx) => renderSingleSheet(comp, sIdx))}
            </div>
          ));
        })()}
      </div>
    </div>
  </div>
)}

{/* HIVATALOS NYOMTATÁSI PORTÁL (DOCUMENT.BODY-RA CSATOLVA A TISZTA NYOMTATÁSHOZ) */}
{(activeTab === 'score-sheet' || activeTab === 'documents') && createPortal(
  <div id="archery-nexus-scoresheet-print-portal">
    <div className="printable-scoresheet-wrapper">
      {(() => {
        const rawList = (scoreSheetQrOption === 'printed'
          ? (scoreSheetSelectedCompetitorId === 'all'
              ? (participants.length > 0 ? participants : [{ id: 'sample', fullName: 'Minta Versenyző', club: 'Minta SE', bowCategory: '3d_hdh_trrb', ageCategory: 'felnott' }])
              : [participants.find(p => p.id === scoreSheetSelectedCompetitorId) || { id: 'sample', fullName: 'Minta Versenyző', club: 'Minta SE', bowCategory: '3d_hdh_trrb', ageCategory: 'felnott' }])
          : [{ id: 'blank1', fullName: '', club: '', bowCategory: '', ageCategory: '' }]
        );

        const isLandscape = scoreSheetPageOrientation === 'landscape';
        const targetCount = Number(competition?.numberOfTargets) || 20;
        const totalTableRows = targetCount + 2;

        const rowHeightMm = isLandscape
          ? Math.max(3.0, Math.min(8.0, parseFloat((152 / totalTableRows).toFixed(2))))
          : Math.max(4.0, Math.min(11.0, parseFloat((225 / totalTableRows).toFixed(2))));

        const dynamicTableFontSize = targetCount > 28
          ? (isLandscape ? '0.52rem' : '0.68rem')
          : (targetCount > 20 ? (isLandscape ? '0.62rem' : '0.75rem') : (isLandscape ? '0.72rem' : '0.85rem'));

        const dynamicHeaderHeight = targetCount > 28
          ? (isLandscape ? '4.8mm' : '6.5mm')
          : (targetCount > 20 ? (isLandscape ? '5.5mm' : '7.5mm') : (isLandscape ? '6.5mm' : '9mm'));

        const dynamicFooterMargin = targetCount > 28
          ? (isLandscape ? '3px' : '6px')
          : (targetCount > 20 ? (isLandscape ? '4px' : '8px') : (isLandscape ? '6px' : '12px'));

        const pagesList = [];
        if (isLandscape) {
          if (scoreSheetQrOption === 'blank') {
            pagesList.push([{ id: 'blank1', fullName: '', club: '', bowCategory: '', ageCategory: '' }, { id: 'blank2', fullName: '', club: '', bowCategory: '', ageCategory: '' }]);
          } else {
            for (let i = 0; i < rawList.length; i += 2) {
              pagesList.push(rawList.slice(i, i + 2));
            }
          }
        } else {
          rawList.forEach(item => pagesList.push([item]));
        }

        const renderSingleSheet = (comp, sheetIdx) => (
          <div key={comp.id || sheetIdx} style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justify: 'space-between',
            borderRight: (isLandscape && sheetIdx === 0) ? '1px dashed #000' : 'none',
            paddingRight: (isLandscape && sheetIdx === 0) ? '6mm' : '0',
            paddingLeft: (isLandscape && sheetIdx === 1) ? '6mm' : '0',
            boxSizing: 'border-box',
            minWidth: 0
          }}>
            <div style={{
              display: 'flex',
              justify: 'space-between',
              alignItems: 'center',
              gap: isLandscape ? '8px' : '12px',
              borderBottom: '2px solid #000',
              paddingBottom: isLandscape ? '4px' : '8px',
              marginBottom: isLandscape ? '6px' : '10px'
            }}>
              <div style={{ flexShrink: 0, textAlign: 'center' }}>
                <img
                  src={competition?.organizerLogoUrl || competition?.clubLogoUrl || competition?.logoUrl || competition?.logo || logo}
                  alt="Club Logo"
                  style={{ maxHeight: isLandscape ? '52px' : '78px', maxWidth: isLandscape ? '80px' : '115px', objectFit: 'contain' }}
                />
              </div>

              <div style={{ textAlign: 'center', flex: 1, padding: '0 5px' }}>
                <h1 style={{ margin: 0, fontSize: isLandscape ? '0.9rem' : '1.25rem', color: '#000', fontWeight: 'bold', lineHeight: '1.1' }}>
                  {competition?.competitionName || 'VERSENY NEVE'}
                </h1>
              </div>

              <div style={{
                border: (scoreSheetQrOption === 'blank' || comp.id?.startsWith('blank')) ? '2px dashed #000' : '1px solid #ccc',
                padding: isLandscape ? '3px 5px' : '5px 8px',
                borderRadius: '6px',
                minHeight: '72px',
                width: isLandscape ? '215px' : '280px',
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#ffffff',
                boxSizing: 'border-box',
                flexShrink: 0
              }}>
                {(scoreSheetQrOption === 'blank' || comp.id?.startsWith('blank')) ? (
                  <div style={{ color: '#888', fontStyle: 'italic', fontSize: isLandscape ? '0.72rem' : '0.82rem', textAlign: 'center', width: '100%' }}>
                    📌 QR-kód matrica helye
                  </div>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', width: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
                      <QRCodeSVG value={generateParticipantQrString(comp)} size={70} />
                      <div style={{
                        fontSize: isLandscape ? '0.55rem' : '0.65rem',
                        fontWeight: '900',
                        color: '#b30000',
                        fontFamily: 'monospace',
                        marginTop: '1px',
                        letterSpacing: '0.2px',
                        textAlign: 'center',
                        lineHeight: '1'
                      }}>
                        {generateParticipantId(comp)}
                      </div>
                    </div>

                    <div style={{ textAlign: 'left', flex: 1, overflow: 'hidden' }}>
                      <div style={{ fontSize: isLandscape ? '0.78rem' : '0.9rem', fontWeight: 'bold', color: '#000', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.1' }}>
                        {comp.fullName}
                      </div>
                      <div style={{ fontSize: isLandscape ? '0.62rem' : '0.7rem', color: '#666', marginTop: '1px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.1' }}>
                        {formatClubName(comp.club) || 'Egyéni induló'}
                      </div>
                      <div style={{ fontSize: isLandscape ? '0.68rem' : '0.78rem', color: '#333', marginTop: '1px', fontWeight: 'bold', lineHeight: '1.1' }}>
                        {getShortBowCategoryLabel(comp.bowCategory)} - {translationMap[comp.ageCategory] || comp.ageCategory}
                      </div>
                      {comp.team && (
                        <div style={{ fontSize: isLandscape ? '0.65rem' : '0.72rem', color: '#b30000', marginTop: '1px', fontWeight: 'bold', lineHeight: '1.1' }}>
                          Csapat: {comp.team}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse', border: '2px solid #000', textAlign: 'center', fontSize: dynamicTableFontSize, tableLayout: 'fixed' }}>
              <thead>
                <tr style={{ backgroundColor: '#e9ecef', borderBottom: '2px solid #000', height: dynamicHeaderHeight }}>
                  <th style={{ border: '1px solid #000', width: isLandscape ? '38px' : '60px', padding: '1px' }}>Célok</th>
                  {(competition?.scoringValues || ['11', '10', '8', '5', '0']).map(val => (
                    <th key={val} style={{ border: '1px solid #000', padding: '1px', fontWeight: 'bold' }}>{val}</th>
                  ))}
                  <th style={{ border: '1px solid #000', width: isLandscape ? '55px' : '80px', padding: '1px' }}>Találat</th>
                  <th style={{ border: '1px solid #000', width: isLandscape ? '70px' : '100px', padding: '1px' }}>Göngyölített</th>
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: targetCount }, (_, i) => i + 1).map(num => (
                  <tr key={num} style={{ height: `${rowHeightMm}mm`, borderBottom: '1px solid #000' }}>
                    <td style={{ border: '1px solid #000', fontWeight: 'bold', backgroundColor: '#f8f9fa', padding: '0 2px' }}>{num}.</td>
                    {(competition?.scoringValues || ['11', '10', '8', '5', '0']).map(val => (
                      <td key={val} style={{ border: '1px solid #000', padding: 0 }}></td>
                    ))}
                    <td style={{ border: '1px solid #000', padding: 0 }}></td>
                    <td style={{ border: '1px solid #000', padding: 0 }}></td>
                  </tr>
                ))}
                <tr style={{ height: dynamicHeaderHeight, backgroundColor: '#f1f3f5', fontWeight: 'bold' }}>
                  <td style={{ border: '1px solid #000', textAlign: 'right', paddingRight: '6px' }}>Össz:</td>
                  {(competition?.scoringValues || ['11', '10', '8', '5', '0']).map(val => (
                    <td key={val} style={{ border: '1px solid #000', padding: 0 }}></td>
                  ))}
                  <td style={{ border: '1px solid #000', padding: 0 }}></td>
                  <td style={{ border: '1px solid #000', padding: 0 }}></td>
                </tr>
              </tbody>
            </table>

            <div style={{ marginTop: dynamicFooterMargin, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: '10px' }}>
              <div style={{ textAlign: 'left', fontSize: isLandscape ? '0.72rem' : '0.85rem', color: '#333', maxWidth: isLandscape ? '60%' : 'calc(100% - 210px)' }}>
                <div style={{ fontWeight: 'bold', fontSize: isLandscape ? '0.8rem' : '0.95rem' }}>Köszönjük a részvételt! 🏹</div>
                {(competition?.organizingClub || competition?.clubName) && (
                  <div style={{ fontSize: isLandscape ? '0.65rem' : '0.78rem', color: '#555', marginTop: '1px', lineHeight: '1.2' }}>
                    Szervező: <strong>{formatClubName(competition.organizingClub || competition.clubName)}</strong>
                  </div>
                )}
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                <span style={{ fontSize: isLandscape ? '0.95rem' : '1.2rem', fontWeight: 'bold', color: '#000' }}>Végeredmény:</span>
                <div style={{ width: isLandscape ? '90px' : '130px', height: isLandscape ? '30px' : '38px', border: '2px solid #000', borderRadius: '4px', backgroundColor: '#fff' }}></div>
              </div>
            </div>
          </div>
        );

        return pagesList.map((pagePair, pageIdx) => (
          <div key={`portal-page-${pageIdx}`} className="scoresheet-page portal-print-sheet" style={{
            backgroundColor: '#fff',
            padding: isLandscape ? '3mm 5mm' : '8mm 10mm',
            boxSizing: 'border-box',
            width: '100%',
            height: '100vh',
            maxHeight: '100vh',
            display: 'flex',
            flexDirection: isLandscape ? 'row' : 'column',
            position: 'relative',
            overflow: 'hidden',
            gap: 0
          }}>
            {pagePair.map((comp, sIdx) => renderSingleSheet(comp, sIdx))}
          </div>
        ));
      })()}
    </div>

    {/* NYOMTATÁSI CSS: REJTSÜK EL A FŐ ALKALMAZÁST (#ROOT) NYOMTATÁSKOR */}
    <style>{`
      @media print {
        @page {
          size: A4 ${scoreSheetPageOrientation};
          margin: 0mm !important;
        }

        ::-webkit-scrollbar {
          display: none !important;
          width: 0 !important;
          height: 0 !important;
        }

        #root {
          display: none !important;
        }

        body > #archery-nexus-scoresheet-print-portal {
          display: block !important;
          position: absolute !important;
          left: 0 !important;
          top: 0 !important;
          width: 100% !important;
          height: auto !important;
          margin: 0 !important;
          padding: 0 !important;
          background: white !important;
        }

        .no-print {
          display: none !important;
        }

        .scoresheet-page.portal-print-sheet {
          page-break-after: always !important;
          break-after: page !important;
          page-break-inside: avoid !important;
          break-inside: avoid !important;
          margin: 0 !important;
          box-shadow: none !important;
          border: none !important;
          box-sizing: border-box !important;
          width: 100% !important;
          height: 100vh !important;
          max-width: 100% !important;
          max-height: 100vh !important;
          overflow: hidden !important;
        }

        .scoresheet-page.portal-print-sheet:last-child {
          page-break-after: auto !important;
          break-after: auto !important;
        }
      }
    `}</style>
  </div>,
  document.body
)}
  </>
)}

        {activeTab === 'course-map' && (
          <>
            <header style={{ ...headerStyle, marginBottom: '10px', marginTop: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                <h2 style={{ margin: 0 }}>Pálya térkép</h2>
              </div>
              <div style={headerStatsStyle}>
                <input
                  type="file"
                  ref={customMapInputRef}
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleCustomMapUpload}
                />

                <button
                  type="button"
                  onClick={handleTogglePublishMap}
                  disabled={isPublishingMap}
                  style={{
                    backgroundColor: competition?.courseMapPublished ? '#6c757d' : '#28a745',
                    color: '#fff', border: 'none', borderRadius: '8px', padding: '7px 14px', cursor: 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.82rem',
                    marginRight: '8px'
                  }}
                >
                  <FiMap /> {isPublishingMap ? 'Folyamatban...' : (competition?.courseMapPublished ? 'Térkép elrejtése' : 'Térkép publikálása')}
                </button>

                {/* NYOMTATÁS DYNAMIC DROPDOWN */}
                {(() => {
                  const hasGoogleMap = !!competition?.courseMapData && ((competition.courseMapData.paths && competition.courseMapData.paths.length > 0) || (competition.courseMapData.targets && competition.courseMapData.targets.length > 0));
                  const hasCustomMap = !!competition?.customMapImageUrl;

                  return (
                    <div style={{ position: 'relative' }} ref={printDropdownRef}>
                      <button
                        type="button"
                        onClick={() => setShowPrintDropdown(prev => !prev)}
                        style={{
                          backgroundColor: '#b30000',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '7px 14px',
                          cursor: 'pointer',
                          fontWeight: 'bold',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                          fontSize: '0.82rem'
                        }}
                      >
                        <FiPrinter /> Térkép Nyomtatása <FiChevronDown size={14} style={{ transform: showPrintDropdown ? 'rotate(180deg)' : 'none', transition: '0.2s' }} />
                      </button>

                      {showPrintDropdown && (
                        <div style={{
                          position: 'absolute',
                          top: '100%',
                          right: 0,
                          marginTop: '6px',
                          backgroundColor: '#ffffff',
                          borderRadius: '10px',
                          boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
                          border: '1px solid #ddd',
                          padding: '6px',
                          zIndex: 1000,
                          minWidth: '220px',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '4px'
                        }}>
                          {/* GOOGLE TÉRKÉP NYOMTATÁSA */}
                          <button
                            type="button"
                            disabled={!hasGoogleMap}
                            onClick={() => {
                              setShowPrintDropdown(false);
                              handlePrintMap();
                            }}
                            title={hasGoogleMap ? 'Google Maps interaktív pálya nyomtatása' : 'Nincs elmentve Google Maps pályaadat'}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              padding: '8px 12px',
                              borderRadius: '6px',
                              border: 'none',
                              backgroundColor: 'transparent',
                              color: hasGoogleMap ? '#333' : '#aaa',
                              fontWeight: 'bold',
                              fontSize: '0.82rem',
                              cursor: hasGoogleMap ? 'pointer' : 'not-allowed',
                              opacity: hasGoogleMap ? 1 : 0.5,
                              textAlign: 'left',
                              width: '100%',
                              transition: 'background-color 0.2s'
                            }}
                            onMouseEnter={(e) => { if (hasGoogleMap) e.currentTarget.style.backgroundColor = '#f0f4f8'; }}
                            onMouseLeave={(e) => { if (hasGoogleMap) e.currentTarget.style.backgroundColor = 'transparent'; }}
                          >
                            <FiMap size={16} color={hasGoogleMap ? '#b30000' : '#aaa'} />
                            <span>Google térkép nyomtatása</span>
                          </button>

                          {/* SAJÁT TÉRKÉP NYOMTATÁSA */}
                          <button
                            type="button"
                            disabled={!hasCustomMap}
                            onClick={() => {
                              setShowPrintDropdown(false);
                              if (competition?.customMapImageUrl) {
                                setShowCustomMapPrintModal(true);
                              }
                            }}
                            title={hasCustomMap ? 'Saját feltöltött térkép nyomtatása (ArcheryNexus fejléccel)' : 'Nincs feltöltve saját térkép'}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              padding: '8px 12px',
                              borderRadius: '6px',
                              border: 'none',
                              backgroundColor: 'transparent',
                              color: hasCustomMap ? '#333' : '#aaa',
                              fontWeight: 'bold',
                              fontSize: '0.82rem',
                              cursor: hasCustomMap ? 'pointer' : 'not-allowed',
                              opacity: hasCustomMap ? 1 : 0.5,
                              textAlign: 'left',
                              width: '100%',
                              transition: 'background-color 0.2s'
                            }}
                            onMouseEnter={(e) => { if (hasCustomMap) e.currentTarget.style.backgroundColor = '#f0f4f8'; }}
                            onMouseLeave={(e) => { if (hasCustomMap) e.currentTarget.style.backgroundColor = 'transparent'; }}
                          >
                            <FiImage size={16} color={hasCustomMap ? '#b30000' : '#aaa'} />
                            <span>Saját térkép nyomtatása</span>
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>
            </header>

            {/* FELSŐ VÁLTÓGOMBOK A KÉT TÉRKÉP MÓD KÖZÖTT */}
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '15px' }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#eee',
                borderRadius: '30px',
                padding: '4px',
                boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)',
                cursor: 'pointer'
              }}>
                <button
                  type="button"
                  onClick={handleSwitchToGoogleMaps}
                  style={{
                    padding: '8px 22px',
                    borderRadius: '25px',
                    border: 'none',
                    backgroundColor: !competition?.isCustomMap ? '#b30000' : 'transparent',
                    color: !competition?.isCustomMap ? 'white' : '#555',
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: !competition?.isCustomMap ? '0 2px 6px rgba(179,0,0,0.3)' : 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  <FiMap size={16} /> Google Térkép
                </button>

                <button
                  type="button"
                  onClick={handleSwitchToCustomMap}
                  style={{
                    padding: '8px 22px',
                    borderRadius: '25px',
                    border: 'none',
                    backgroundColor: competition?.isCustomMap ? '#b30000' : 'transparent',
                    color: competition?.isCustomMap ? 'white' : '#555',
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: competition?.isCustomMap ? '0 2px 6px rgba(179,0,0,0.3)' : 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  <FiImage size={16} /> Saját Térkép
                </button>
              </div>
            </div>

            <CourseMapEditor
              key={`course-editor-${editorKey}`}
              ref={mapEditorRef}
              competitionId={id}
              numberOfTargets={Number(competition?.numberOfTargets) || 24}
              defaultLat={competition?.gpsLatitude}
              defaultLng={competition?.gpsLongitude}
              onDistanceChange={setMapTotalDistance}
              totalDistance={mapTotalDistance}
              customMapImageUrl={competition?.customMapImageUrl}
              isCustomMap={competition?.isCustomMap}
              isPublishedMap={competition?.courseMapPublished}
              onSwitchToGoogleMaps={handleSwitchToGoogleMaps}
              onRemoveCustomMap={handleRemoveCustomMap}
              onUploadNewCustomMap={() => customMapInputRef.current?.click()}
              isUploadingCustomMap={isUploadingCustomMap}
            />
          </>
        )}

        {/* --- TÉRKÉP NYOMTATÁSI PORTÁL --- */}
        <PrintMapPortal
           isOpen={showMapPrintModal}
           onClose={() => {
             setShowMapPrintModal(false);
             setEditorKey(prev => prev + 1);
           }}
           competition={competition}
           distance={mapTotalDistance}
           courseData={competition?.courseMapData}
           isSnapshotMode={isSnapshotMode}
           onScreenshotReady={handleScreenshotReceived}
        />

        <PrintCustomMapPortal
           isOpen={showCustomMapPrintModal}
           onClose={() => setShowCustomMapPrintModal(false)}
           competition={competition}
           customMapImageUrl={competition?.customMapImageUrl}
        />

{/* --- CÉLOK ÉS TÁVOK FÜL TARTALMA --- */}
{activeTab === 'targets' && (
  <div style={mainCardStyle}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
      <h3 style={{ margin: 0, color: '#b30000' }}>Célok és Távolságok beállítása</h3>
      <div style={{ display: 'flex', gap: '10px' }}>
        <button
          onClick={() => setShowTargetsPrintModal(true)}
          style={{ ...exportButtonStyle, padding: '10px 20px' }}
        >
          <FiPrinter /> Nyomtatás
        </button>
        <button
          onClick={handleSaveTargets}
          disabled={isSavingTargets}
          style={{ ...qrButtonStyle, padding: '10px 25px' }}
        >
          {isSavingTargets ? 'Mentés...' : 'Összes mentése'}
        </button>
        <button
          onClick={handleTogglePublishTargets}
          disabled={isPublishingTargets}
          style={{
            ...qrButtonStyle,
            padding: '10px 25px',
            backgroundColor: competition.targetsPublished ? '#6c757d' : '#b30000',
            borderColor: competition.targetsPublished ? '#6c757d' : '#b30000'
          }}
        >
          {isPublishingTargets ? 'Folyamatban...' : (competition.targetsPublished ? 'Távok elrejtése' : 'Távok publikálása')}
        </button>
      </div>
    </div>

    <div style={{ marginBottom: '20px', padding: '10px 15px', backgroundColor: '#fff5f5', borderRadius: '8px', border: '1px solid #ffcccc' }}>
      <p style={{ fontSize: '0.85rem', color: '#b30000', margin: 0, fontWeight: 'bold' }}>
        <FiAlertCircle style={{ verticalAlign: 'middle', marginRight: '6px' }} />
        Tizedes értékeknél kérjük használj pontot (pl. 28.7)! A vesszőt a rendszer nem kezeli.
      </p>
    </div>

    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      {Array.from({ length: Number(competition?.numberOfTargets) || 0 }, (_, i) => i + 1).map(num => (
        <div key={num} style={{
          display: 'flex',
          alignItems: 'center',
          gap: '15px',
          padding: '10px 15px',
          backgroundColor: '#f8f9fa',
          borderRadius: '10px',
          border: '1px solid #eee',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}>
          <div style={{
            width: '28px',
            height: '28px',
            borderRadius: '50%',
            backgroundColor: '#b30000',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.8rem',
            fontWeight: 'bold',
            flexShrink: 0
          }}>
            {num}.
          </div>

          <input
            type="text"
            placeholder="Cél neve (pl. Medve)"
            value={localTargetDetails[num]?.name || ''}
            onChange={(e) => setLocalTargetDetails({
              ...localTargetDetails,
              [num]: { ...localTargetDetails[num], name: e.target.value }
            })}
            style={{ ...formInputStyle, flex: '1.2', minWidth: '150px', fontWeight: 'bold' }}
            disabled={isSavingTargets}
          />

          <div style={{ display: 'flex', gap: '10px', flex: '3.5', alignItems: 'center' }}>
            {/* PIROS KARÓ */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1, minWidth: 0 }}>
              <div style={{ position: 'relative', flex: 1, minWidth: '55px' }}>
                <input
                  type="text"
                  placeholder="Piros"
                  value={localTargetDetails[num]?.distRed || ''}
                  onChange={(e) => setLocalTargetDetails({
                    ...localTargetDetails,
                    [num]: { ...localTargetDetails[num], distRed: e.target.value }
                  })}
                  style={{ ...formInputStyle, border: '2.5px solid #b30000', textAlign: 'center', paddingRight: '18px', height: '38px' }}
                  disabled={isSavingTargets}
                />
                <span style={{ position: 'absolute', right: '4px', top: '50%', transform: 'translateY(-50%)', fontSize: '0.65rem', fontWeight: 'bold', color: '#b30000' }}>m</span>
              </div>
              {targetAverages[num]?.red?.avg ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff0f0', border: '1.5px solid #ffcccc', borderRadius: '6px', padding: '2px 5px', flexShrink: 0, minWidth: '45px', height: '38px', boxSizing: 'border-box', lineHeight: '1.1' }} title="Átlagos pontszám a Piros karóról">
                  <span style={{ fontSize: '0.58rem', fontWeight: 'bold', color: '#b30000', textTransform: 'uppercase', letterSpacing: '0.2px' }}>Átlag:</span>
                  <span style={{ fontSize: '0.8rem', fontWeight: '900', color: '#b30000' }}>{targetAverages[num].red.avg}</span>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fafafa', border: '1px dashed #ddd', borderRadius: '6px', padding: '2px 5px', flexShrink: 0, minWidth: '45px', height: '38px', boxSizing: 'border-box', lineHeight: '1.1' }} title="Nincs még lőtt adat">
                  <span style={{ fontSize: '0.58rem', fontWeight: 'bold', color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.2px' }}>Átlag:</span>
                  <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#ccc' }}>-</span>
                </div>
              )}
            </div>

            {/* KÉK KARÓ */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1, minWidth: 0 }}>
              <div style={{ position: 'relative', flex: 1, minWidth: '55px' }}>
                <input
                  type="text"
                  placeholder="Kék"
                  value={localTargetDetails[num]?.distBlue || ''}
                  onChange={(e) => setLocalTargetDetails({
                    ...localTargetDetails,
                    [num]: { ...localTargetDetails[num], distBlue: e.target.value }
                  })}
                  style={{ ...formInputStyle, border: '2.5px solid #007bff', textAlign: 'center', paddingRight: '18px', height: '38px' }}
                  disabled={isSavingTargets}
                />
                <span style={{ position: 'absolute', right: '4px', top: '50%', transform: 'translateY(-50%)', fontSize: '0.65rem', fontWeight: 'bold', color: '#007bff' }}>m</span>
              </div>
              {targetAverages[num]?.blue?.avg ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f7ff', border: '1.5px solid #cce5ff', borderRadius: '6px', padding: '2px 5px', flexShrink: 0, minWidth: '45px', height: '38px', boxSizing: 'border-box', lineHeight: '1.1' }} title="Átlagos pontszám a Kék karóról">
                  <span style={{ fontSize: '0.58rem', fontWeight: 'bold', color: '#0056b3', textTransform: 'uppercase', letterSpacing: '0.2px' }}>Átlag:</span>
                  <span style={{ fontSize: '0.8rem', fontWeight: '900', color: '#0056b3' }}>{targetAverages[num].blue.avg}</span>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fafafa', border: '1px dashed #ddd', borderRadius: '6px', padding: '2px 5px', flexShrink: 0, minWidth: '45px', height: '38px', boxSizing: 'border-box', lineHeight: '1.1' }} title="Nincs még lőtt adat">
                  <span style={{ fontSize: '0.58rem', fontWeight: 'bold', color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.2px' }}>Átlag:</span>
                  <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#ccc' }}>-</span>
                </div>
              )}
            </div>

            {/* FEHÉR KARÓ */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1, minWidth: 0 }}>
              <div style={{ position: 'relative', flex: 1, minWidth: '55px' }}>
                <input
                  type="text"
                  placeholder="Fehér"
                  value={localTargetDetails[num]?.distWhite || ''}
                  onChange={(e) => setLocalTargetDetails({
                    ...localTargetDetails,
                    [num]: { ...localTargetDetails[num], distWhite: e.target.value }
                  })}
                  style={{ ...formInputStyle, border: '2.5px solid #ddd', textAlign: 'center', paddingRight: '18px', height: '38px' }}
                  disabled={isSavingTargets}
                />
                <span style={{ position: 'absolute', right: '4px', top: '50%', transform: 'translateY(-50%)', fontSize: '0.65rem', fontWeight: 'bold', color: '#888' }}>m</span>
              </div>
              {targetAverages[num]?.white?.avg ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8f9fa', border: '1.5px solid #e2e8f0', borderRadius: '6px', padding: '2px 5px', flexShrink: 0, minWidth: '45px', height: '38px', boxSizing: 'border-box', lineHeight: '1.1' }} title="Átlagos pontszám a Fehér karóról">
                  <span style={{ fontSize: '0.58rem', fontWeight: 'bold', color: '#555', textTransform: 'uppercase', letterSpacing: '0.2px' }}>Átlag:</span>
                  <span style={{ fontSize: '0.8rem', fontWeight: '900', color: '#555' }}>{targetAverages[num].white.avg}</span>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fafafa', border: '1px dashed #ddd', borderRadius: '6px', padding: '2px 5px', flexShrink: 0, minWidth: '45px', height: '38px', boxSizing: 'border-box', lineHeight: '1.1' }} title="Nincs még lőtt adat">
                  <span style={{ fontSize: '0.58rem', fontWeight: 'bold', color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.2px' }}>Átlag:</span>
                  <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#ccc' }}>-</span>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>

    {(!competition?.numberOfTargets || Number(competition.numberOfTargets) === 0) && (
      <div style={placeholderStyle}>
        <p>A versenybeállításoknál nincs megadva célok száma.</p>
      </div>
    )}
  </div>
)}

{/* --- ÉRTESÍTÉS KÜLDÉSE A VERSENYZŐKNEK FÜL TARTALMA --- */}
{activeTab === 'notifications' && (
  <div style={mainCardStyle}>
    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      <h3 style={{ ...resultGroupTitleStyle, display: 'flex', alignItems: 'center', gap: '10px' }}>
        <FiMessageSquare color="#b30000" /> Értesítés küldése a versenyzőknek
      </h3>
      <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '25px', lineHeight: '1.5' }}>
        Írj be egy fontos hirdetményt, vészhelyzeti üzenetet (pl. <em>"Vihar közeleg! Megkérünk minden versenyzőt, hogy térjen vissza a bázisra"</em>), és küldd ki azonnali Push értesítésként a versenyen résztvevő összes appos versenyzőnek!
      </p>

      <div style={inputGroupStyle}>
        <label style={labelStyle}>Üzenet szövege</label>
        <textarea
          style={{ ...formInputStyle, minHeight: '120px', paddingTop: '12px', fontSize: '15px' }}
          value={broadcastMessage}
          onChange={(e) => setBroadcastMessage(e.target.value)}
          placeholder="Írd ide az értesítés szövegét..."
          disabled={isSendingBroadcast}
        />
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '25px' }}>
        <button
          style={{
            ...qrButtonStyle,
            padding: '12px 30px',
            fontSize: '1rem',
            opacity: isSendingBroadcast ? 0.7 : 1,
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onClick={handleSendBroadcastNotification}
          disabled={isSendingBroadcast}
        >
          <FiMessageSquare /> {isSendingBroadcast ? 'Küldés folyamatban...' : 'Értesítés küldése mindenkinek'}
        </button>
      </div>
    </div>
  </div>
)}

{/* --- GLOBÁLIS CSAPAT TOOLTIP (Bármelyik fülön működik) --- */}
{hoveredTeam && (
  <div style={{
    position: 'fixed',
    left: `${tooltipPos.x}px`,
    top: `${tooltipPos.y + 35}px`,
    backgroundColor: 'white',
    border: '1px solid #ddd',
    borderRadius: '12px',
    boxShadow: '0 15px 35px rgba(0,0,0,0.2)',
    padding: '15px',
    zIndex: 10000,
    minWidth: '220px',
    pointerEvents: 'none',
    animation: 'fadeIn 0.2s'
  }}>
    <div style={{ borderBottom: '2px solid #b30000', marginBottom: '10px', paddingBottom: '5px', fontWeight: 'bold', color: '#b30000', fontSize: '0.95rem' }}>
      {hoveredTeam.number}. csapat részletei
    </div>
    {hoveredTeam.members.length > 0 ? (
      hoveredTeam.members.map(m => {
        const isArrived = localRegisteredIds.has(m.id) || m.totalScore !== undefined;
        const hasScore = m.totalScore !== undefined;

        return (
          <div key={m.id} style={{
            fontSize: '0.85rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '4px 0',
            color: isArrived ? '#333' : '#bbb',
            borderBottom: '1px solid #f9f9f9'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden' }}>
              <span>{isArrived ? '✅' : '⏳'}</span>
              <span style={{ fontWeight: isArrived ? '600' : 'normal', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {m.fullName}
              </span>
              {hasScore && (
                <span style={{ color: '#b30000', fontWeight: 'bold', marginLeft: '4px' }}>
                  ({m.totalScore}p)
                </span>
              )}
            </div>
            <span style={{
              fontSize: '0.65rem',
              backgroundColor: '#f0f0f0',
              padding: '1px 5px',
              borderRadius: '4px',
              color: '#666',
              marginLeft: '10px',
              flexShrink: 0
            }}>
              {m.bowCategory?.split('_').pop()?.toUpperCase()}
            </span>
          </div>
        );
      })
    ) : (
      <div style={{ fontSize: '0.85rem', color: '#bbb', fontStyle: 'italic', textAlign: 'center', padding: '10px 0' }}>
        Üres csapat
      </div>
    )}
  </div>
)}

{/* --- LÁNCOLÁSI LEBEGŐ BUBORÉK --- */}
{renderLinkingBubble()}
      </div>
      {/* VISSZA A TETEJERÉ GOMB */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          style={{
            position: 'fixed',
            bottom: '30px',
            right: '30px',
            width: '50px',
            height: '50px',
            backgroundColor: '#b30000',
            color: 'white',
            borderRadius: '50%',
            border: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: '0 4px 15px rgba(179, 0, 0, 0.4)',
            zIndex: 2001,
            transition: 'all 0.3s ease',
            animation: 'fadeIn 0.3s'
          }}
          title="Vissza a tetejére"
        >
          <FiArrowUp size={24} strokeWidth={3} />
        </button>
      )}

      {/* --- GYORS-KASSZA PANEL --- */}
      {showPaymentUI && paymentGroup.length > 0 && (
        <div style={quickPaymentPanelStyle}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', borderBottom: '2px solid #b30000', paddingBottom: '10px' }}>
            <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#b30000', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <FiUsers /> Csoportos fizetés ({paymentGroup.length} fő)
            </h3>
            <FiX style={{ cursor: 'pointer', color: '#999' }} onClick={handleCancelPayment} />
          </div>

          <div style={paymentListStyle}>
            {paymentGroup.map((p, idx) => {
              const entryFee = Number(competition?.ageFees?.[p.ageCategory]) || Number(p.entryFee) || 0;

              let lunchFee = 0;
              let menuName = "Ebéd";
              if (p.lunchCount > 0) {
                if (p.lunchSelections) {
                  // ÚJ: Összetett menü választás kezelése a kasszánál
                  const activeSelections = Object.entries(p.lunchSelections)
                    .filter(([, amount]) => amount > 0)
                    .map(([key, amount]) => {
                      const name = competition?.lunches?.[key]?.name || `${key}. menü`;
                      const price = Number(competition?.lunches?.[key]?.price) || 0;
                      lunchFee += amount * price;
                      return `${amount}db ${name}`;
                    });
                  menuName = activeSelections.join(", ");
                } else if (p.selectedMenu && competition?.lunches?.[p.selectedMenu]) {
                   lunchFee = p.lunchCount * (Number(competition.lunches[p.selectedMenu].price) || 0);
                   menuName = `${p.selectedMenu}. menü (${competition.lunches[p.selectedMenu].name})`;
                } else {
                   lunchFee = p.lunchCount * (Number(competition?.lunchPrice) || 0);
                }
              }

              return (
                <div key={`${p.id}-${idx}`} style={paymentItemStyle}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 'bold' }}>{p.fullName}</div>
                    <div style={{ fontSize: '0.7rem', color: '#888' }}>
                      {translationMap[p.bowCategory] || p.bowCategory} | {translationMap[p.ageCategory] || p.ageCategory}
                    </div>
                  </div>
                  <div style={{ textAlign: 'right', minWidth: '180px', display: 'flex', alignItems: 'center', gap: '15px', justifyContent: 'flex-end' }}>
                    <div>
                      <div style={{ fontSize: '0.85rem' }}>Nev.: {entryFee.toLocaleString()} Ft</div>
                      {p.lunchCount > 0 && (
                        <div style={{ fontSize: '0.75rem', color: '#f58231' }}>{menuName} ({p.lunchCount}db): {lunchFee.toLocaleString()} Ft</div>
                      )}
                    </div>
                    {/* ELTÁVOLÍTÁS GOMB SORONKÉNT */}
                    <button
                      onClick={() => handleToggleRegistration(p.id)}
                      style={{
                        background: 'none', border: 'none', color: '#ccc',
                        cursor: 'pointer', display: 'flex', padding: '5px'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.color = '#b30000'}
                      onMouseLeave={(e) => e.currentTarget.style.color = '#ccc'}
                      title="Eltávolítás a listából"
                    >
                      <FiX size={16} />
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          <div style={{ textAlign: 'right', marginBottom: '20px' }}>
            <span style={{ fontSize: '0.9rem', color: '#666', marginRight: '10px' }}>ÖSSZESEN:</span>
            <span style={{ fontSize: '1.5rem', fontWeight: '900', color: '#28a745' }}>
              {paymentGroup.reduce((sum, p) => {
                const entry = Number(competition?.ageFees?.[p.ageCategory]) || Number(p.entryFee) || 0;
                let currentLunchFee = 0;
                if (p.lunchCount > 0) {
                  if (p.lunchSelections) {
                    Object.entries(p.lunchSelections).forEach(([key, amount]) => {
                      const price = Number(competition?.lunches?.[key]?.price) ||
                                    (key === 'A' ? (Number(competition?.lunchPrice) || 0) : 0);
                      currentLunchFee += amount * price;
                    });
                  } else {
                    const menuKey = p.selectedMenu || 'A';
                    const price = Number(competition?.lunches?.[menuKey]?.price) || Number(competition?.lunchPrice) || 0;
                    currentLunchFee = p.lunchCount * price;
                  }
                }
                return sum + entry + currentLunchFee;
              }, 0).toLocaleString()} Ft
            </span>
          </div>

          <div style={{ display: 'flex', gap: '15px' }}>
            <button
              style={{ ...modalCancelButtonStyle, flex: 1, padding: '10px' }}
              onClick={handleCancelPayment}
            >
              Mégse
            </button>
            <button
              style={{ ...modalDeleteButtonStyle, flex: 2, padding: '10px', backgroundColor: '#b30000' }}
              onClick={handlePaidPayment}
            >
              Fizetve
            </button>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes pulse-sync {
          0% { opacity: 1; }
          50% { opacity: 0.6; }
          100% { opacity: 1; }
        }
        @keyframes pulse-warning-error {
          0% { transform: scale(1); box-shadow: 0 0 0px transparent; }
          50% { transform: scale(1.15); box-shadow: 0 0 15px rgba(220, 53, 69, 0.4); background-color: rgba(220, 53, 69, 0.2); }
          100% { transform: scale(1); box-shadow: 0 0 0px transparent; }
        }
        @keyframes quick-slide-down {
          from { transform: translate(-50%, -100%); opacity: 0; }
          to { transform: translate(-50%, 0); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

// --- STÍLUSOK ---

const pageContainerStyle = {
  display: 'flex',
  height: 'calc(100vh - 64px)',
  backgroundColor: '#f4f6f8',
  fontFamily: 'Arial, sans-serif',
  position: 'relative', // ÚJ: Szükséges a fix oldalsávhoz
  overflow: 'hidden'
};

const sidebarStyle = (isOpen) => ({
  width: '240px',
  position: 'fixed',
  top: '64px',
  bottom: 0,
  left: 0,
  backgroundColor: '#ffffff',
  borderRight: '1px solid #e0e4e8',
  display: 'flex',
  flexDirection: 'column',
  padding: '15px',
  zIndex: 1001,
  transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',
  transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  boxShadow: isOpen ? '10px 0 25px rgba(0,0,0,0.1)' : 'none'
});

const sidebarHeaderStyle = {
  marginBottom: '30px',
  borderBottom: '1px solid #eee',
  paddingBottom: '20px'
};

const backButtonStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  background: 'none',
  border: 'none',
  color: '#666',
  cursor: 'pointer',
  fontSize: '14px',
  marginBottom: '15px',
  padding: 0
};

const sidebarTitleStyle = {
  margin: '0 0 10px 0',
  fontSize: '1.2rem',
  color: '#333',
  fontWeight: 'bold'
};

const statusBadgeStyle = {
  backgroundColor: '#e6fffa',
  color: '#2c7a7b',
  padding: '4px 12px',
  borderRadius: '20px',
  fontSize: '12px',
  fontWeight: 'bold'
};

const navStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '5px'
};

const tabButtonStyle = (isActive) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '10px 15px',
  border: 'none',
  borderRadius: '8px',
  backgroundColor: isActive ? '#fbeaea' : 'transparent',
  color: isActive ? '#b30000' : '#555',
  fontWeight: isActive ? 'bold' : 'normal',
  textAlign: 'left',
  cursor: 'pointer',
  transition: '0.2s',
  fontSize: '14px',
  whiteSpace: 'pre-line',
  lineHeight: '1.2'
});

const iconStyle = {
  fontSize: '18px',
  display: 'flex'
};

const contentStyle = {
  flex: 1,
  padding: '20px 15px',
  overflowY: 'auto',
  width: '100%', // ÚJ: Teljes szélesség
  marginLeft: 0, // Alapból nincs margó
  transition: 'padding 0.3s ease'
};

const headerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '25px'
};

const headerStatsStyle = {
  display: 'flex',
  gap: '20px',
  color: '#666'
};

const mainCardStyle = {
  backgroundColor: '#fff',
  borderRadius: '12px',
  padding: '25px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
  minHeight: '400px'
};

const actionBarStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '20px',
  gap: '20px'
};

const searchContainerStyle = {
  position: 'relative',
  flex: 1,
  maxWidth: '400px'
};

const searchIconStyle = {
  position: 'absolute',
  left: '12px',
  top: '50%',
  transform: 'translateY(-50%)',
  color: '#888'
};

const formInputStyle = {
  width: '100%',
  padding: '10px 12px',
  borderRadius: '8px',
  border: '1px solid #ddd',
  fontSize: '14px',
  outline: 'none',
  boxSizing: 'border-box'
};

const searchInputStyle = {
  ...formInputStyle,
  paddingLeft: '40px'
};

const exportButtonStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '10px 15px',
  backgroundColor: '#fafafa',
  border: '1px solid #ddd',
  borderRadius: '8px',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: 'bold',
  color: '#333'
};

const qrButtonStyle = {
  ...exportButtonStyle,
  backgroundColor: '#b30000',
  color: 'white',
  border: '1px solid #b30000'
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  marginTop: '10px'
};

const thStyle = {
  textAlign: 'left',
  padding: '12px 8px',
  borderBottom: '2px solid #eee',
  color: '#666',
  fontSize: '14px',
  fontWeight: 'bold'
};

const tdStyle = {
  padding: '12px 8px',
  borderBottom: '1px solid #eee',
  fontSize: '14px'
};

const trStyle = {
  transition: '0.1s',
  ':hover': {
    backgroundColor: '#f9fafb'
  }
};

const emptyTdStyle = {
  padding: '40px',
  textAlign: 'center',
  color: '#888',
  fontStyle: 'italic'
};

const commentIconStyle = {
  cursor: 'help',
  fontSize: '1.2rem'
};

const deleteButtonStyle = {
  background: 'none',
  border: 'none',
  color: '#b30000',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '5px',
  borderRadius: '4px',
  transition: '0.2s'
};

const participantStatusStyle = (status) => ({
  backgroundColor: status === 'Megérkezett' ? '#e6fffa' : '#f7fafc',
  color: status === 'Megérkezett' ? '#2c7a7b' : '#4a5568',
  padding: '2px 8px',
  borderRadius: '10px',
  fontSize: '12px',
  fontWeight: 'bold'
});

const infoGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
  gap: '20px'
};

const infoCardStyle = {
  padding: '20px',
  borderRadius: '10px',
  border: '1px solid #eee',
  backgroundColor: '#fafafa'
};

const placeholderStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '300px',
  textAlign: 'center'
};

const loadingContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh'
};

const spinnerStyle = {
  width: '40px',
  height: '40px',
  border: '4px solid #f3f3f3',
  borderTop: '#b30000 4px solid',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
  marginBottom: '15px'
};

// --- MODAL STÍLUSOK ---

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 2000,
  backdropFilter: 'blur(3px)'
};

const modalContentStyle = {
  backgroundColor: 'white',
  padding: '30px',
  borderRadius: '15px',
  textAlign: 'center',
  maxWidth: '400px',
  width: '95%',
  boxShadow: '0 15px 35px rgba(0,0,0,0.3)',
  boxSizing: 'border-box',
  maxHeight: '90vh',
  overflowY: 'auto'
};

const modalDeleteButtonStyle = {
  backgroundColor: '#b30000',
  color: 'white',
  border: 'none',
  padding: '12px 24px',
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const modalCancelButtonStyle = {
  backgroundColor: '#eee',
  color: '#333',
  border: 'none',
  padding: '12px 24px',
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

// --- CSAPATBEOSZTÁS STÍLUSOK ---

const teamsGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
  gap: '20px',
  padding: '10px'
};

const teamBoxStyle = {
  backgroundColor: '#f8f9fa',
  border: '1px solid #dee2e6',
  borderRadius: '10px',
  display: 'flex',
  flexDirection: 'column',
  minHeight: '200px',
  overflow: 'hidden'
};

const teamHeaderStyle = {
  backgroundColor: '#fff',
  padding: '10px 15px',
  borderBottom: '1px solid #eee',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontWeight: 'bold',
  fontSize: '0.9rem',
  color: '#333'
};

const teamCountStyle = {
  fontSize: '0.8rem',
  color: '#888',
  fontWeight: 'normal'
};

const teamBodyStyle = {
  padding: '10px',
  flex: 1,
  minHeight: '100px'
};

const emptyTeamTextStyle = {
  color: '#ccc',
  fontSize: '0.8rem',
  textAlign: 'center',
  marginTop: '20px',
  fontStyle: 'italic'
};

const catBadgeStyle = {
  backgroundColor: '#fbeaea',
  padding: '2px 6px',
  borderRadius: '4px',
  fontSize: '0.7rem',
  fontWeight: 'bold',
  color: '#000', // Fekete betűk
  border: '0.5px solid #000'
};

const teamCardCommentStyle = {
  fontSize: '0.7rem',
  color: '#b30000',
  fontStyle: 'italic',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  borderTop: '1px solid #f0f0f0',
  paddingTop: '4px',
  marginTop: '2px'
};

const resultGroupTitleStyle = {
  margin: '0 0 20px 0',
  paddingBottom: '10px',
  borderBottom: '2px solid #b30000',
  color: '#b30000',
  fontSize: '1.2rem',
  fontWeight: 'bold'
};

const resultsGridStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  padding: '10px'
};

// --- QR MODAL STÍLUSOK ---

const qrModalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: '#fff',
  zIndex: 3000,
  overflowY: 'auto',
  padding: '40px'
};

const qrModalContentStyle = {
  maxWidth: '1000px',
  margin: '0 auto',
  backgroundColor: '#fff'
};

const qrModalHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '40px',
  paddingBottom: '20px',
  borderBottom: '1px solid #eee'
};

const printButtonStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '10px 20px',
  backgroundColor: '#b30000',
  color: '#fff',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  fontWeight: 'bold'
};

const closeButtonStyle = {
  ...printButtonStyle,
  backgroundColor: '#6c757d'
};

const qrGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)', // JAVÍTÁS: Mindig 4 oszlop a képernyőn
  gap: '15px'
};

const qrCardStyle = {
  border: '1px solid #ddd',
  borderRadius: '8px',
  padding: '10px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '15px',
  backgroundColor: '#fff',
  width: '100%',
  boxSizing: 'border-box',
  minHeight: '100px'
};

const qrCardInfoStyle = {
  textAlign: 'left',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  flex: 1,
  overflow: 'hidden'
};

const qrCardNameStyle = {
  fontSize: '1rem',
  fontWeight: 'bold',
  lineHeight: '1.2',
  display: '-webkit-box',
  WebkitLineClamp: '2',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

// --- CSAPAT NYOMTATÁS STÍLUSOK ---

const teamPrintCardStyle = {
  border: '1px solid #eee',
  borderRadius: '8px',
  padding: '15px',
  backgroundColor: '#fff'
};

const teamPrintHeaderStyle = {
  margin: '0 0 10px 0',
  paddingBottom: '5px',
  borderBottom: '2px solid #333',
  fontSize: '1.1rem'
};

const teamPrintTableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  tableLayout: 'fixed' // ÚJ: Fix szélességű oszlopok kényszerítése
};

const teamPrintThStyle = {
  textAlign: 'left',
  fontSize: '0.8rem',
  color: '#666',
  paddingBottom: '5px'
};

const teamPrintTdStyle = {
  padding: '5px 8px 5px 0',
  fontSize: '0.9rem',
  borderBottom: '1px solid #f0f0f0',
  textAlign: 'left',
  verticalAlign: 'top'
};

const formGridStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '15px'
};

const inputGroupStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '5px'
};

const labelStyle = {
  fontSize: '0.85rem',
  fontWeight: 'bold',
  color: '#555'
};

const selectStyle = {
  ...formInputStyle
};

const profileRegCardStyle = {
  backgroundColor: '#f8f9fa',
  padding: '15px',
  borderRadius: '10px',
  border: '1px solid #eee',
  marginBottom: '15px'
};

const regCardStyle = (isRegistered, isClosed = false) => {
  const isMissing = !isRegistered && isClosed;
  return {
    padding: '12px 15px',
    borderRadius: '10px',
    backgroundColor: isRegistered ? '#28a745' : (isMissing ? '#dc3545' : '#fff'),
    color: (isRegistered || isMissing) ? '#fff' : '#333',
    border: isRegistered ? '1px solid #218838' : (isMissing ? '1px solid #c82333' : '1px solid #eee'),
    cursor: isClosed ? 'default' : 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: (isRegistered || isMissing) ? 'none' : '0 2px 4px rgba(0,0,0,0.05)',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  };
};

const statWidgetStyle = {
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '12px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  border: '1px solid #eee'
};

const statLabelStyle = {
  fontSize: '0.85rem',
  color: '#888',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  marginBottom: '5px'
};

const statValueStyle = {
  fontSize: '1.8rem',
  fontWeight: 'bold',
  color: '#333'
};

const statSubLabelStyle = {
  fontSize: '0.8rem',
  color: '#666',
  marginTop: '5px'
};

const autocompleteContainerStyle = {
  position: 'absolute',
  top: '100%',
  left: 0,
  right: 0,
  backgroundColor: 'white',
  border: '1px solid #ddd',
  borderRadius: '8px',
  boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
  zIndex: 100,
  maxHeight: '200px',
  overflowY: 'auto'
};

const autocompleteItemStyle = {
  padding: '10px 15px',
  cursor: 'pointer',
  borderBottom: '1px solid #eee',
  fontSize: '0.9rem',
  color: '#333',
  textAlign: 'left'
};

const quickPaymentPanelStyle = {
  position: 'fixed',
  top: '64px',
  left: '50%',
  transform: 'translateX(-50%)',
  width: '500px',
  maxWidth: '95vw',
  backgroundColor: 'white',
  borderRadius: '0 0 15px 15px',
  boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
  zIndex: 999,
  padding: '20px',
  border: '1px solid #eee',
  borderTop: 'none',
  animation: 'quick-slide-down 0.4s ease-out'
};

const paymentListStyle = {
  maxHeight: '200px',
  overflowY: 'auto',
  marginBottom: '15px',
  borderBottom: '1px solid #eee'
};

const paymentItemStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 0',
  borderBottom: '1px dashed #f0f0f0',
  fontSize: '0.9rem'
};

export default CompetitionOffice;



